// AUTO-GENERATED. Regenerate via /home/user/workspace/build_modules.py
// PDF-faithful: content is extracted only from the source PDF text files in
// /home/user/workspace/. No prose has been invented. Where extraction was not
// confident, items are omitted or flagged via `needsReview` / `reviewFlags`.
import type { ChapterModule } from "./types";

export const GENERATED_MODULES: Record<string, ChapterModule> = {
  "01": {
    "meta": {
      "id": "01",
      "number": 1,
      "title": "Definition and Characteristics of Applied Behavior Analysis",
      "subtitle": "Goals of science, attitudes, history, dimensions, definition, domains",
      "part": "Part 1 - Introduction and Basic Concepts",
      "bacb": []
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [],
    "coreConcepts": [
      {
        "title": "Science: Basic Characteristics and a Definition",
        "body": [
          "Different types of scientific investigations yield knowledge that enables the description, prediction, and/or control of the phenomena studied."
        ],
        "bullets": [
          "Descriptive studies yield a collection of facts about the observed events that can be quantified, classified, and examined for possible relations with other known facts.",
          "Knowledge gained from a study that finds the systematic covariation between two events-termed a correlationcan be used to predict the probability that one event will occur based on the occurrence of the other event.",
          "Results of experiments that show that specific manipulations of one event (the independent variable) produce a reliable change in another event (the dependent variable), and that the change in the dependent variable was unlikely the result of extraneous factors (confounding variables)-a fi nding known as a functional relation-can be used to control the phenomena under investigation."
        ]
      },
      {
        "title": "A Brief History of Behavior Analysis",
        "body": [
          "Behavior analysis consists of three major branches: behaviorism, the experimental analysis of behavior (EAB), and applied behavior analysis (ABA)."
        ],
        "bullets": [
          "Watson espoused an early form of behaviorism known as stimulus-response (S-R) psychology, which did not account for behavior without obvious antecedent causes.",
          "Skinner founded the experimental analysis of behavior (EAB), a natural science approach for discovering orderly and reliable relations between behavior and the environmental variables of which it is a function. lawful and orderly place in which phenomena occur as a",
          "EAB is characterized by these methodological features: result of other events. • Rate of response is the most common dependent variable. ena of interest. • Repeated or continuous measurement is made of carefully defined response classes. • Within-subject experimental comparisons are used instead of designs comparing the behavior of experimental and control groups. 24 Part I • Introduction and Basic Concepts • The visual analysis of graphed data is preferred over statistical inference. • A description of functional relations is valued over formal theory testing.",
          "Through thousands of laboratory experiments, Skinner and his colleagues and students discovered and verified the basic principles of operant behavior that provide the empirical foundation for behavior analysis today."
        ]
      },
      {
        "title": "Characteristics of Applied Behavior Analysis",
        "body": [
          "ABA offers society an approach toward solving many of its problems that is accountable, public, doable, empowering, and optimistic."
        ],
        "bullets": []
      },
      {
        "title": "A Definition of Applied Behavior Analysis",
        "body": [
          "Applied behavior analysis is the science in which tactics derived from the principles of behavior are applied systematically to improve socially significant behavior and experimentation is used to identify the variables responsible for behavior change."
        ],
        "bullets": [
          "Behavior analysts work in one or more of four interrelated domains: behaviorism (theoretical and philosophical issues), the experimental analysis of behavior (basic research), applied behavior analysis (applied research), and professional practice (providing behavior analytic services to consumers).",
          "ABA's natural science approach to discovering environmental variables that reliably influence socially significant behavior and developing a technology to take practical advantage of those discoveries offers humankind its best hope for solving many of its problems. improved human performance and the quality of participants' lives across a wide range of areas, but no problem has been solved completely, and many important problems, challenges, and opportunities remain."
        ]
      }
    ],
    "glossary": [
      {
        "term": "explanatory ficti o n",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "pa rsimo ny",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "behaviorism",
        "definition": "The key point of behaviorism is that what people do can be understood .",
        "sourceHint": "The key point of behaviorism is that what people do can be understood ."
      },
      {
        "term": "functio na l analysis",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "p hilosop hic d o ubt",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "determinism",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "function a l re latio n",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "p rag matism",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "empiricism",
        "definition": "As it is in every scientific field, empiricism is the foremost analysis of behavior from other methods of investigarule in behavior analysis.",
        "sourceHint": "As it is in every scientific field, empiricism is the foremost analysis of behavior from other methods of investigarule in behavior analysis."
      },
      {
        "term": "hypothetical construct",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "rad ical behavio rism",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "e xperiment",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "menta lism",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "rep Iicatio n",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "methodological behaviorism",
        "definition": "Methodological behaviorism is a philosophical position that considers behavioral events that cannot be publicly observed to be outside the realm of the science.",
        "sourceHint": "Methodological behaviorism is a philosophical position that considers behavioral events that cannot be publicly observed to be outside the realm of the science."
      },
      {
        "term": "science",
        "definition": "\"Science is a willingness to accept facts even when they are opposed to wishes\" (Skinner, 1953, p.",
        "sourceHint": "\"Science is a willingness to accept facts even when they are opposed to wishes\" (Skinner, 1953, p."
      },
      {
        "term": "entific methods-objective description, measurement, and",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "experimen tation-to demonstrate reliable relations",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "scientists is also characterized by qualities such as thoroughness, curiosity, perseverance, diligence, ethics, and honesty.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "scientists is also characterized by qualities such as thoroughness, curiosity, perseverance, diligence, ethics, and honesty."
      },
      {
        "scenario": "Compared to reflexive behavior with its clear eliciting events, much of the behavior of organisms appeared spontaneous or \"voluntary.\" In tary\" behavior, other psychologists postulated mediating variables inside the organism in the form of hypothetical constructs such as cognitive processes, drives, and free will.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Compared to reflexive behavior with its clear eliciting events, much of the behavior of organisms appeared spontaneous or \"voluntary.\" In tary\" behavior, other psychologists postulated mediating variables inside the organism in the form of hypothetical constructs such as cognitive processes, drives, and free will."
      },
      {
        "scenario": "This was followed by his classic text, Science and Human Behavior (1953), in which he speculated on how the principles of behavior might be applied to complex human behavior in areas such as education, religion, government, law, and psychotherapy.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "This was followed by his classic text, Science and Human Behavior (1953), in which he speculated on how the principles of behavior might be applied to complex human behavior in areas such as education, religion, government, law, and psychotherapy."
      },
      {
        "scenario": "Freud, for example, created a complex mental world of hypothetical constructs-the id, ego, and superego-that he contended were key to understanding a person's actions.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Freud, for example, created a complex mental world of hypothetical constructs-the id, ego, and superego-that he contended were key to understanding a person's actions."
      }
    ],
    "comparisons": [
      {
        "title": "Distinction drawn in the source",
        "left": {
          "label": "First framing",
          "points": [
            "Mentalism is an approach to understanding behavior that assumes that a mental, or \"inner,\" dimension exists that."
          ]
        },
        "right": {
          "label": "Contrast",
          "points": [
            "a behavioral dimension and that phenomena in this dimension either directly cause or at least mediate some forms of behavior; it relies on hypothetical constructs and explanatory fictions."
          ]
        },
        "sourceHint": "Mentalism is an approach to understanding behavior that assumes that a mental, or \"inner,\" dimension exists that differs from a behavioral dimension and that phenomena in this dimension either directly cause or at least mediate some forms of behavior; it relies on hypothetical constructs and explanatory fictions."
      }
    ],
    "misconceptions": [],
    "examChecklist": [
      "Define \"behaviorism\" from memory and match the source text.",
      "Define \"empiricism\" from memory and match the source text.",
      "Define \"methodological behaviorism\" from memory and match the source text.",
      "Define \"science\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"The key point of behaviorism is that what people do can be understood .\"",
        "options": [
          {
            "label": "A",
            "text": "behaviorism"
          },
          {
            "label": "B",
            "text": "empiricism"
          },
          {
            "label": "C",
            "text": "methodological behaviorism"
          },
          {
            "label": "D",
            "text": "science"
          }
        ],
        "answer": "A",
        "explanation": "\"The key point of behaviorism is that what people do can be understood .\" is the chapter's own definition of behaviorism.",
        "topic": "Key terms",
        "sourceHint": "The key point of behaviorism is that what people do can be understood ."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"As it is in every scientific field, empiricism is the foremost analysis of behavior from other methods of investigarule in behavior analysis.\"",
        "options": [
          {
            "label": "A",
            "text": "behaviorism"
          },
          {
            "label": "B",
            "text": "methodological behaviorism"
          },
          {
            "label": "C",
            "text": "science"
          },
          {
            "label": "D",
            "text": "empiricism"
          }
        ],
        "answer": "D",
        "explanation": "\"As it is in every scientific field, empiricism is the foremost analysis of behavior from other methods of investigarule in behavior analysis.\" is the chapter's own definition of empiricism.",
        "topic": "Key terms",
        "sourceHint": "As it is in every scientific field, empiricism is the foremost analysis of behavior from other methods of investigarule in behavior analysis."
      },
      {
        "id": "Q3",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Methodological behaviorism is a philosophical position that considers behavioral events that cannot be publicly observed to be outside the realm of the science.\"",
        "options": [
          {
            "label": "A",
            "text": "empiricism"
          },
          {
            "label": "B",
            "text": "science"
          },
          {
            "label": "C",
            "text": "methodological behaviorism"
          },
          {
            "label": "D",
            "text": "behaviorism"
          }
        ],
        "answer": "C",
        "explanation": "\"Methodological behaviorism is a philosophical position that considers behavioral events that cannot be publicly observed to be outside the realm of the science.\" is the chapter's own definition of methodological behaviorism.",
        "topic": "Key terms",
        "sourceHint": "Methodological behaviorism is a philosophical position that considers behavioral events that cannot be publicly observed to be outside the realm of the science."
      },
      {
        "id": "Q4",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"\"Science is a willingness to accept facts even when they are opposed to wishes\" (Skinner, 1953, p.\"",
        "options": [
          {
            "label": "A",
            "text": "methodological behaviorism"
          },
          {
            "label": "B",
            "text": "science"
          },
          {
            "label": "C",
            "text": "behaviorism"
          },
          {
            "label": "D",
            "text": "empiricism"
          }
        ],
        "answer": "B",
        "explanation": "\"\"Science is a willingness to accept facts even when they are opposed to wishes\" (Skinner, 1953, p.\" is the chapter's own definition of science.",
        "topic": "Key terms",
        "sourceHint": "\"Science is a willingness to accept facts even when they are opposed to wishes\" (Skinner, 1953, p."
      }
    ],
    "reviewPrompts": [
      "Define \"behaviorism\" in your own words, then check against the chapter glossary.",
      "Define \"empiricism\" in your own words, then check against the chapter glossary.",
      "Define \"methodological behaviorism\" in your own words, then check against the chapter glossary.",
      "Define \"science\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"Different types of scientific investigations yield knowledge that enables the description, prediction, and/or control of the phenomena studied..\"",
      "Restate this idea from the chapter in your own words: \"Descriptive studies yield a collection of facts about the observed events that can be quantified, classified, and examined for possible relations with other known facts..\"",
      "What is the single most important takeaway from \"Definition and Characteristics of Applied Behavior Analysis\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "ABA's natural science approach to discovering environmental variables that reliably influence socially significant behavior and developing a technology to take practical advantage of those discoveries offers humankind its best hope for solving many of its problems."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "misconceptions": true
    }
  },
  "02": {
    "meta": {
      "id": "02",
      "number": 2,
      "title": "Basic Concepts and Principles",
      "subtitle": "Behavior, response classes, respondent vs operant, 3-term contingency",
      "part": "Part 1 - Introduction and Basic Concepts",
      "bacb": []
    },
    "overview": [
      "One must understand how the organism is modified by its interactions with the environment, how new environmentof Behavioral Research, third edition, these authors define behavior as follows: behavior relations are learned and unlearned. Behavior is that portion of an organism's interaction with -Jack L. Michael (2004, p. 1) its environment that involves movement of some part of the organism (2009, p. 31). Johnston and Pennypacker discuss each part of this defi-",
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [],
    "coreConcepts": [
      {
        "title": "Behavior",
        "body": [
          "Behavior is the activity of living organisms."
        ],
        "bullets": [
          "Technically, behavior is \"that portion of an organism's interaction with its environment that involves movement of some part of the organism\" (Johnston & Pennypacker, 2009, p. 31).",
          "The term behavior is usually used in reference to a larger set or class of responses that share certain topographical dimensions or functions.",
          "Response refers to a specific instance of behavior.",
          "Response topography refers to the physical shape or form of behavior."
        ]
      },
      {
        "title": "En vironment",
        "body": [
          "Environment is the physical setting and circumstances in which the organism or referenced part of the organism exists."
        ],
        "bullets": [
          "Stimulus is \"an energy change that affects an organism through its receptor cells\" (Michael, 2004, p. 7).",
          "A stimulus class is a group of stimuli that share specified common elements along formal, temporal, and/or functional dimensions.",
          "Antecedent conditions or stimulus changes exist or occur prior to the behavior of interest.",
          "Consequences are stimulus changes that follow a behavior of interest."
        ]
      },
      {
        "title": "Respondent Behavior",
        "body": [
          "A reflex is a stimulus-response relation consisting of an antecedent stimulus and the respondent behavior it elicits (e.g., bright light-pupil contraction)."
        ],
        "bullets": [
          "All healthy members of a given species are born with the same repertoire of unconditioned reflexes.",
          "An unconditioned stimulus (e.g., food) and the respondent behavior it elicits (e.g., salivation) are called unconditioned reflexes."
        ]
      },
      {
        "title": "Operant Behavior",
        "body": [
          "Positive reinforcement: A response is followed by the presentation of a stimulus that results in similar responses occurring more often."
        ],
        "bullets": [
          "Negative reinforcement: A response is foll owed by the withdrawal of a stimulus that results in similar responses occurring more often.",
          "The term aversive stimulus is often used to refer to stimulus conditions whose termination functions as reinforcement.",
          "Extinction (withholding all reinforcement for a previously reinforced behavior) produces a decrease in response rate to the behavior's pre-reinforcement level.",
          "Positive punishment: A response is followed by the presentation of a stimulus that results in similar responses occurring less often."
        ]
      },
      {
        "title": "Recognizing the Complexity of Human Behavior",
        "body": [
          "Humans are capable of acquiring a huge repertoire of behaviors. Response chains and verbal behavior also make human behavior extremely complex."
        ],
        "bullets": [
          "The variables that govern human behavior are often highly complex. Many behaviors have multiple causes. organic impairments also make the analysis and control of human behavior difficult.",
          "Applied behavior analysts are sometimes prevented from conducting an effective analysis of behavior because of practical, logistical, financial, sociopolitical, legal, and/or ethical reasons."
        ]
      }
    ],
    "glossary": [
      {
        "term": "antecedent",
        "definition": "The term antecedent refers to environmental conditions or stimulus changes that exist or occur prior to the behavior of interest.",
        "sourceHint": "The term antecedent refers to environmental conditions or stimulus changes that exist or occur prior to the behavior of interest."
      },
      {
        "term": "habituation",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "reinforcer",
        "definition": "The words can and often in the two previous sentences recognize the important qualification that the momentary effectiveness of an unconditioned reinforcer is a function of current motivating operations.",
        "sourceHint": "The words can and often in the two previous sentences recognize the important qualification that the momentary effectiveness of an unconditioned reinforcer is a function of current motivating operations."
      },
      {
        "term": "automatic re inforcement",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "higher-order cond itioni ng",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "repertoire",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "automaticity of reinforcement",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "history of reinforcement",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "respondent behavior",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "aversive stimulus",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "joint contro l",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "respondent conditioning",
        "definition": "NS + US UR (eye blink) The product of respondent conditioning is a conditioned reflex (CR): In this case the clicking sound has become a conditioned stimulus (CS) that elicits an eye blink when presented alone.",
        "sourceHint": "NS + US UR (eye blink) The product of respondent conditioning is a conditioned reflex (CR): In this case the clicking sound has become a conditioned stimulus (CS) that elicits an eye blink when presented alone."
      },
      {
        "term": "behavior",
        "definition": "Behavior is that portion of an organism's interaction with -Jack L.",
        "sourceHint": "Behavior is that portion of an organism's interaction with -Jack L."
      },
      {
        "term": "motivating operation",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "respondent extinction",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "behavior change tactic",
        "definition": "A behavior change tactic is a technologically consistent method for changing behavior that has been derived from one or more basic principles of behavior.",
        "sourceHint": "A behavior change tactic is a technologically consistent method for changing behavior that has been derived from one or more basic principles of behavior."
      },
      {
        "term": "negative punishment",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "response",
        "definition": "A technical definition of response is an \"action of an organism's effector.",
        "sourceHint": "A technical definition of response is an \"action of an organism's effector."
      },
      {
        "term": "conditioned punisher",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "negative reinforcement",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "response class",
        "definition": "A response class is a group of responses with the same function (that is, each response in the group produces the same effect on the environment).",
        "sourceHint": "A response class is a group of responses with the same function (that is, each response in the group produces the same effect on the environment)."
      },
      {
        "term": "conditioned reflex",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "neutral stimulus",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "ru le-governed behavior",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "conditioned reinforcer",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "ontogeny",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "selection ism",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "conditioned stimulus",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "operant behavior",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "social ly mediated contingency",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "consequence",
        "definition": "A consequence is a stimulus change that follows a behavior of interest.",
        "sourceHint": "A consequence is a stimulus change that follows a behavior of interest."
      },
      {
        "term": "operant conditioning",
        "definition": "[Ultimately, of course, it is all a matter of natural selection, since operant conditioning is an evolved process, of which cultural practices are special applications.] Skinner's discovery and subsequent elucidation of operant selection by consequences have rightly been called \"revolutionary\" and \"the bedrock on which other behavioral principles rest\" (Glenn, 2004, p.",
        "sourceHint": "[Ultimately, of course, it is all a matter of natural selection, since operant conditioning is an evolved process, of which cultural practices are special applications.] Skinner's discovery and subsequent elucidation of operant selection by consequences have rightly been called \"revolutionary\" and \"the bedrock on which other behavioral principles rest\" (Glenn, 2004, p."
      },
      {
        "term": "stimu lus",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "contingency",
        "definition": "The three-term contingency-a concept for expressing temporal and functional relations between operant behavior and environment-and its importance as a focal point in applied behavior analysis are then organism, whether real or hypothetical, are not behavexplained.",
        "sourceHint": "The three-term contingency-a concept for expressing temporal and functional relations between operant behavior and environment-and its importance as a focal point in applied behavior analysis are then organism, whether real or hypothetical, are not behavexplained."
      },
      {
        "term": "phylogeny",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "stimu lus class",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "contingency-shaped behavior",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "positive punishment",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "stimu lus control",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "contingent",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "positive reinforcement",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "stimu lus-stimulus pairing",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "deprivation",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "principle of behavior",
        "definition": "A principle of behavior is an empirical generalization inferred from many experiments.",
        "sourceHint": "A principle of behavior is an empirical generalization inferred from many experiments."
      },
      {
        "term": "three-term contingency",
        "definition": "The three-term contingency-a concept for expressing temporal and functional relations between operant behavior and environment-and its importance as a focal point in applied behavior analysis are then organism, whether real or hypothetical, are not behavexplained.",
        "sourceHint": "The three-term contingency-a concept for expressing temporal and functional relations between operant behavior and environment-and its importance as a focal point in applied behavior analysis are then organism, whether real or hypothetical, are not behavexplained."
      },
      {
        "term": "discriminated operant",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "pun isher",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "unconditioned punisher",
        "definition": "Similarly, an unconditioned punisher is a stimulus change that can decrease the future occurrence of any behavior that precedes it without prior pairing with any other form of punishment.",
        "sourceHint": "Similarly, an unconditioned punisher is a stimulus change that can decrease the future occurrence of any behavior that precedes it without prior pairing with any other form of punishment."
      },
      {
        "term": "punishment",
        "definition": "To cite another example, punishment is a principle of behavior because it describes the established functional relation between the presentation of a consequence and the decreased occurrence of similar behavior in the future.",
        "sourceHint": "To cite another example, punishment is a principle of behavior because it describes the established functional relation between the presentation of a consequence and the decreased occurrence of similar behavior in the future."
      },
      {
        "term": "unconditioned reinforcer",
        "definition": "The words can and often in the two previous sentences recognize the important qualification that the momentary effectiveness of an unconditioned reinforcer is a function of current motivating operations.",
        "sourceHint": "The words can and often in the two previous sentences recognize the important qualification that the momentary effectiveness of an unconditioned reinforcer is a function of current motivating operations."
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "Although words such as activity and movement communicate the general notion of behavior, a more precise definition is needed for scientific purposes.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Although words such as activity and movement communicate the general notion of behavior, a more precise definition is needed for scientific purposes."
      },
      {
        "scenario": "The phrase of an organism restricts the subject matter to the activity of living organisms, leaving notions such as the \"behavior\" of the stock market outside the realm of the scientific use of the term.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "The phrase of an organism restricts the subject matter to the activity of living organisms, leaving notions such as the \"behavior\" of the stock market outside the realm of the scientific use of the term."
      },
      {
        "scenario": "For example, each of us has a repertoire of behaviors appropriate for informal social situations that differs somewhat (or a lot) from the behaviors we use to navigate formal situations.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, each of us has a repertoire of behaviors appropriate for informal social situations that differs somewhat (or a lot) from the behaviors we use to navigate formal situations."
      },
      {
        "scenario": "Formal Dimensions of St imuli Behavior analysts often describe, measure, and manipulate stimuli according to their formal dimensions, such as size, color, intensity, weight, and spatial position relative to other objects.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Formal Dimensions of St imuli Behavior analysts often describe, measure, and manipulate stimuli according to their formal dimensions, such as size, color, intensity, weight, and spatial position relative to other objects."
      }
    ],
    "comparisons": [],
    "misconceptions": [],
    "examChecklist": [
      "Define \"antecedent\" from memory and match the source text.",
      "Define \"reinforcer\" from memory and match the source text.",
      "Define \"respondent conditioning\" from memory and match the source text.",
      "Define \"behavior\" from memory and match the source text.",
      "Define \"behavior change tactic\" from memory and match the source text.",
      "Define \"response\" from memory and match the source text.",
      "Define \"response class\" from memory and match the source text.",
      "Define \"consequence\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"The term antecedent refers to environmental conditions or stimulus changes that exist or occur prior to the behavior of interest.\"",
        "options": [
          {
            "label": "A",
            "text": "antecedent"
          },
          {
            "label": "B",
            "text": "reinforcer"
          },
          {
            "label": "C",
            "text": "respondent conditioning"
          },
          {
            "label": "D",
            "text": "behavior"
          }
        ],
        "answer": "A",
        "explanation": "\"The term antecedent refers to environmental conditions or stimulus changes that exist or occur prior to the behavior of interest.\" is the chapter's own definition of antecedent.",
        "topic": "Key terms",
        "sourceHint": "The term antecedent refers to environmental conditions or stimulus changes that exist or occur prior to the behavior of interest."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"The words can and often in the two previous sentences recognize the important qualification that the momentary effectiveness of an unconditioned reinforcer is a function of current motivating operations.\"",
        "options": [
          {
            "label": "A",
            "text": "antecedent"
          },
          {
            "label": "B",
            "text": "respondent conditioning"
          },
          {
            "label": "C",
            "text": "behavior"
          },
          {
            "label": "D",
            "text": "reinforcer"
          }
        ],
        "answer": "D",
        "explanation": "\"The words can and often in the two previous sentences recognize the important qualification that the momentary effectiveness of an unconditioned reinforcer is a function of current motivating operations.\" is the chapter's own definition of reinforcer.",
        "topic": "Key terms",
        "sourceHint": "The words can and often in the two previous sentences recognize the important qualification that the momentary effectiveness of an unconditioned reinforcer is a function of current motivating operations."
      },
      {
        "id": "Q3",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"NS + US UR (eye blink) The product of respondent conditioning is a conditioned reflex (CR): In this case the clicking sound has become a conditioned stimulus (CS) that elicits an eye blink when presented alone.\"",
        "options": [
          {
            "label": "A",
            "text": "reinforcer"
          },
          {
            "label": "B",
            "text": "behavior"
          },
          {
            "label": "C",
            "text": "respondent conditioning"
          },
          {
            "label": "D",
            "text": "antecedent"
          }
        ],
        "answer": "C",
        "explanation": "\"NS + US UR (eye blink) The product of respondent conditioning is a conditioned reflex (CR): In this case the clicking sound has become a conditioned stimulus (CS) that elicits an eye blink when presented alone.\" is the chapter's own definition of respondent conditioning.",
        "topic": "Key terms",
        "sourceHint": "NS + US UR (eye blink) The product of respondent conditioning is a conditioned reflex (CR): In this case the clicking sound has become a conditioned stimulus (CS) that elicits an eye blink when presented alone."
      },
      {
        "id": "Q4",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Behavior is that portion of an organism's interaction with -Jack L.\"",
        "options": [
          {
            "label": "A",
            "text": "respondent conditioning"
          },
          {
            "label": "B",
            "text": "behavior"
          },
          {
            "label": "C",
            "text": "antecedent"
          },
          {
            "label": "D",
            "text": "reinforcer"
          }
        ],
        "answer": "B",
        "explanation": "\"Behavior is that portion of an organism's interaction with -Jack L.\" is the chapter's own definition of behavior.",
        "topic": "Key terms",
        "sourceHint": "Behavior is that portion of an organism's interaction with -Jack L."
      },
      {
        "id": "Q5",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"A behavior change tactic is a technologically consistent method for changing behavior that has been derived from one or more basic principles of behavior.\"",
        "options": [
          {
            "label": "A",
            "text": "behavior change tactic"
          },
          {
            "label": "B",
            "text": "antecedent"
          },
          {
            "label": "C",
            "text": "reinforcer"
          },
          {
            "label": "D",
            "text": "respondent conditioning"
          }
        ],
        "answer": "A",
        "explanation": "\"A behavior change tactic is a technologically consistent method for changing behavior that has been derived from one or more basic principles of behavior.\" is the chapter's own definition of behavior change tactic.",
        "topic": "Key terms",
        "sourceHint": "A behavior change tactic is a technologically consistent method for changing behavior that has been derived from one or more basic principles of behavior."
      },
      {
        "id": "Q6",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"A technical definition of response is an \"action of an organism's effector.\"",
        "options": [
          {
            "label": "A",
            "text": "antecedent"
          },
          {
            "label": "B",
            "text": "reinforcer"
          },
          {
            "label": "C",
            "text": "respondent conditioning"
          },
          {
            "label": "D",
            "text": "response"
          }
        ],
        "answer": "D",
        "explanation": "\"A technical definition of response is an \"action of an organism's effector.\" is the chapter's own definition of response.",
        "topic": "Key terms",
        "sourceHint": "A technical definition of response is an \"action of an organism's effector."
      }
    ],
    "reviewPrompts": [
      "Define \"antecedent\" in your own words, then check against the chapter glossary.",
      "Define \"reinforcer\" in your own words, then check against the chapter glossary.",
      "Define \"respondent conditioning\" in your own words, then check against the chapter glossary.",
      "Define \"behavior\" in your own words, then check against the chapter glossary.",
      "Define \"behavior change tactic\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"Behavior is the activity of living organisms..\"",
      "Restate this idea from the chapter in your own words: \"Technically, behavior is \"that portion of an organism's interaction with its environment that involves movement of some part of the organism\" (Johnston & Pennypacker, 2009, p.\""
    ],
    "recap": [
      "Applied behavior analysts are sometimes prevented from conducting an effective analysis of behavior because of practical, logistical, financial, sociopolitical, legal, and/or ethical reasons.."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true,
      "misconceptions": true
    }
  },
  "03": {
    "meta": {
      "id": "03",
      "number": 3,
      "title": "Selecting and Defining Target Behaviors",
      "subtitle": "Assessment methods, target selection, operational definitions",
      "part": "Part 2 - Selecting, Defining, and Measuring Behavior",
      "bacb": []
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [],
    "coreConcepts": [
      {
        "title": "Role of Assessment in Applied Behavior Analysis",
        "body": [
          "Behavioral assessment involves using indirect, direct, and empirical methods to identify, define, and determine the function of target behaviors."
        ],
        "bullets": [
          "Before conducting a behavioral assessment, the behavior analyst must determine whether she has the authority and permission, resources, and skills to assess and change the behavior. Past and current records related to medical, educational, and historical events should be examined and analyzed as part of a complete behavioral assessment."
        ]
      },
      {
        "title": "Assessment Methods Used by Behavior Analysts",
        "body": [
          "Subsumed under the three major methods for assessment information- indirect, direct, and empirical-are (a) interviews, checklists/rating scales, (b) tests and direct observations, and (c) functional behavior analysis and reinforcer/ punishment preference assessment methods, respectively."
        ],
        "bullets": [
          "The client interview is used to determine the client's description of problem behaviors or achievement goals. What, when, and where questions are emphasized, focusing on the actual behavior of the client and the responses of significant others to that behavior.",
          "Questionnaires and needs assessment surveys are sometimes completed by the client to supplement the information gathered in the interview.",
          "Clients are sometimes asked to self-monitor certain situations or behaviors. Self-collected data may be useful in selecting and defining target behaviors.",
          "Significant others can also be interviewed to gather assessment information and, in some cases, to find out whether they will be willing and able to assist in an intervention."
        ]
      },
      {
        "title": "Target Behaviors",
        "body": [
          "Target behaviors in applied behavior analysis must be socially significant behaviors that will increase a person's habilitation (adjustment, competence, and quality of life)."
        ],
        "bullets": []
      },
      {
        "title": "Prioritizing Target Behaviors",
        "body": [
          "Participation by the person whose behavior is to be changed, parents and/or other important fa mil y members, staff, and administration in identifying and prioriti zing target behaviors can help reduce goal conflicts."
        ],
        "bullets": []
      },
      {
        "title": "Defining Target Behaviors",
        "body": [
          "Explicit, well-written target behavior definitions are necessary for researchers to accurately and reliably measure the same response classes within and across studies or to aggregate, compare, and interpret their data."
        ],
        "bullets": [
          "Good target behaviors definitions are necessary for practitioners to collect accurate and believable data to guide ongoing program decisions, apply procedures consistently, and provide accountability to clients, parents, and administrators.",
          "Function-based definitions designate responses as members of the targeted response class solely by their common effect on the environment.",
          "Topography-based definitions define instances of the targeted response class behavior by the shape or form of the behavior.",
          "A good definition must be objective, clear, and complete, and must discriminate between what is and what is not an instance of the target behavior."
        ]
      },
      {
        "title": "Setting Criteria for Behavior Change",
        "body": [
          "A behavior change has social validity if it changes some aspect of the person's life in an important way."
        ],
        "bullets": [
          "Outcome criteria specifying the extent of behavior change desired or needed should be determined before efforts to modify the target behavior begin.",
          "Two approaches to determining socially validated performance criteria are (a) assessing the performance of people j udged to be highly competent and (b) experimentally manipulating different levels of performance to determine which produces optimal results."
        ]
      }
    ],
    "glossary": [
      {
        "term": "ecological assessment",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "reactivity",
        "definition": "Reactivity refers to the effects that an assessment procedure has on the behavior being assessed.",
        "sourceHint": "Reactivity refers to the effects that an assessment procedure has on the behavior being assessed."
      },
      {
        "term": "anecdotal observation",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "function-based definition",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "relevance of behavior rule",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "behavior checklist",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "habilitation",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "social validity",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "behavioral assessment",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "normalization",
        "definition": "The principle of normalization refers to the use of produres \"to establish and/or maintain personal behaviors which are as culturally normal as possible\" (Wolfensberger, 1972, p.",
        "sourceHint": "The principle of normalization refers to the use of produres \"to establish and/or maintain personal behaviors which are as culturally normal as possible\" (Wolfensberger, 1972, p."
      },
      {
        "term": "target behavior",
        "definition": "selection and definitio n of a target behavior- the specific behavior selected for change.",
        "sourceHint": "selection and definitio n of a target behavior- the specific behavior selected for change."
      },
      {
        "term": "behavioral cusp",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "pivotal behavior",
        "definition": "Pivotal Behavior A pivotal behavior is a behavior that, once learned, produces correspondi ng modifications or covariations in other adaptive untrained behaviors.",
        "sourceHint": "Pivotal Behavior A pivotal behavior is a behavior that, once learned, produces correspondi ng modifications or covariations in other adaptive untrained behaviors."
      },
      {
        "term": "topography-based definition",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Determine t he need for behavior-analytic services.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "risks, constraints, and social validity.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "pplied behavior analysis is concerned with producing",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "predictable and replicable improvements in behavior.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "behaviors.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "social, motor, and academic skills.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "For example, suppose that a behavior analyst is standing in a checko ut line where a nearby parent is attempting to manage an extremely disruptive child.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, suppose that a behavior analyst is standing in a checko ut line where a nearby parent is attempting to manage an extremely disruptive child."
      },
      {
        "scenario": "For example, when interviewing parents, the following questions help to target instances of \"noncompliant\" help implement a subsequent intervention.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, when interviewing parents, the following questions help to target instances of \"noncompliant\" help implement a subsequent intervention."
      },
      {
        "scenario": "Such scales provide a rank order characterization of phenomena when the direction of an underlying dimencombination with interviews to identify potential target behav- sion (such as consciousness) can be described and units of measurement cannot.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Such scales provide a rank order characterization of phenomena when the direction of an underlying dimencombination with interviews to identify potential target behav- sion (such as consciousness) can be described and units of measurement cannot."
      },
      {
        "scenario": "For example, Lo (2003) used the form shown in Figure 3.6 to record anecdotal observations of a fourth-grade special education student whose teacher had complained that the boy' s frequent talk-outs and out-of-seat behavior were impairing his learning and often di srupted the entire class.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, Lo (2003) used the form shown in Figure 3.6 to record anecdotal observations of a fourth-grade special education student whose teacher had complained that the boy' s frequent talk-outs and out-of-seat behavior were impairing his learning and often di srupted the entire class."
      }
    ],
    "comparisons": [],
    "misconceptions": [
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "A good definition must be objective, clear, and complete, and must discriminate between what is and what is not an instance of the target behavior.",
        "sourceHint": "A good definition must be objective, clear, and complete, and must discriminate between what is and what is not an instance of the target behavior."
      }
    ],
    "examChecklist": [
      "Define \"reactivity\" from memory and match the source text.",
      "Define \"normalization\" from memory and match the source text.",
      "Define \"target behavior\" from memory and match the source text.",
      "Define \"pivotal behavior\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Reactivity refers to the effects that an assessment procedure has on the behavior being assessed.\"",
        "options": [
          {
            "label": "A",
            "text": "reactivity"
          },
          {
            "label": "B",
            "text": "normalization"
          },
          {
            "label": "C",
            "text": "target behavior"
          },
          {
            "label": "D",
            "text": "pivotal behavior"
          }
        ],
        "answer": "A",
        "explanation": "\"Reactivity refers to the effects that an assessment procedure has on the behavior being assessed.\" is the chapter's own definition of reactivity.",
        "topic": "Key terms",
        "sourceHint": "Reactivity refers to the effects that an assessment procedure has on the behavior being assessed."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"The principle of normalization refers to the use of produres \"to establish and/or maintain personal behaviors which are as culturally normal as possible\" (Wolfensberger, 1972, p.\"",
        "options": [
          {
            "label": "A",
            "text": "reactivity"
          },
          {
            "label": "B",
            "text": "target behavior"
          },
          {
            "label": "C",
            "text": "pivotal behavior"
          },
          {
            "label": "D",
            "text": "normalization"
          }
        ],
        "answer": "D",
        "explanation": "\"The principle of normalization refers to the use of produres \"to establish and/or maintain personal behaviors which are as culturally normal as possible\" (Wolfensberger, 1972, p.\" is the chapter's own definition of normalization.",
        "topic": "Key terms",
        "sourceHint": "The principle of normalization refers to the use of produres \"to establish and/or maintain personal behaviors which are as culturally normal as possible\" (Wolfensberger, 1972, p."
      },
      {
        "id": "Q3",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"selection and definitio n of a target behavior- the specific behavior selected for change.\"",
        "options": [
          {
            "label": "A",
            "text": "normalization"
          },
          {
            "label": "B",
            "text": "pivotal behavior"
          },
          {
            "label": "C",
            "text": "target behavior"
          },
          {
            "label": "D",
            "text": "reactivity"
          }
        ],
        "answer": "C",
        "explanation": "\"selection and definitio n of a target behavior- the specific behavior selected for change.\" is the chapter's own definition of target behavior.",
        "topic": "Key terms",
        "sourceHint": "selection and definitio n of a target behavior- the specific behavior selected for change."
      },
      {
        "id": "Q4",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Pivotal Behavior A pivotal behavior is a behavior that, once learned, produces correspondi ng modifications or covariations in other adaptive untrained behaviors.\"",
        "options": [
          {
            "label": "A",
            "text": "target behavior"
          },
          {
            "label": "B",
            "text": "pivotal behavior"
          },
          {
            "label": "C",
            "text": "reactivity"
          },
          {
            "label": "D",
            "text": "normalization"
          }
        ],
        "answer": "B",
        "explanation": "\"Pivotal Behavior A pivotal behavior is a behavior that, once learned, produces correspondi ng modifications or covariations in other adaptive untrained behaviors.\" is the chapter's own definition of pivotal behavior.",
        "topic": "Key terms",
        "sourceHint": "Pivotal Behavior A pivotal behavior is a behavior that, once learned, produces correspondi ng modifications or covariations in other adaptive untrained behaviors."
      }
    ],
    "reviewPrompts": [
      "Define \"reactivity\" in your own words, then check against the chapter glossary.",
      "Define \"normalization\" in your own words, then check against the chapter glossary.",
      "Define \"target behavior\" in your own words, then check against the chapter glossary.",
      "Define \"pivotal behavior\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"Behavioral assessment involves using indirect, direct, and empirical methods to identify, define, and determine the function of target behaviors..\"",
      "Restate this idea from the chapter in your own words: \"Behavioral assessment consists of five phases or functions: (a) screening, (b) defining and quantifying problems or goals, (c) pinpointing the target behavior(s) to be treated, 13.\"",
      "What is the single most important takeaway from \"Selecting and Defining Target Behaviors\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "Two approaches to determining socially validated performance criteria are (a) assessing the performance of people j udged to be highly competent and (b) experimentally manipulating different levels of performance to determine which produces optimal results.."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true
    }
  },
  "04": {
    "meta": {
      "id": "04",
      "number": 4,
      "title": "Measuring Behavior",
      "subtitle": "Dimensional quantities, event/duration/latency measurement",
      "part": "Part 2 - Selecting, Defining, and Measuring Behavior",
      "bacb": [
        "C-2",
        "C-3",
        "C-4",
        "C-5",
        "C-6",
        "C-7",
        "C-9"
      ]
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [
      {
        "id": "C-2",
        "text": "Distinguish among di rect, indirect, and product measu res of behavior."
      },
      {
        "id": "C-3",
        "text": "Measure occu rrence (e.g., count, frequency, rate, percentage)."
      },
      {
        "id": "C-4",
        "text": "Measure temporal dimensions of behavior (e.g ., duration, latency, interresponse time)."
      },
      {
        "id": "C-5",
        "text": "Measure form and strength of behavior (e.g., topography, magnitude)."
      },
      {
        "id": "C-6",
        "text": "Measure trials-to-criterion."
      },
      {
        "id": "C-7",
        "text": "Design and implement sampling procedures (i.e., interva l recordi ng, time sampling)."
      },
      {
        "id": "C-9",
        "text": "Select a measurement system to obt ai n representative data given the dimensions of behavior and the logistics of observing."
      }
    ],
    "coreConcepts": [
      {
        "title": "Definition and Functions of Measurement",
        "body": [
          "Without measurement, all three level s of scientific knowledge-description, prediction, and control-would be relegated to guesswork and subjective opinions."
        ],
        "bullets": [
          "Applied behavior analysts measure behavior to obtain answers to questions about the existence and nature of functional relations between socially significant behavior and environmental variables.",
          "Without frequent measures of the behavior targeted for intervention, practitioners may (a) continue an ineffective treatment when no real behavior change occurred or (b) discontinue an effective treatment because subjective judgment detects no improvement."
        ]
      },
      {
        "title": "Measurable Dimensions of Behavior",
        "body": [
          "Rate is a ratio of count per observation period; it is expressed as count per standard unit of time. behavior."
        ],
        "bullets": [
          "Magnitude refers to the force or intensity with which a response is emitted."
        ]
      },
      {
        "title": "Methods for Measuring Behavior",
        "body": [
          "Event recording encompasses a wide variety of procedures for detecting and recording the number of times a behavior of interest is observed."
        ],
        "bullets": [
          "Time sampling refers to a variety of methods for observing and recording behavior during intervals or at specific moments in time. vation period into a series of equal time intervals. At the end of each interval, they record whether the target behavior occurred throughout the entire interval.",
          "Observers using partial-interval recording divide the observation period into a series of equal time intervals. At the end of each interval, they record whether behavior occurred at any point during the interval. observation period into a series of time intervals. At the end of each interval, they record whether the target behavior is occurring at that specific moment. momentary time sampling in which the observer records whether each individual in a group is engaged in the target behavior.",
          "Celeration is a measure of the change (acceleration or deceleration) in rate of responding per unit of time.",
          "Duration is the amount of time from the onset to the end point of a behavior."
        ]
      },
      {
        "title": "Measuring Behavior by Permanent Products",
        "body": [
          "Measuring behavior after it has occurred by measuring its effects on the environment is known as measurement by permanent product."
        ],
        "bullets": [
          "Measurement by permanent product offers numerous advantages: The practitioner is free to do other tasks; it enables the measurement of behaviors that occur at inconvenient or inaccessible times and places; measurement may be more accurate, complete, and continuous; it facilitates the collection of interobserver agreement and treatment integrity data; and it enables the measurement of complex behaviors and multiple response classes. during the session, measurement by permanent product may not be warranted. ucts must meet two rules. Rule I: Each occurrence of the target behavior must produce the same permanent product. Rule 2: The permanent product can be produced only by the target behavior."
        ]
      },
      {
        "title": "Measurement Tools",
        "body": [
          "Low tech tools are functional , easy to use, inexpensive, and effective for research, education, and treatment."
        ],
        "bullets": [
          "High-tech, digital and computer hardware and software systems for behavioral measurement and data analysis have become increasingly sophisticated and easier to use."
        ]
      },
      {
        "title": "Selecting a Measurement Method",
        "body": [
          "When selecting a measurement method, consider the behavior change goals and expected direction of behavior change, the re lative ease of detecting occurrences of the behavior, the environments where and times when the behavior will be measured, and the availability and skills of personnel who will observe and record the behavior."
        ],
        "bullets": []
      }
    ],
    "glossary": [
      {
        "term": "artifact",
        "definition": "An artifact is a phenomenon that appears to exist because of the way it is examined or measured.",
        "sourceHint": "An artifact is a phenomenon that appears to exist because of the way it is examined or measured."
      },
      {
        "term": "latency",
        "definition": "Response latency is a measure of the elapsed time between the onset of a stimulus and the initiation of a subsequent response.",
        "sourceHint": "Response latency is a measure of the elapsed time between the onset of a stimulus and the initiation of a subsequent response."
      },
      {
        "term": "repeatability",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "celeration",
        "definition": "Celeration is a measure of count per unit time/per unit of time; or expressed another way, rate/per unit of time (Graf & Lindsley, 2002; Kubina, 2005).",
        "sourceHint": "Celeration is a measure of count per unit time/per unit of time; or expressed another way, rate/per unit of time (Graf & Lindsley, 2002; Kubina, 2005)."
      },
      {
        "term": "magnitude",
        "definition": "Magnitude Magnitude refers to the force or intensity of a response.",
        "sourceHint": "Magnitude Magnitude refers to the force or intensity of a response."
      },
      {
        "term": "temporal extent",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "count",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "measu rement",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "temporal locus",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "d iscrete tria I",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "measu rement by permanent product",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "time sampling",
        "definition": "Time Sampling Time sampling refers to a variety of methods for observing and recording behavior during intervals or at specific moments in time.",
        "sourceHint": "Time Sampling Time sampling refers to a variety of methods for observing and recording behavior during intervals or at specific moments in time."
      },
      {
        "term": "duration",
        "definition": "Total duration is a measure of the cumulative time a person engages in the target behavior.",
        "sourceHint": "Total duration is a measure of the cumulative time a person engages in the target behavior."
      },
      {
        "term": "momentary time sampling",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "topography",
        "definition": "Topography is a measurable dimension of behavior because responses of varying form can be detected from one another.",
        "sourceHint": "Topography is a measurable dimension of behavior because responses of varying form can be detected from one another."
      },
      {
        "term": "event recording",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "partia l-interval recording",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "trials-to-criterion",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "free operant",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "percentage",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "whole-interva l recording",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "frequency",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "rate",
        "definition": "Rate is defined as the number of responses per unit of tirne.",
        "sourceHint": "Rate is defined as the number of responses per unit of tirne."
      },
      {
        "term": "Measure trials-to-criterion.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "completely oblivious of the behavioral measurement.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "For example, a student who, over four Figure 4.1 Schematic representation of the dimensional quantities of repeatability, temporal extent, and temporal locus.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, a student who, over four Figure 4.1 Schematic representation of the dimensional quantities of repeatability, temporal extent, and temporal locus."
      },
      {
        "scenario": "For example, in measuring students' math calculation performance, instead of counting answers to a two-digit plus rect, a behavior analyst might consider the number of steps that were completed in correct sequence within each problem.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, in measuring students' math calculation performance, instead of counting answers to a two-digit plus rect, a behavior analyst might consider the number of steps that were completed in correct sequence within each problem."
      },
      {
        "scenario": "For example, response rates of behaviors that occur a person engages in a target behavior.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, response rates of behaviors that occur a person engages in a target behavior."
      },
      {
        "scenario": "opportunity bound, measures such as percentage of response opportunities in which a response was emitted or trial s-tocriterion should be used.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "opportunity bound, measures such as percentage of response opportunities in which a response was emitted or trial s-tocriterion should be used."
      }
    ],
    "comparisons": [],
    "misconceptions": [
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "Behaviors suitable for measurement with permanent proding (i.e., magnitude) are not fundamental dimensional quantities of behavior, they are important quantitative parameters for defining and verifying the occurrence of many response classes.",
        "sourceHint": "Behaviors suitable for measurement with permanent proding (i.e., magnitude) are not fundamental dimensional quantities of behavior, they are important quantitative parameters for defining and verifying the occurrence of many response classes."
      }
    ],
    "examChecklist": [
      "Address objective C-2: Distinguish among di rect, indirect, and product measu res of behavior.",
      "Address objective C-3: Measure occu rrence (e.g., count, frequency, rate, percentage).",
      "Address objective C-4: Measure temporal dimensions of behavior (e.g ., duration, latency, interresponse time).",
      "Address objective C-5: Measure form and strength of behavior (e.g., topography, magnitude).",
      "Address objective C-6: Measure trials-to-criterion.",
      "Address objective C-7: Design and implement sampling procedures (i.e., interva l recordi ng, time sampling).",
      "Address objective C-9: Select a measurement system to obt ai n representative data given the dimensions of behavior and the logistics of observing.",
      "Define \"artifact\" from memory and match the source text.",
      "Define \"latency\" from memory and match the source text.",
      "Define \"celeration\" from memory and match the source text.",
      "Define \"magnitude\" from memory and match the source text.",
      "Define \"time sampling\" from memory and match the source text.",
      "Define \"duration\" from memory and match the source text.",
      "Define \"topography\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"An artifact is a phenomenon that appears to exist because of the way it is examined or measured.\"",
        "options": [
          {
            "label": "A",
            "text": "artifact"
          },
          {
            "label": "B",
            "text": "latency"
          },
          {
            "label": "C",
            "text": "celeration"
          },
          {
            "label": "D",
            "text": "magnitude"
          }
        ],
        "answer": "A",
        "explanation": "\"An artifact is a phenomenon that appears to exist because of the way it is examined or measured.\" is the chapter's own definition of artifact.",
        "topic": "Key terms",
        "sourceHint": "An artifact is a phenomenon that appears to exist because of the way it is examined or measured."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Response latency is a measure of the elapsed time between the onset of a stimulus and the initiation of a subsequent response.\"",
        "options": [
          {
            "label": "A",
            "text": "artifact"
          },
          {
            "label": "B",
            "text": "celeration"
          },
          {
            "label": "C",
            "text": "magnitude"
          },
          {
            "label": "D",
            "text": "latency"
          }
        ],
        "answer": "D",
        "explanation": "\"Response latency is a measure of the elapsed time between the onset of a stimulus and the initiation of a subsequent response.\" is the chapter's own definition of latency.",
        "topic": "Key terms",
        "sourceHint": "Response latency is a measure of the elapsed time between the onset of a stimulus and the initiation of a subsequent response."
      },
      {
        "id": "Q3",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Celeration is a measure of count per unit time/per unit of time; or expressed another way, rate/per unit of time (Graf & Lindsley, 2002; Kubina, 2005).\"",
        "options": [
          {
            "label": "A",
            "text": "latency"
          },
          {
            "label": "B",
            "text": "magnitude"
          },
          {
            "label": "C",
            "text": "celeration"
          },
          {
            "label": "D",
            "text": "artifact"
          }
        ],
        "answer": "C",
        "explanation": "\"Celeration is a measure of count per unit time/per unit of time; or expressed another way, rate/per unit of time (Graf & Lindsley, 2002; Kubina, 2005).\" is the chapter's own definition of celeration.",
        "topic": "Key terms",
        "sourceHint": "Celeration is a measure of count per unit time/per unit of time; or expressed another way, rate/per unit of time (Graf & Lindsley, 2002; Kubina, 2005)."
      },
      {
        "id": "Q4",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Magnitude Magnitude refers to the force or intensity of a response.\"",
        "options": [
          {
            "label": "A",
            "text": "celeration"
          },
          {
            "label": "B",
            "text": "magnitude"
          },
          {
            "label": "C",
            "text": "artifact"
          },
          {
            "label": "D",
            "text": "latency"
          }
        ],
        "answer": "B",
        "explanation": "\"Magnitude Magnitude refers to the force or intensity of a response.\" is the chapter's own definition of magnitude.",
        "topic": "Key terms",
        "sourceHint": "Magnitude Magnitude refers to the force or intensity of a response."
      },
      {
        "id": "Q5",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Time Sampling Time sampling refers to a variety of methods for observing and recording behavior during intervals or at specific moments in time.\"",
        "options": [
          {
            "label": "A",
            "text": "time sampling"
          },
          {
            "label": "B",
            "text": "artifact"
          },
          {
            "label": "C",
            "text": "latency"
          },
          {
            "label": "D",
            "text": "celeration"
          }
        ],
        "answer": "A",
        "explanation": "\"Time Sampling Time sampling refers to a variety of methods for observing and recording behavior during intervals or at specific moments in time.\" is the chapter's own definition of time sampling.",
        "topic": "Key terms",
        "sourceHint": "Time Sampling Time sampling refers to a variety of methods for observing and recording behavior during intervals or at specific moments in time."
      },
      {
        "id": "Q6",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Total duration is a measure of the cumulative time a person engages in the target behavior.\"",
        "options": [
          {
            "label": "A",
            "text": "artifact"
          },
          {
            "label": "B",
            "text": "latency"
          },
          {
            "label": "C",
            "text": "celeration"
          },
          {
            "label": "D",
            "text": "duration"
          }
        ],
        "answer": "D",
        "explanation": "\"Total duration is a measure of the cumulative time a person engages in the target behavior.\" is the chapter's own definition of duration.",
        "topic": "Key terms",
        "sourceHint": "Total duration is a measure of the cumulative time a person engages in the target behavior."
      }
    ],
    "reviewPrompts": [
      "Define \"artifact\" in your own words, then check against the chapter glossary.",
      "Define \"latency\" in your own words, then check against the chapter glossary.",
      "Define \"celeration\" in your own words, then check against the chapter glossary.",
      "Define \"magnitude\" in your own words, then check against the chapter glossary.",
      "Define \"time sampling\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"Measurement is how scientists operationalize empiricism..\"",
      "What is the single most important takeaway from \"Measuring Behavior\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "High-tech, digital and computer hardware and software systems for behavioral measurement and data analysis have become increasingly sophisticated and easier to use.."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true
    }
  },
  "05": {
    "meta": {
      "id": "05",
      "number": 5,
      "title": "Improving and Assessing the Quality of Behavioral Measurement",
      "subtitle": "Validity, accuracy, reliability, IOA",
      "part": "Part 2 - Selecting, Defining, and Measuring Behavior",
      "bacb": []
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [],
    "coreConcepts": [
      {
        "title": "Indicators of Trustworthy Measurement",
        "body": [
          "To be most useful for science, measurement must be valid, accurate, and reliable."
        ],
        "bullets": [
          "Measurement is accurate when observed values, the data produced by measuring an event, match the true state, or true values, of the event.",
          "Measurement is reliable when it yields the same values across repeated measurement of the same event."
        ]
      },
      {
        "title": "Threats to Valid Measurement Validity",
        "body": [
          "Indirect measurement-measuring a behavior different from the behavior of interest-threatens validity because it requires the researcher or practitioner to make inferences about the relationship between the measures obtained and the actual behavior of interest."
        ],
        "bullets": [
          "A researcher who uses indirect measurement must provide evidence that the behavior measured directly reflects, in some reliable and meaningful way, something about the behavior for which the researcher wishes to draw conclusions.",
          "Measuring a dimension of the behavior that is ill suited for, or irrelevant to, the reason for measuring the behavior compromises validity.",
          "Measurement artifacts are data that give an unwarranted or misleading picture of the behavior because of the way measurement was conducted. Discontinuous measurement, poorly scheduled observations, and insensitive or limiting measurement scales are common causes of measurement artifacts."
        ]
      },
      {
        "title": "Threats to Accurate and Reliable Measurement",
        "body": [
          "Most investigations in applied behavior analysis use human observers to measure behavior, and human error is the biggest threat to the accuracy and reliability of data."
        ],
        "bullets": [
          "Factors that contribute to measurement error include poorly designed measurement systems, inadequate observer training, and expectations about what the data should look like.",
          "Observers should receive systematic training and practice with the measurement system and meet predetermined accuracy and reliability criteria before collecting data.",
          "Observer drift-unintended changes in the way an observer uses a measurement system over the course of an investigation--can be minimized by booster training sessions and feedback on the accuracy and reliability of measurement.",
          "An observer's expectations or knowledge about predicted or desired results can impair the accuracy and reliability of data."
        ]
      },
      {
        "title": "Assessing the Accuracy and Reliability",
        "body": [
          "Researchers and practitioners who assess the accuracy of their data can (a) determine early in an analysis whether the data are usable for making experimental or treatment decisions, (b) discover and correct measurement errors, (c) detect consistent patterns of measurement error that can lead to the overall improvement or calibration of the measurement system, and (d) communicate to others the relative trustworthiness of the data."
        ],
        "bullets": [
          "Assessing the accuracy of measurement is a straightforward process of calculating the correspondence of each measure, or datum, assessed to its true value.",
          "True values for many behaviors of interest to applied behavior analysts are evident and universally accepted or can be established conditionally by local context. True values for some behaviors (e.g., cooperative play) are difficult because the process for determining a true value must be different from the measurement procedures used to obtain the data one wishes to compare to the true value.",
          "Assessing the extent to which observers are reliably applying a valid and accurate measurement system provides a useful indicator of the overall trustworthiness of the data.",
          "Assessing the reliability of measurement requires a natural or contrived permanent product so the observer can remeasure the same behavioral events."
        ]
      },
      {
        "title": "Measurement",
        "body": [
          "The most commonly used indicator of measurement quality in ABA is interobserver agreement (JOA), the degree to which two or more independent observers report the same observed values after measuring the same events."
        ],
        "bullets": [
          "Total count IOA is the simplest and crudest indicator of IOA for event recording data, and exact count-per-interval IOA is the most stringent for most data sets obtained by event recording.",
          "IOA for data obtained by timing duration, response latency, or interresponse time (IRT) is calculated in essentially the same ways as for event recording data.",
          "Total duration IOA is computed by dividing the shorter of the two durations reported by the observers by the longer duration. Mean duration-per-occurrence IOA is a more conservative and usually more meaningful assessment of IOA for total duration data and should always be calculated for duration-per-occurrence data.",
          "Three techniques commonly used to calculate IOA for interval data are interval-by-interval IOA, scored-interval IOA, and unscored-interval IOA."
        ]
      }
    ],
    "glossary": [
      {
        "term": "accuracy",
        "definition": "Accuracy When used in the context of measurement, accuracy refers to the extent to which the observed value (i.e., the quantitative labels produced by measuring an event) match the true value of the event.",
        "sourceHint": "Accuracy When used in the context of measurement, accuracy refers to the extent to which the observed value (i.e., the quantitative labels produced by measuring an event) match the true value of the event."
      },
      {
        "term": "believability",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "cal ibration",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "continuous measurement",
        "definition": "\"No sir, for you cannot make a tail into a leg by calling it Discontinuous Measurement Because behavior is a dynamic and continuous phenomenon that occurs and changes over time, continuous measurement is the gold standard in behavior analysis research and practice.",
        "sourceHint": "\"No sir, for you cannot make a tail into a leg by calling it Discontinuous Measurement Because behavior is a dynamic and continuous phenomenon that occurs and changes over time, continuous measurement is the gold standard in behavior analysis research and practice."
      },
      {
        "term": "measurement bias",
        "definition": "Measurement bias refers to nonrandom measurement errorrelevant, or valid, dimension of their riding behavior.",
        "sourceHint": "Measurement bias refers to nonrandom measurement errorrelevant, or valid, dimension of their riding behavior."
      },
      {
        "term": "direct measurement",
        "definition": "Conversely, direct measurement occurs when the behavior measured is exactly the same as the behavior that is the focus of the investigation or behavior change program.",
        "sourceHint": "Conversely, direct measurement occurs when the behavior measured is exactly the same as the behavior that is the focus of the investigation or behavior change program."
      },
      {
        "term": "na\"ive observer",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "true va lue",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "discontinuous measurement",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "observed va lue",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "observer drift",
        "definition": "Observer drift occurs when observers expand or compress the original definition of the target behavior.",
        "sourceHint": "Observer drift occurs when observers expand or compress the original definition of the target behavior."
      },
      {
        "term": "va lid ity",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "indirect measurement",
        "definition": "Indirect Measurement Indirect measurement occurs when the researcher or practitioner measures a proxy, or stand-in, for the actual behavior of interest.",
        "sourceHint": "Indirect Measurement Indirect measurement occurs when the researcher or practitioner measures a proxy, or stand-in, for the actual behavior of interest."
      },
      {
        "term": "observer reactivity",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "reliabi lity",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "material with which behavioral researchers and practi-",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "generalization of behavior changes.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "For example, a student's responses to a questionnaire designed to measure his socialization with peers is an indirect measure.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, a student's responses to a questionnaire designed to measure his socialization with peers is an indirect measure."
      },
      {
        "scenario": "For example, Green and Reid (1996) used direct measures of smiling to represent \"happiness\" by persons with profound multiple disabilities.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, Green and Reid (1996) used direct measures of smiling to represent \"happiness\" by persons with profound multiple disabilities."
      },
      {
        "scenario": "Minimizing the threat to validcontinuous measurement may be prohibited by factors such as ity posed by discontinuous measurement requires careful conthe nature of the target behavior being measured; the number sideration of when observation and measurement periods should be scheduled.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Minimizing the threat to validcontinuous measurement may be prohibited by factors such as ity posed by discontinuous measurement requires careful conthe nature of the target behavior being measured; the number sideration of when observation and measurement periods should be scheduled."
      },
      {
        "scenario": "For example, measuring off-task behavior by partial-interval recording with IO-minute intervals may produce data that make even the most diligent of students appear to be highly off task.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, measuring off-task behavior by partial-interval recording with IO-minute intervals may produce data that make even the most diligent of students appear to be highly off task."
      }
    ],
    "comparisons": [],
    "misconceptions": [
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "Observers should not receive feedback about the extent to which their data confinn or run counter to hypothesized results or treatment goals.",
        "sourceHint": "Observers should not receive feedback about the extent to which their data confinn or run counter to hypothesized results or treatment goals."
      },
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "Although high reliability does not confirm high accuracy, discovering a low level of reliability signals that the data are suspect enough to be disregarded until problems in the measurement system can be determined and repaired.",
        "sourceHint": "Although high reliability does not confirm high accuracy, discovering a low level of reliability signals that the data are suspect enough to be disregarded until problems in the measurement system can be determined and repaired."
      }
    ],
    "examChecklist": [
      "Define \"accuracy\" from memory and match the source text.",
      "Define \"continuous measurement\" from memory and match the source text.",
      "Define \"measurement bias\" from memory and match the source text.",
      "Define \"direct measurement\" from memory and match the source text.",
      "Define \"observer drift\" from memory and match the source text.",
      "Define \"indirect measurement\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Accuracy When used in the context of measurement, accuracy refers to the extent to which the observed value (i.e., the quantitative labels produced by measuring an event) match the true value of the event.\"",
        "options": [
          {
            "label": "A",
            "text": "accuracy"
          },
          {
            "label": "B",
            "text": "continuous measurement"
          },
          {
            "label": "C",
            "text": "measurement bias"
          },
          {
            "label": "D",
            "text": "direct measurement"
          }
        ],
        "answer": "A",
        "explanation": "\"Accuracy When used in the context of measurement, accuracy refers to the extent to which the observed value (i.e., the quantitative labels produced by measuring an event) match the true value of the event.\" is the chapter's own definition of accuracy.",
        "topic": "Key terms",
        "sourceHint": "Accuracy When used in the context of measurement, accuracy refers to the extent to which the observed value (i.e., the quantitative labels produced by measuring an event) match the true value of the event."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"\"No sir, for you cannot make a tail into a leg by calling it Discontinuous Measurement Because behavior is a dynamic and continuous phenomenon that occurs and changes over time, continuous measurement is the gold standard in behavior analysis research and practice.\"",
        "options": [
          {
            "label": "A",
            "text": "accuracy"
          },
          {
            "label": "B",
            "text": "measurement bias"
          },
          {
            "label": "C",
            "text": "direct measurement"
          },
          {
            "label": "D",
            "text": "continuous measurement"
          }
        ],
        "answer": "D",
        "explanation": "\"\"No sir, for you cannot make a tail into a leg by calling it Discontinuous Measurement Because behavior is a dynamic and continuous phenomenon that occurs and changes over time, continuous measurement is the gold standard in behavior analysis research and practice.\" is the chapter's own definition of continuous measurement.",
        "topic": "Key terms",
        "sourceHint": "\"No sir, for you cannot make a tail into a leg by calling it Discontinuous Measurement Because behavior is a dynamic and continuous phenomenon that occurs and changes over time, continuous measurement is the gold standard in behavior analysis research and practice."
      },
      {
        "id": "Q3",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Measurement bias refers to nonrandom measurement errorrelevant, or valid, dimension of their riding behavior.\"",
        "options": [
          {
            "label": "A",
            "text": "continuous measurement"
          },
          {
            "label": "B",
            "text": "direct measurement"
          },
          {
            "label": "C",
            "text": "measurement bias"
          },
          {
            "label": "D",
            "text": "accuracy"
          }
        ],
        "answer": "C",
        "explanation": "\"Measurement bias refers to nonrandom measurement errorrelevant, or valid, dimension of their riding behavior.\" is the chapter's own definition of measurement bias.",
        "topic": "Key terms",
        "sourceHint": "Measurement bias refers to nonrandom measurement errorrelevant, or valid, dimension of their riding behavior."
      },
      {
        "id": "Q4",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Conversely, direct measurement occurs when the behavior measured is exactly the same as the behavior that is the focus of the investigation or behavior change program.\"",
        "options": [
          {
            "label": "A",
            "text": "measurement bias"
          },
          {
            "label": "B",
            "text": "direct measurement"
          },
          {
            "label": "C",
            "text": "accuracy"
          },
          {
            "label": "D",
            "text": "continuous measurement"
          }
        ],
        "answer": "B",
        "explanation": "\"Conversely, direct measurement occurs when the behavior measured is exactly the same as the behavior that is the focus of the investigation or behavior change program.\" is the chapter's own definition of direct measurement.",
        "topic": "Key terms",
        "sourceHint": "Conversely, direct measurement occurs when the behavior measured is exactly the same as the behavior that is the focus of the investigation or behavior change program."
      },
      {
        "id": "Q5",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Observer drift occurs when observers expand or compress the original definition of the target behavior.\"",
        "options": [
          {
            "label": "A",
            "text": "observer drift"
          },
          {
            "label": "B",
            "text": "accuracy"
          },
          {
            "label": "C",
            "text": "continuous measurement"
          },
          {
            "label": "D",
            "text": "measurement bias"
          }
        ],
        "answer": "A",
        "explanation": "\"Observer drift occurs when observers expand or compress the original definition of the target behavior.\" is the chapter's own definition of observer drift.",
        "topic": "Key terms",
        "sourceHint": "Observer drift occurs when observers expand or compress the original definition of the target behavior."
      },
      {
        "id": "Q6",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Indirect Measurement Indirect measurement occurs when the researcher or practitioner measures a proxy, or stand-in, for the actual behavior of interest.\"",
        "options": [
          {
            "label": "A",
            "text": "accuracy"
          },
          {
            "label": "B",
            "text": "continuous measurement"
          },
          {
            "label": "C",
            "text": "measurement bias"
          },
          {
            "label": "D",
            "text": "indirect measurement"
          }
        ],
        "answer": "D",
        "explanation": "\"Indirect Measurement Indirect measurement occurs when the researcher or practitioner measures a proxy, or stand-in, for the actual behavior of interest.\" is the chapter's own definition of indirect measurement.",
        "topic": "Key terms",
        "sourceHint": "Indirect Measurement Indirect measurement occurs when the researcher or practitioner measures a proxy, or stand-in, for the actual behavior of interest."
      }
    ],
    "reviewPrompts": [
      "Define \"accuracy\" in your own words, then check against the chapter glossary.",
      "Define \"continuous measurement\" in your own words, then check against the chapter glossary.",
      "Define \"measurement bias\" in your own words, then check against the chapter glossary.",
      "Define \"direct measurement\" in your own words, then check against the chapter glossary.",
      "Define \"observer drift\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"To be most useful for science, measurement must be valid, accurate, and reliable..\"",
      "What is the single most important takeaway from \"Improving and Assessing the Quality of Behavioral Measurement\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "Researchers can use multiple indices to assess the quality of their data (e.g., accuracy plus IOA, reliability plus IOA)."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true
    }
  },
  "06": {
    "meta": {
      "id": "06",
      "number": 6,
      "title": "Constructing and Interpreting Graphic Displays of Behavioral Data",
      "subtitle": "Line graphs, axes, conditions, visual analysis",
      "part": "Part 3 - Evaluating and Analyzing Behavior Change",
      "bacb": [
        "C-10",
        "C-11"
      ]
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [
      {
        "id": "C-10",
        "text": "Graph data to communicate relevant quantitative relations (e.g., equal-interval graphs, ba r graphs, cumulative records)."
      },
      {
        "id": "C-11",
        "text": "Int erpret graphed data."
      }
    ],
    "coreConcepts": [
      {
        "title": "Key idea",
        "body": [
          "Applied behavior analysts document and quantify behavior change by direct and repeated measurement of behavior, and the product of those measurements is called data."
        ],
        "bullets": [
          "Graphs are relatively simple formats for visually displaying relationships among and between a series of measurements and relevant variables."
        ]
      },
      {
        "title": "Behavioral Data",
        "body": [
          "Graphing each measure of behavior as it is collected provides the practitioner or researcher with an immediate and ongoing visual record of the participant's behavior, allowing treatment and experimental decisions to be responsive to the participant's performance."
        ],
        "bullets": [
          "Direct and continual contact with the data in a readily analyzable format enables the practitioner or researcher to identify and investigate interesting variations in behavior as they occur.",
          "As a judgmental aid for interpreting experimental results, graphic display is a fast, relatively easy-to-learn method that imposes no arbitrary levels of significance for evaluating behavior change.",
          "Visual analysis of graphed data is a conservative method for determining the significance of behavior change; only variables able to produce meaningful effects repeatedly are considered significant, and weak and unstable variables are screened out. ",
          "Graphs enable and encourage independent judgments of the meaning and significance of behavior change by others."
        ]
      },
      {
        "title": "Graphs Used by Applied Behavior Analysts",
        "body": [
          "Line graphs, the most commonly used format for the graphic display of behavioral data, are based on the Cartesian plane, a two-dimensional area formed by the intersection of two perpendicular lines."
        ],
        "bullets": [
          "Major parts of the simple line graph are the horizontal axis (also called the x-axis), the vertical axis (also called the y-axis), condition change lines, condition labels, data points, the data path, and the figure caption.",
          "A second vertical axis, which is drawn on the right-hand side of the horizontal axis, is sometimes used to show different scales for multiple data paths.",
          "Bar graphs are used for two primary purposes: (a) to display discrete data not related by an underlying dimension that can be used to scale the horizontal axis and (b) to summarize and enable easy comparison of the performance of a participant or group of participants during the different conditions of an experiment.",
          "Each data point on a cumulative record represents the total number of responses emitted by the subject since measurement began. The steeper the slope of the data path on a cumulative graph, the higher the response rate."
        ]
      },
      {
        "title": "Constructing Line Graphs",
        "body": [
          "The vertical axis is drawn to a length approximately twothirds that of the horizontal axis."
        ],
        "bullets": [
          "The horizontal axis is marked in equal intervals, each representing, from left to right, the chronological succession of equal time periods within which behavior was measured.",
          "Scale breaks on the horizontal axis indicate discontinuities of time.",
          "The vertical axis is scaled relative to the dimension of behavior measured, the range of values of the measures obtained, and the social significance of various levels of change in the target behavior.",
          "Condition change lines indicate changes in the treatment program or manipulations of an independent variable and are drawn to the same height as the vertical axis."
        ]
      },
      {
        "title": "Interpreting Graphically Displayed Behavioral Data",
        "body": [
          "Before beginning to evaluate the data displayed in a graph, a careful examination of the graph's construction should be undertaken. If distortion is suspected from the features of the graph's construction, the data should be replotted on a new set of axes before interpretation is attempted."
        ],
        "bullets": [
          "Blocked data and data representing the average performance of a group of subjects should be viewed with the understanding that significant variability may have been lost in the display.",
          "Visual analysis of data within a given condition focuses on the number of data points, the variability of performance, the level of performance, and the direction and degree of any trends in the data.",
          "As a general rule, the more data in a condition and the greater the stability of those data, the more confidence one can place in the data path's estimate of behavior during that time. The more variability in the behavioral measures during a condition, the greater the need for additional data.",
          "Variability refers to the frequency and degree to which multiple measures of behavior yield different outcomes. A high degree of variability within a given condition usually indicates that little or no control has been achieved over the factors influencing the behavior."
        ]
      }
    ],
    "glossary": [
      {
        "term": "bar graph",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "graph",
        "definition": "Evident in the bottom graph is a variable pattern of responding, characterized by higher response rates during the first part of each week and a decreasing trend toward the end of each week.",
        "sourceHint": "Evident in the bottom graph is a variable pattern of responding, characterized by higher response rates during the first part of each week and a decreasing trend toward the end of each week."
      },
      {
        "term": "ratio scale",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "cumulative record",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "independent variable",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "scatterplot",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "cumulative recorder",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "level",
        "definition": "Level refers to the value on the vertical axis around which a series of data points converges.",
        "sourceHint": "Level refers to the value on the vertical axis around which a series of data points converges."
      },
      {
        "term": "split-middle line of progress",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "data",
        "definition": "Visual analysis of graphed data is a conservative method for determining the significance of behavior change; only variables able to produce meaningful effects repeatedly are considered significant, and weak and unstable variables are screened out.",
        "sourceHint": "Visual analysis of graphed data is a conservative method for determining the significance of behavior change; only variables able to produce meaningful effects repeatedly are considered significant, and weak and unstable variables are screened out."
      },
      {
        "term": "line graph",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "data path",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "local response rate",
        "definition": "The term local response rate refers to the rate of response during periods smal ler than that for which an overall rate has Figure 6.12, the learner exhibited a local rate of responding during interspersal training (Slope b-c) that was considerably higher than his overall rate for that condition.",
        "sourceHint": "The term local response rate refers to the rate of response during periods smal ler than that for which an overall rate has Figure 6.12, the learner exhibited a local rate of responding during interspersal training (Slope b-c) that was considerably higher than his overall rate for that condition."
      },
      {
        "term": "trend",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "dependent variable",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "overall response rate",
        "definition": "An overall response rate is the average rate of response over a given time period, such as during a specific session, phase, or condition of an experiment.",
        "sourceHint": "An overall response rate is the average rate of response over a given time period, such as during a specific session, phase, or condition of an experiment."
      },
      {
        "term": "variability",
        "definition": "Variability refers to the frequency and degree to which multiple measures of behavior yield different outcomes.",
        "sourceHint": "Variability refers to the frequency and degree to which multiple measures of behavior yield different outcomes."
      },
      {
        "term": "equal-interval sca le",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "precision teaching",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "visual analysis",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Int erpret graphed data.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "pplied behavior analysts quantify behavior change with",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "overlooked.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "For example, Figure 6.8 shows the mean percentage by four students during baseline and the combined generalization ing each child to recruit teacher attention while working (Craft, Alber, & Heward, 1998).",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, Figure 6.8 shows the mean percentage by four students during baseline and the combined generalization ing each child to recruit teacher attention while working (Craft, Alber, & Heward, 1998)."
      },
      {
        "scenario": "Bar graphs that present a measure of central tendency, such as the mean or median score for each condition, may mask important variability in the data.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Bar graphs that present a measure of central tendency, such as the mean or median score for each condition, may mask important variability in the data."
      },
      {
        "scenario": "For example, in a study analyzing the effects of establishing operations on preference assessments, Gottschalk, Libby, and Graff (2000) used bar graphs to show the percentage of trials in which four children reached toward and picked up different items (see Figure 6.10).",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, in a study analyzing the effects of establishing operations on preference assessments, Gottschalk, Libby, and Graff (2000) used bar graphs to show the percentage of trials in which four children reached toward and picked up different items (see Figure 6.10)."
      },
      {
        "scenario": "An overall response rate is the average rate of response over a given time period, such as during a specific session, phase, or condition of an experiment.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "An overall response rate is the average rate of response over a given time period, such as during a specific session, phase, or condition of an experiment."
      }
    ],
    "comparisons": [],
    "misconceptions": [],
    "examChecklist": [
      "Address objective C-10: Graph data to communicate relevant quantitative relations (e.g., equal-interval graphs, ba r graphs, cumulative records).",
      "Address objective C-11: Int erpret graphed data.",
      "Define \"graph\" from memory and match the source text.",
      "Define \"level\" from memory and match the source text.",
      "Define \"data\" from memory and match the source text.",
      "Define \"local response rate\" from memory and match the source text.",
      "Define \"overall response rate\" from memory and match the source text.",
      "Define \"variability\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Evident in the bottom graph is a variable pattern of responding, characterized by higher response rates during the first part of each week and a decreasing trend toward the end of each week.\"",
        "options": [
          {
            "label": "A",
            "text": "graph"
          },
          {
            "label": "B",
            "text": "level"
          },
          {
            "label": "C",
            "text": "data"
          },
          {
            "label": "D",
            "text": "local response rate"
          }
        ],
        "answer": "A",
        "explanation": "\"Evident in the bottom graph is a variable pattern of responding, characterized by higher response rates during the first part of each week and a decreasing trend toward the end of each week.\" is the chapter's own definition of graph.",
        "topic": "Key terms",
        "sourceHint": "Evident in the bottom graph is a variable pattern of responding, characterized by higher response rates during the first part of each week and a decreasing trend toward the end of each week."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Level refers to the value on the vertical axis around which a series of data points converges.\"",
        "options": [
          {
            "label": "A",
            "text": "graph"
          },
          {
            "label": "B",
            "text": "data"
          },
          {
            "label": "C",
            "text": "local response rate"
          },
          {
            "label": "D",
            "text": "level"
          }
        ],
        "answer": "D",
        "explanation": "\"Level refers to the value on the vertical axis around which a series of data points converges.\" is the chapter's own definition of level.",
        "topic": "Key terms",
        "sourceHint": "Level refers to the value on the vertical axis around which a series of data points converges."
      },
      {
        "id": "Q3",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Visual analysis of graphed data is a conservative method for determining the significance of behavior change; only variables able to produce meaningful effects repeatedly are considered significant, and weak and unstable variables are screened out.\"",
        "options": [
          {
            "label": "A",
            "text": "level"
          },
          {
            "label": "B",
            "text": "local response rate"
          },
          {
            "label": "C",
            "text": "data"
          },
          {
            "label": "D",
            "text": "graph"
          }
        ],
        "answer": "C",
        "explanation": "\"Visual analysis of graphed data is a conservative method for determining the significance of behavior change; only variables able to produce meaningful effects repeatedly are considered significant, and weak and unstable variables are screened out.\" is the chapter's own definition of data.",
        "topic": "Key terms",
        "sourceHint": "Visual analysis of graphed data is a conservative method for determining the significance of behavior change; only variables able to produce meaningful effects repeatedly are considered significant, and weak and unstable variables are screened out."
      },
      {
        "id": "Q4",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"The term local response rate refers to the rate of response during periods smal ler than that for which an overall rate has Figure 6.12, the learner exhibited a local rate of responding during interspersal training (Slope b-c) that was considerably higher than his overall rate for that condition.\"",
        "options": [
          {
            "label": "A",
            "text": "data"
          },
          {
            "label": "B",
            "text": "local response rate"
          },
          {
            "label": "C",
            "text": "graph"
          },
          {
            "label": "D",
            "text": "level"
          }
        ],
        "answer": "B",
        "explanation": "\"The term local response rate refers to the rate of response during periods smal ler than that for which an overall rate has Figure 6.12, the learner exhibited a local rate of responding during interspersal training (Slope b-c) that was considerably higher than his overall rate for that condition.\" is the chapter's own definition of local response rate.",
        "topic": "Key terms",
        "sourceHint": "The term local response rate refers to the rate of response during periods smal ler than that for which an overall rate has Figure 6.12, the learner exhibited a local rate of responding during interspersal training (Slope b-c) that was considerably higher than his overall rate for that condition."
      },
      {
        "id": "Q5",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"An overall response rate is the average rate of response over a given time period, such as during a specific session, phase, or condition of an experiment.\"",
        "options": [
          {
            "label": "A",
            "text": "overall response rate"
          },
          {
            "label": "B",
            "text": "graph"
          },
          {
            "label": "C",
            "text": "level"
          },
          {
            "label": "D",
            "text": "data"
          }
        ],
        "answer": "A",
        "explanation": "\"An overall response rate is the average rate of response over a given time period, such as during a specific session, phase, or condition of an experiment.\" is the chapter's own definition of overall response rate.",
        "topic": "Key terms",
        "sourceHint": "An overall response rate is the average rate of response over a given time period, such as during a specific session, phase, or condition of an experiment."
      },
      {
        "id": "Q6",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Variability refers to the frequency and degree to which multiple measures of behavior yield different outcomes.\"",
        "options": [
          {
            "label": "A",
            "text": "graph"
          },
          {
            "label": "B",
            "text": "level"
          },
          {
            "label": "C",
            "text": "data"
          },
          {
            "label": "D",
            "text": "variability"
          }
        ],
        "answer": "D",
        "explanation": "\"Variability refers to the frequency and degree to which multiple measures of behavior yield different outcomes.\" is the chapter's own definition of variability.",
        "topic": "Key terms",
        "sourceHint": "Variability refers to the frequency and degree to which multiple measures of behavior yield different outcomes."
      }
    ],
    "reviewPrompts": [
      "Define \"graph\" in your own words, then check against the chapter glossary.",
      "Define \"level\" in your own words, then check against the chapter glossary.",
      "Define \"data\" in your own words, then check against the chapter glossary.",
      "Define \"local response rate\" in your own words, then check against the chapter glossary.",
      "Define \"overall response rate\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"Applied behavior analysts document and quantify behavior change by direct and repeated measurement of behavior, and the product of those measurements is called data..\"",
      "Restate this idea from the chapter in your own words: \"Graphs are relatively simple formats for visually displaying relationships among and between a series of measurements and relevant variables..\""
    ],
    "recap": [
      "Visual analysis of data across conditions determines whether change in level, trend, and/or variability occurred and to what extent any changes were significant.."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true,
      "misconceptions": true
    }
  },
  "07": {
    "meta": {
      "id": "07",
      "number": 7,
      "title": "Analyzing Behavior Change: Basic Assumptions and Strategies",
      "subtitle": "Functional relations, IV/DV, single-subject logic",
      "part": "Part 3 - Evaluating and Analyzing Behavior Change",
      "bacb": [
        "D-1",
        "D-2",
        "D-3",
        "D-4",
        "D-5",
        "D-6"
      ]
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [
      {
        "id": "D-1",
        "text": "Distinguish between dependent and independent variables."
      },
      {
        "id": "D-2",
        "text": "Distinguish between internal and external validity."
      },
      {
        "id": "D-3",
        "text": "Ident ify the defining features of sing le-subject experimental designs (e.g., individuals serve as their ow n controls, repeated."
      },
      {
        "id": "D-4",
        "text": "Describe the advantages of sing le-subject experimental designs compared to group designs."
      },
      {
        "id": "D-5",
        "text": "Use single-subject experimental designs (e.g., reversal, multiple baseline, mu ltielement, changing criterion)."
      },
      {
        "id": "D-6",
        "text": "Describe rationales for conducting comparative, component, and parametric ana lyses."
      }
    ],
    "coreConcepts": [
      {
        "title": "Introduction",
        "body": [
          "A useful technology of behavior change depends upon knowing that specific arrangements of environmental variables will reliably produce desired forms of behavior change."
        ],
        "bullets": [
          "An experimental analysis must be performed to determine how a given behavior functions in relation to specific environmental events."
        ]
      },
      {
        "title": "Behavior",
        "body": [
          "The overall goal of science is to achieve an understanding of the phenomena under study-socially important behavior, in the case of applied behavior analysis."
        ],
        "bullets": [
          "Experimental control is achieved when a predictable change in behavior (the dependent variable) is reliably produced by the systematic manipulation of some aspect behavior changes, but measurement alone cannot reveal of the environment (the independent variable). why the behavior changes occurred.",
          "An analysis of a behavior has been achieved when a reliable functional relation between the behavior and some specified aspect of the environment has been demonstrated convincingly.",
          "A functional analysis does not eliminate the possibility that the behavior under investigation is also a function of other variables.",
          "An experiment that shows convincingly that changes in behavior are a function of the independent variable and not the result of uncontrolled or unknown variables has internal validity."
        ]
      },
      {
        "title": "Behavior Analysis",
        "body": [
          "The greatest potential benefits of science are derived from the third, and highest, level of scientific understanding, which comes from establishing experimental control."
        ],
        "bullets": []
      },
      {
        "title": "Guide Its Analysis",
        "body": [
          "Confounding variables exert unknown or uncontrolled influences on the dependent variable."
        ],
        "bullets": [
          "Because behavior is an individual phenomenon, the experimental strategy of behavior analysis features within-subject (or single-case) methods of analysis.",
          "Because behavior is a dynamic and continuous phenomenon that occurs in and changes through time, measuring behavior as it changes over time is a fundamental feature of appEed behavior analysis. ",
          "The assumption of determinism guides experimental method in behavior analysis.",
          "Experimental methods in behavior analysis also derive from the assumption that behavioral variability is extrinsic to the organism, not an inherent trait; that is, variability is imposed by environmental variables."
        ]
      },
      {
        "title": "Experiments",
        "body": [
          "A research question specifies what the investigator wants to learn from conducting the experiment; all aspects of an experiment's design and conduct should follow from it."
        ],
        "bullets": [
          "Experiments in applied behavior analysis are referred to as single-case research designs because the experimental logic for detecting and analyzing behavior change employs each subject as his or her own control.",
          "The dependent variable in an applied behavior analysis experiment is a measurable dimensional quantity of the target behavior.",
          "In addition to precise manipulation of the independent variable, the behavior analyst must hold constant all other aspects of the experimental setting-extraneous variables-to prevent unplanned environmental variation.",
          "When unplanned events or variations occur in the experimental setting, the behavior analyst must either wait out their effects or incorporate them into the design of the experiment."
        ]
      },
      {
        "title": "Steady State Strategy and Baseline Logic",
        "body": [
          "Steady state responding enables a form of inductive reasoning called baseline logic. Baseline logic entails three elements: prediction, verification, and replication."
        ],
        "bullets": [
          "The most common method for evaluating the effects of a given variable is to impose it on an ongoing measure of behavior obtained in its absence. These preintervention data serve as the baseline against which any observed changes in behavior when the independent variable is introduced can be compared.",
          "A baseline condition does not necessarily mean the absence of instruction or treatment per se, only the absence of a specific independent variable of experimental interest.",
          "In addition to the primary purpose of establishing a baseline as an objective basis for evaluating the effects of the independent variable, three other reasons for baseline data collection are: (a) Systematic observation of the target behavior prior to intervention sometimes yields information about antecedent-behavior-consequent correlations that may be useful in planning an effective intervention; (b) baseline data can provide valuable guidance in setting initial criteria for reinforcement; and (c) baseline data may reveal that the behavior targeted for change does not warrant intervention.",
          "Four types of baseline data patterns are stable, ascending, descending, and variable."
        ]
      },
      {
        "title": "Affirmation of the Consequent",
        "body": [
          "Prediction of future behavior can be made when repeated measures of behavior under relatively constant environmental conditions show little or no variation."
        ],
        "bullets": [
          "Practice effects refer to improvements in performance",
          "The predictive power of steady state responding enables a form of inductive reasoning known as affirmation of the consequent.",
          "Although the logic of affirmation of the consequent is flawed (some other event may have caused the change in behavior), an effective experimental design confirms several if-A-then-B possibilities, each one reducing the likelihood that factors other than the independent variable are responsible for the observed changes in behavior.",
          "Verification is accomplished by demonstrating that the prior level of baseline responding would have remained unchanged had the independent variable not been resulting from opportunities to emit the behavior that must introduced. be provided to obtain repeated measures."
        ]
      }
    ],
    "glossary": [
      {
        "term": "A-B design",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "experimental design",
        "definition": "Manipulation of the Independent Variable: Experimental Design Experimental design refers to the particular arrangement of conditions in a study so that meaningful comparisons of the effects of the presence, absence, or different values of the independent variable can be made.",
        "sourceHint": "Manipulation of the Independent Variable: Experimental Design Experimental design refers to the particular arrangement of conditions in a study so that meaningful comparisons of the effects of the presence, absence, or different values of the independent variable can be made."
      },
      {
        "term": "replication",
        "definition": "Replication The six measures within the shaded area obtained during Replication is the essence of believability.",
        "sourceHint": "Replication The six measures within the shaded area obtained during Replication is the essence of believability."
      },
      {
        "term": "affirmation of the consequent",
        "definition": "Again, the reasoning behind affirmation of the consequent is the logic that underlies the experimental strategy.",
        "sourceHint": "Again, the reasoning behind affirmation of the consequent is the logic that underlies the experimental strategy."
      },
      {
        "term": "external validity",
        "definition": "External validity refers to the degree to which a study's results are generalizable to other subjects, settings, and/ group, enable probability statements about the average perforor behaviors.",
        "sourceHint": "External validity refers to the degree to which a study's results are generalizable to other subjects, settings, and/ group, enable probability statements about the average perforor behaviors."
      },
      {
        "term": "single-case designs",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "ascend ing baseline",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "extraneous var iable",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "stable baseline",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "baseline",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "independent variable",
        "definition": "Therefore, the independent variable is a controlling varito respond, the child would begin to emit the target behavior at a nonzero level.",
        "sourceHint": "Therefore, the independent variable is a controlling varito respond, the child would begin to emit the target behavior at a nonzero level."
      },
      {
        "term": "steady state responding",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "baseline logic",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "internal validity",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "steady state strategy",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "confounding variable",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "parametric analysis",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "variable basel ine",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "dependent variable",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "practice effects",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "verification",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "descending baseline",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "prediction",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "experimental control",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "research question",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Distinguish between dependent and independent variables.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Distinguish between internal and external validity.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "easurement shows whether, when, and how much",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "behavior has changed, but measurement alone does",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "For example, although administrators and taxpayers may be justifiably interested in the average increase in students' reading comprehension from grade level to grade level, such information is of little use to the classroom teacher who must decide how to improve a given student's comprehension skills.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, although administrators and taxpayers may be justifiably interested in the average increase in students' reading comprehension from grade level to grade level, such information is of little use to the classroom teacher who must decide how to improve a given student's comprehension skills."
      },
      {
        "scenario": "For example, in a classic study analyzing the effects of the self-recording by a junior high school girl on her classroom study behavior, Brofor the group may not be representative of any individual subject.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, in a classic study analyzing the effects of the self-recording by a junior high school girl on her classroom study behavior, Brofor the group may not be representative of any individual subject."
      },
      {
        "scenario": "For example, perhaps two separate treatments are evaluated as well as the effects of a third treatment, which is a combination of both variables.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, perhaps two separate treatments are evaluated as well as the effects of a third treatment, which is a combination of both variables."
      },
      {
        "scenario": "For example, baseline observations revealing that a child' s disruptive outbursts are consistently followed by parent or teacher attention can be used in designing an intervention of ignoring outbursts and contingent attention following desired behavior.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, baseline observations revealing that a child' s disruptive outbursts are consistently followed by parent or teacher attention can be used in designing an intervention of ignoring outbursts and contingent attention following desired behavior."
      }
    ],
    "comparisons": [],
    "misconceptions": [
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "A functional analysis does not eliminate the possibility that the behavior under investigation is also a function of other variables.",
        "sourceHint": "A functional analysis does not eliminate the possibility that the behavior under investigation is also a function of other variables."
      },
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "A baseline condition does not necessarily mean the absence of instruction or treatment per se, only the absence of a specific independent variable of experimental interest.",
        "sourceHint": "A baseline condition does not necessarily mean the absence of instruction or treatment per se, only the absence of a specific independent variable of experimental interest."
      },
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "The independent variable should not be introduced when an ascending or descending baseline indicates improving performance.",
        "sourceHint": "The independent variable should not be introduced when an ascending or descending baseline indicates improving performance."
      },
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "An independent variable should not be imposed on a highly variable, unstable baseline.",
        "sourceHint": "An independent variable should not be imposed on a highly variable, unstable baseline."
      }
    ],
    "examChecklist": [
      "Address objective D-1: Distinguish between dependent and independent variables.",
      "Address objective D-2: Distinguish between internal and external validity.",
      "Address objective D-3: Ident ify the defining features of sing le-subject experimental designs (e.g., individuals serve as their ow n controls, repeated.",
      "Address objective D-4: Describe the advantages of sing le-subject experimental designs compared to group designs.",
      "Address objective D-5: Use single-subject experimental designs (e.g., reversal, multiple baseline, mu ltielement, changing criterion).",
      "Address objective D-6: Describe rationales for conducting comparative, component, and parametric ana lyses.",
      "Define \"experimental design\" from memory and match the source text.",
      "Define \"replication\" from memory and match the source text.",
      "Define \"affirmation of the consequent\" from memory and match the source text.",
      "Define \"external validity\" from memory and match the source text.",
      "Define \"independent variable\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Manipulation of the Independent Variable: Experimental Design Experimental design refers to the particular arrangement of conditions in a study so that meaningful comparisons of the effects of the presence, absence, or different values of the independent variable can be made.\"",
        "options": [
          {
            "label": "A",
            "text": "experimental design"
          },
          {
            "label": "B",
            "text": "replication"
          },
          {
            "label": "C",
            "text": "affirmation of the consequent"
          },
          {
            "label": "D",
            "text": "external validity"
          }
        ],
        "answer": "A",
        "explanation": "\"Manipulation of the Independent Variable: Experimental Design Experimental design refers to the particular arrangement of conditions in a study so that meaningful comparisons of the effects of the presence, absence, or different values of the independent variable can be made.\" is the chapter's own definition of experimental design.",
        "topic": "Key terms",
        "sourceHint": "Manipulation of the Independent Variable: Experimental Design Experimental design refers to the particular arrangement of conditions in a study so that meaningful comparisons of the effects of the presence, absence, or different values of the independent variable can be made."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Replication The six measures within the shaded area obtained during Replication is the essence of believability.\"",
        "options": [
          {
            "label": "A",
            "text": "experimental design"
          },
          {
            "label": "B",
            "text": "affirmation of the consequent"
          },
          {
            "label": "C",
            "text": "external validity"
          },
          {
            "label": "D",
            "text": "replication"
          }
        ],
        "answer": "D",
        "explanation": "\"Replication The six measures within the shaded area obtained during Replication is the essence of believability.\" is the chapter's own definition of replication.",
        "topic": "Key terms",
        "sourceHint": "Replication The six measures within the shaded area obtained during Replication is the essence of believability."
      },
      {
        "id": "Q3",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Again, the reasoning behind affirmation of the consequent is the logic that underlies the experimental strategy.\"",
        "options": [
          {
            "label": "A",
            "text": "replication"
          },
          {
            "label": "B",
            "text": "external validity"
          },
          {
            "label": "C",
            "text": "affirmation of the consequent"
          },
          {
            "label": "D",
            "text": "experimental design"
          }
        ],
        "answer": "C",
        "explanation": "\"Again, the reasoning behind affirmation of the consequent is the logic that underlies the experimental strategy.\" is the chapter's own definition of affirmation of the consequent.",
        "topic": "Key terms",
        "sourceHint": "Again, the reasoning behind affirmation of the consequent is the logic that underlies the experimental strategy."
      },
      {
        "id": "Q4",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"External validity refers to the degree to which a study's results are generalizable to other subjects, settings, and/ group, enable probability statements about the average perforor behaviors.\"",
        "options": [
          {
            "label": "A",
            "text": "affirmation of the consequent"
          },
          {
            "label": "B",
            "text": "external validity"
          },
          {
            "label": "C",
            "text": "experimental design"
          },
          {
            "label": "D",
            "text": "replication"
          }
        ],
        "answer": "B",
        "explanation": "\"External validity refers to the degree to which a study's results are generalizable to other subjects, settings, and/ group, enable probability statements about the average perforor behaviors.\" is the chapter's own definition of external validity.",
        "topic": "Key terms",
        "sourceHint": "External validity refers to the degree to which a study's results are generalizable to other subjects, settings, and/ group, enable probability statements about the average perforor behaviors."
      },
      {
        "id": "Q5",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Therefore, the independent variable is a controlling varito respond, the child would begin to emit the target behavior at a nonzero level.\"",
        "options": [
          {
            "label": "A",
            "text": "independent variable"
          },
          {
            "label": "B",
            "text": "experimental design"
          },
          {
            "label": "C",
            "text": "replication"
          },
          {
            "label": "D",
            "text": "affirmation of the consequent"
          }
        ],
        "answer": "A",
        "explanation": "\"Therefore, the independent variable is a controlling varito respond, the child would begin to emit the target behavior at a nonzero level.\" is the chapter's own definition of independent variable.",
        "topic": "Key terms",
        "sourceHint": "Therefore, the independent variable is a controlling varito respond, the child would begin to emit the target behavior at a nonzero level."
      }
    ],
    "reviewPrompts": [
      "Define \"experimental design\" in your own words, then check against the chapter glossary.",
      "Define \"replication\" in your own words, then check against the chapter glossary.",
      "Define \"affirmation of the consequent\" in your own words, then check against the chapter glossary.",
      "Define \"external validity\" in your own words, then check against the chapter glossary.",
      "Define \"independent variable\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"Measurement can show whether, when, and how much.\"",
      "Restate this idea from the chapter in your own words: \"A useful technology of behavior change depends upon knowing that specific arrangements of environmental variables will reliably produce desired forms of behavior change..\""
    ],
    "recap": [
      "Replication within an experiment means reproducing a previously observed behavior change by reintroducing the behaviors that have no logical opportunity to occur."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true
    }
  },
  "08": {
    "meta": {
      "id": "08",
      "number": 8,
      "title": "Reversal and Multielement Designs",
      "subtitle": "A-B-A-B, NCR, alternating treatments",
      "part": "Part 3 - Evaluating and Analyzing Behavior Change",
      "bacb": [
        "D-1",
        "D-3",
        "D-5",
        "D-6"
      ]
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [
      {
        "id": "D-1",
        "text": "Distinguish between dependent and independent variables."
      },
      {
        "id": "D-3",
        "text": "Identify the defining features of sing le-subject experimental designs (e.g., ind ividuals serve as their own controls, repeated."
      },
      {
        "id": "D-5",
        "text": "Use single-subject experimental designs (e.g ., reversal, multiple baseline, mu ltielement, changing criterion)."
      },
      {
        "id": "D-6",
        "text": "Describe rationales for conducting comparative, component, and parametric analyses."
      }
    ],
    "coreConcepts": [
      {
        "title": "Reversal Design",
        "body": [
          "The reversal tactic (A-B-A) entails repeated measures of behavior in a given setting during three consecutive phases: (a) baseline (independent variable absent), (b) treatment (independent variable present), and (c) return to baseline (independent variable absent)."
        ],
        "bullets": [
          "Reintroducing the independent variable in the form of an A-B-A-B design strengthens the reversal design tremendously. The A-B-A-B design is the most straightforward and generally most powerful intrasubject design for demonstrating functional relations."
        ]
      },
      {
        "title": "Variations of the A-8-A-B Design",
        "body": [
          "Extending the A-B-A-B design with repeated reversals may provide a more convincing demonstration of a functional relation than a design with one reversal."
        ],
        "bullets": [
          "The B-A-B reversal design can be used with target behaviors for which an initial baseline phase is inappropriate or not possible for ethical or practical reasons.",
          "Multiple treatment reversal designs (e.g., A-B-A-B-C-B-C, A-B-C-A-C-B-C) use the reversal tactic to compare the effects of two or more experimental conditions to baseline and/or to one another.",
          "The noncontingent reinforcement (NCR) reversal technique enables the isolation and analysis of the contingent aspect of reinforcement.",
          "Reversal techniques incorporating differential reinforcement control conditions (DRO and DRI/DRA) can also be used to analyze the effects of contingent reinforcement. 192 Part 3 • Evaluating and Analyzing Behavior Change"
        ]
      },
      {
        "title": "Considering the Appropriateness of the Reversal Design",
        "body": [
          "Experimental designs featuring the reversal tactic are ineffective in evaluating the effects of treatment variables that, by their very nature, cannot be withdrawn once presented (e.g., instruction, modeling)."
        ],
        "bullets": [
          "Once changed during treatment, some behaviors will not reverse to baseline levels when the independent variprecludes effective use of the reversal design. • Two-phase design: initial baseline and comparison phase • Three-phase design: initial baseline, alternating treatments, and best treatment only • Three-phase design: initial baseline, alternating treatments, and participant's choice • Concurrent chains (or schedule) design able has been withdrawn. Such behavioral irreversibility"
        ]
      },
      {
        "title": "Advantages of the Multielement Design",
        "body": [
          "Withdrawing a seemingly effective treatment variable to provide scientific verification of its function in changing behavior may raise legitimate social, educational, and ethical concerns."
        ],
        "bullets": []
      },
      {
        "title": "Multielement Design",
        "body": [
          "The multielement design (also called alternating treatments design) compares two or more treatments (i.e., independent variables) while their effects on the target behavior (i.e., dependent variable) are measured."
        ],
        "bullets": [
          "In a multielement design, each successive data point the prediction of future levels of responding under that treatment, (b) potential verification of the previous prediction of performance under that treatment, and (c) the opportunity for replication of previous effects produced by that treatment.",
          "Experimental control is demonstrated in a multielement design when the data paths for two different treatments show little or no overlap. • Can be used with unstable data patterns. • Can assess generalization of effects. • Intervention can begin immediately."
        ]
      },
      {
        "title": "Multielement Design",
        "body": [
          "The rapid back-and-forth switching of treatment conditions does not typify clinical or education practice and may be viewed as artificial and undesirable."
        ],
        "bullets": []
      },
      {
        "title": "Variations of the Multielement Design",
        "body": [
          "Multielement designs are not effective for assessing the effects of independent variables that change behavior only when implemented over a continuous period of time."
        ],
        "bullets": []
      }
    ],
    "glossary": [
      {
        "term": "multiple treatment reversal design",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "adapted alternating treatments",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "reversal technique",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "design",
        "definition": "Repeated Reversals Perhaps the most obvious variation of the A-B-A-B reversal design is a simple extension in which the independent variable is withdrawn and reintroduced once again (A-B-A-B-A-B).",
        "sourceHint": "Repeated Reversals Perhaps the most obvious variation of the A-B-A-B reversal design is a simple extension in which the independent variable is withdrawn and reintroduced once again (A-B-A-B-A-B)."
      },
      {
        "term": "irreversibility",
        "definition": "Behavioral irreversibility means that a level of behavior observed in an earlier phase cannot be reproduced even though the experimental conditions are the same as they were during the earlier phase (Sidman, 1960).",
        "sourceHint": "Behavioral irreversibility means that a level of behavior observed in an earlier phase cannot be reproduced even though the experimental conditions are the same as they were during the earlier phase (Sidman, 1960)."
      },
      {
        "term": "reversal design",
        "definition": "Repeated Reversals Perhaps the most obvious variation of the A-B-A-B reversal design is a simple extension in which the independent variable is withdrawn and reintroduced once again (A-B-A-B-A-B).",
        "sourceHint": "Repeated Reversals Perhaps the most obvious variation of the A-B-A-B reversal design is a simple extension in which the independent variable is withdrawn and reintroduced once again (A-B-A-B-A-B)."
      },
      {
        "term": "alternating treatments design",
        "definition": "Treatment Withdrawal Not Required A major advantage of the alternating treatments design is that it does not require the investigator to withdraw a seemingly effective treatment to demonstrate a functional relation.",
        "sourceHint": "Treatment Withdrawal Not Required A major advantage of the alternating treatments design is that it does not require the investigator to withdraw a seemingly effective treatment to demonstrate a functional relation."
      },
      {
        "term": "multielement design",
        "definition": "Mult iple Treatment Interf erence The fundamental feature of the multielement design is the rapid alternation of two or more independent variables irrespective of the behavioral measures obtained under each treatment.",
        "sourceHint": "Mult iple Treatment Interf erence The fundamental feature of the multielement design is the rapid alternation of two or more independent variables irrespective of the behavioral measures obtained under each treatment."
      },
      {
        "term": "sequence effects",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "multiple treatment interference",
        "definition": "Multiple treatment interference refers to the confounding effects of one treatment on a subject's behavior being influenced by the effects of another treatment administered in the same study.",
        "sourceHint": "Multiple treatment interference refers to the confounding effects of one treatment on a subject's behavior being influenced by the effects of another treatment administered in the same study."
      },
      {
        "term": "withdrawal design",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Distinguish between dependent and independent variables.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "designs, two single-case research tactics used widely",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "design are reported",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "For example, the analyst must dition are lost during a condition in which equal amounts of the same consequence are delivered independent of the occurrence of the target behavior, a functional relation between the reinforceevents in practice: After baseline (A), an initial treatment (B) ment contingency and behavior change may be demonstrated.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, the analyst must dition are lost during a condition in which equal amounts of the same consequence are delivered independent of the occurrence of the target behavior, a functional relation between the reinforceevents in practice: After baseline (A), an initial treatment (B) ment contingency and behavior change may be demonstrated."
      },
      {
        "scenario": "For example, Latta) (1969) employed forcement of alternative behavior (ORA) reversal techniques described next, is a multiple treatment design.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, Latta) (1969) employed forcement of alternative behavior (ORA) reversal techniques described next, is a multiple treatment design."
      },
      {
        "scenario": "For example, the Baer and Wolf ( l 970a) study of social reinforcement shown in Figure 8.6 used an A-B-C-B-C design, with B representing the NCR conditions and C representing the contingent reinforcement conditions.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, the Baer and Wolf ( l 970a) study of social reinforcement shown in Figure 8.6 used an A-B-C-B-C design, with B representing the NCR conditions and C representing the contingent reinforcement conditions."
      },
      {
        "scenario": "Although independent variables involving reinforcement and punishment contingencies can be manipulated with some certainty-the experimenter either such as providing information or modeling, once presented, cannot simply be removed.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Although independent variables involving reinforcement and punishment contingencies can be manipulated with some certainty-the experimenter either such as providing information or modeling, once presented, cannot simply be removed."
      }
    ],
    "comparisons": [],
    "misconceptions": [
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "The rapid back-and-forth switching of treatment conditions does not typify clinical or education practice and may be viewed as artificial and undesirable.",
        "sourceHint": "The rapid back-and-forth switching of treatment conditions does not typify clinical or education practice and may be viewed as artificial and undesirable."
      },
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "Multielement designs are not effective for assessing the effects of independent variables that change behavior only when implemented over a continuous period of time.",
        "sourceHint": "Multielement designs are not effective for assessing the effects of independent variables that change behavior only when implemented over a continuous period of time."
      }
    ],
    "examChecklist": [
      "Address objective D-1: Distinguish between dependent and independent variables.",
      "Address objective D-3: Identify the defining features of sing le-subject experimental designs (e.g., ind ividuals serve as their own controls, repeated.",
      "Address objective D-5: Use single-subject experimental designs (e.g ., reversal, multiple baseline, mu ltielement, changing criterion).",
      "Address objective D-6: Describe rationales for conducting comparative, component, and parametric analyses.",
      "Define \"design\" from memory and match the source text.",
      "Define \"irreversibility\" from memory and match the source text.",
      "Define \"reversal design\" from memory and match the source text.",
      "Define \"alternating treatments design\" from memory and match the source text.",
      "Define \"multielement design\" from memory and match the source text.",
      "Define \"multiple treatment interference\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Repeated Reversals Perhaps the most obvious variation of the A-B-A-B reversal design is a simple extension in which the independent variable is withdrawn and reintroduced once again (A-B-A-B-A-B).\"",
        "options": [
          {
            "label": "A",
            "text": "design"
          },
          {
            "label": "B",
            "text": "irreversibility"
          },
          {
            "label": "C",
            "text": "reversal design"
          },
          {
            "label": "D",
            "text": "alternating treatments design"
          }
        ],
        "answer": "A",
        "explanation": "\"Repeated Reversals Perhaps the most obvious variation of the A-B-A-B reversal design is a simple extension in which the independent variable is withdrawn and reintroduced once again (A-B-A-B-A-B).\" is the chapter's own definition of design.",
        "topic": "Key terms",
        "sourceHint": "Repeated Reversals Perhaps the most obvious variation of the A-B-A-B reversal design is a simple extension in which the independent variable is withdrawn and reintroduced once again (A-B-A-B-A-B)."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Behavioral irreversibility means that a level of behavior observed in an earlier phase cannot be reproduced even though the experimental conditions are the same as they were during the earlier phase (Sidman, 1960).\"",
        "options": [
          {
            "label": "A",
            "text": "design"
          },
          {
            "label": "B",
            "text": "reversal design"
          },
          {
            "label": "C",
            "text": "alternating treatments design"
          },
          {
            "label": "D",
            "text": "irreversibility"
          }
        ],
        "answer": "D",
        "explanation": "\"Behavioral irreversibility means that a level of behavior observed in an earlier phase cannot be reproduced even though the experimental conditions are the same as they were during the earlier phase (Sidman, 1960).\" is the chapter's own definition of irreversibility.",
        "topic": "Key terms",
        "sourceHint": "Behavioral irreversibility means that a level of behavior observed in an earlier phase cannot be reproduced even though the experimental conditions are the same as they were during the earlier phase (Sidman, 1960)."
      },
      {
        "id": "Q3",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Repeated Reversals Perhaps the most obvious variation of the A-B-A-B reversal design is a simple extension in which the independent variable is withdrawn and reintroduced once again (A-B-A-B-A-B).\"",
        "options": [
          {
            "label": "A",
            "text": "irreversibility"
          },
          {
            "label": "B",
            "text": "alternating treatments design"
          },
          {
            "label": "C",
            "text": "reversal design"
          },
          {
            "label": "D",
            "text": "design"
          }
        ],
        "answer": "C",
        "explanation": "\"Repeated Reversals Perhaps the most obvious variation of the A-B-A-B reversal design is a simple extension in which the independent variable is withdrawn and reintroduced once again (A-B-A-B-A-B).\" is the chapter's own definition of reversal design.",
        "topic": "Key terms",
        "sourceHint": "Repeated Reversals Perhaps the most obvious variation of the A-B-A-B reversal design is a simple extension in which the independent variable is withdrawn and reintroduced once again (A-B-A-B-A-B)."
      },
      {
        "id": "Q4",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Treatment Withdrawal Not Required A major advantage of the alternating treatments design is that it does not require the investigator to withdraw a seemingly effective treatment to demonstrate a functional relation.\"",
        "options": [
          {
            "label": "A",
            "text": "reversal design"
          },
          {
            "label": "B",
            "text": "alternating treatments design"
          },
          {
            "label": "C",
            "text": "design"
          },
          {
            "label": "D",
            "text": "irreversibility"
          }
        ],
        "answer": "B",
        "explanation": "\"Treatment Withdrawal Not Required A major advantage of the alternating treatments design is that it does not require the investigator to withdraw a seemingly effective treatment to demonstrate a functional relation.\" is the chapter's own definition of alternating treatments design.",
        "topic": "Key terms",
        "sourceHint": "Treatment Withdrawal Not Required A major advantage of the alternating treatments design is that it does not require the investigator to withdraw a seemingly effective treatment to demonstrate a functional relation."
      },
      {
        "id": "Q5",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Mult iple Treatment Interf erence The fundamental feature of the multielement design is the rapid alternation of two or more independent variables irrespective of the behavioral measures obtained under each treatment.\"",
        "options": [
          {
            "label": "A",
            "text": "multielement design"
          },
          {
            "label": "B",
            "text": "design"
          },
          {
            "label": "C",
            "text": "irreversibility"
          },
          {
            "label": "D",
            "text": "reversal design"
          }
        ],
        "answer": "A",
        "explanation": "\"Mult iple Treatment Interf erence The fundamental feature of the multielement design is the rapid alternation of two or more independent variables irrespective of the behavioral measures obtained under each treatment.\" is the chapter's own definition of multielement design.",
        "topic": "Key terms",
        "sourceHint": "Mult iple Treatment Interf erence The fundamental feature of the multielement design is the rapid alternation of two or more independent variables irrespective of the behavioral measures obtained under each treatment."
      },
      {
        "id": "Q6",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Multiple treatment interference refers to the confounding effects of one treatment on a subject's behavior being influenced by the effects of another treatment administered in the same study.\"",
        "options": [
          {
            "label": "A",
            "text": "design"
          },
          {
            "label": "B",
            "text": "irreversibility"
          },
          {
            "label": "C",
            "text": "reversal design"
          },
          {
            "label": "D",
            "text": "multiple treatment interference"
          }
        ],
        "answer": "D",
        "explanation": "\"Multiple treatment interference refers to the confounding effects of one treatment on a subject's behavior being influenced by the effects of another treatment administered in the same study.\" is the chapter's own definition of multiple treatment interference.",
        "topic": "Key terms",
        "sourceHint": "Multiple treatment interference refers to the confounding effects of one treatment on a subject's behavior being influenced by the effects of another treatment administered in the same study."
      }
    ],
    "reviewPrompts": [
      "Define \"design\" in your own words, then check against the chapter glossary.",
      "Define \"irreversibility\" in your own words, then check against the chapter glossary.",
      "Define \"reversal design\" in your own words, then check against the chapter glossary.",
      "Define \"alternating treatments design\" in your own words, then check against the chapter glossary.",
      "Define \"multielement design\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"Reintroducing the independent variable in the form of an A-B-A-B design strengthens the reversal design tremendously.\"",
      "What is the single most important takeaway from \"Reversal and Multielement Designs\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "Multielement designs are not effective for assessing the effects of independent variables that change behavior only when implemented over a continuous period of time.."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true
    }
  },
  "09": {
    "meta": {
      "id": "09",
      "number": 9,
      "title": "Multiple Baseline and Changing Criterion Designs",
      "subtitle": "Across behaviors / subjects / settings; probe variants",
      "part": "Part 3 - Evaluating and Analyzing Behavior Change",
      "bacb": []
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [],
    "coreConcepts": [
      {
        "title": "Multiple Baseline Design",
        "body": [
          "In a multiple baseline design, simultaneous baseline measurement is begun on two or more behaviors. After stable baseline responding has been achieved, the independent variable is applied to one of the behaviors while baseline conditions remain in effect for the other behavior(s). After maximum change has been noted in the first behavior, the independent variable is applied in sequential fashion to the other behaviors in the design."
        ],
        "bullets": [
          "Experimental control is demonstrated in a multiple baseline design by each behavior changing when, and only when, the independent variable is applied."
        ]
      },
      {
        "title": "Variations of the Multiple Baseline Design",
        "body": [
          "The multiple probe design is effective for evaluating the effects of instruction on skill sequences in which it is highly unlikely that the participant's performance on later steps in the sequence can improve without instruction or mastery of the earlier steps in the chain. The multiple probe design is also appropriate for situations in which prolonged baseline measurement may prove reactive, impractical, or too costly. 214 Part 3 • Evaluating and Analyzing Behavior Change"
        ],
        "bullets": [
          "In a multiple probe design, intermittent measures, or probes, are taken on all of the behaviors in the design at the outset of the experiment. Thereafter, probes are taken each time the subject masters one of the behaviors or skills in the sequence. Just prior to instruction on each behavior, a series of baseline measures is taken until stability is achieved.",
          "In a delayed multiple baseline design, baseline measurement of subsequent behaviors is begun sometime after baseline measurement began on earlier behaviors in the design. Only baselines begun while earlier behaviors in the design are still under baseline conditions can be used to verify predictions made for the earlier behaviors.",
          "Limitations of the delayed multiple baseline design include the following: (a) The behavior analyst may have to wait too long to modify certain behaviors; (b) baseline phases may contain too few data points, and (c) baselines begun after the independent variable has been applied to earlier behaviors in the design can mask the interdependence (covariation) of behaviors.",
          "The nonconcurrent multiple baseline across participants design consists of a series of A-B (baseline-intervention) sequences conducted across subjects at different points in time."
        ]
      },
      {
        "title": "Baseline Designs",
        "body": [
          "Behaviors that are part of multiple baseline designs should the independent variable is applied to it."
        ],
        "bullets": [
          "Behaviors in a multiple baseline design should be mea-",
          "In a multiple baseline design, the independent variable should not be applied to the next behavior until the previous behavior has changed maximally and a sufficient"
        ]
      },
      {
        "title": "Changing Criterion Design",
        "body": [
          "After stable baseline responding has been achieved, the first treatment phase is begun, in which reinforcement is usually contingent on the subject performing at a specified sured concurrently and have an equal opportunity of being level (criterion). The design entails a series of treatment influenced by the same set of relevant variables. phases, each requiring an improved level of performance over the previous phase. Experimental control is demonstrated when the subject's behavior closely conforms to the changing criteria. "
        ],
        "bullets": [
          "In a range-bound changing criterion design, each intervention sub-phase includes both a lower and an upper criterion within which the subject is expected to perform.",
          "Three features combine to determine the potential for a changing criterion design to demonstrate experimental control: (a) the length of phases, (b) the magnitude of criterion changes, and (c) the number of criterion changes. The believability of the changing criterion design is enhanced if a previous criterion is reinstated and the subj ect's behavior reverses to the level previously observed under that criterion."
        ]
      },
      {
        "title": "Considering the Appropriateness",
        "body": [
          "of the Changing Criterion Design"
        ],
        "bullets": [
          "Limitations of the changing criterion design are (a) the target behavior must already be in the subject's repertoire, and (b) incorporating the necessary features of the design may impede optimal learning rates."
        ]
      }
    ],
    "glossary": [
      {
        "term": "changing criterion design",
        "definition": "Considering the Appropriateness The changing criterion design is a useful addition to the behavior analyst's set of tactics for evaluating systematic behav- changes in the rate, accuracy, duration , or latency of a single ior change.",
        "sourceHint": "Considering the Appropriateness The changing criterion design is a useful addition to the behavior analyst's set of tactics for evaluating systematic behav- changes in the rate, accuracy, duration , or latency of a single ior change."
      },
      {
        "term": "multiple baseline across settings design",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "multiple pro be design",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "delayed multiple baseline design",
        "definition": "A third limitation of the delayed multiple baseline design is that it can mask the interdependence of dependent variables .",
        "sourceHint": "A third limitation of the delayed multiple baseline design is that it can mask the interdependence of dependent variables ."
      },
      {
        "term": "multiple baseline across subjects",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "nonconcu rrent multiple baseline",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "multiple baseline across behaviors",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "design",
        "definition": "The same pattern of results was obtained for each of the other four players in the study, illustrating that the multiple baseline across behaviors design is a single-subject experimental strategy in which each subject serves as his own control.",
        "sourceHint": "The same pattern of results was obtained for each of the other four players in the study, illustrating that the multiple baseline across behaviors design is a single-subject experimental strategy in which each subject serves as his own control."
      },
      {
        "term": "across partici pants design",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "multiple baseline design",
        "definition": "A third limitation of the delayed multiple baseline design is that it can mask the interdependence of dependent variables .",
        "sourceHint": "A third limitation of the delayed multiple baseline design is that it can mask the interdependence of dependent variables ."
      },
      {
        "term": "range-bound changing criterion design",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Distinguish between dependent and independent variables.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "his chapter describes two additional experimental tactics",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Baseline Design",
        "definition": "A third limitation of the delayed multiple baseline design is that it can mask the interdependence of dependent variables .",
        "sourceHint": "A third limitation of the delayed multiple baseline design is that it can mask the interdependence of dependent variables ."
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "Jason, who had been diagnosed with autism, cerebral palsy, and moderate intellectual disabilities, had a history of putting objects such as toys, cloth, paper, tree bark, plants, and dirt into his mouth.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Jason, who had been diagnosed with autism, cerebral palsy, and moderate intellectual disabilities, had a history of putting objects such as toys, cloth, paper, tree bark, plants, and dirt into his mouth."
      },
      {
        "scenario": "For example, in a study by Parker and colleagues (1984), the presence or absence of other people in the training room constituted the different settings (environments) in which the effects of the independent variable were evaluated.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, in a study by Parker and colleagues (1984), the presence or absence of other people in the training room constituted the different settings (environments) in which the effects of the independent variable were evaluated."
      },
      {
        "scenario": "For example, Van Houten and Malenfant (2004) used a multiple baseline design across two crosswalks on busy streets to evaluate the effects of an intensive were obtained for Sara, the sharp downward trend in the data driver enforcement program on the percentage of drivers yield- indicated she should receive safety training first.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, Van Houten and Malenfant (2004) used a multiple baseline design across two crosswalks on busy streets to evaluate the effects of an intensive were obtained for Sara, the sharp downward trend in the data driver enforcement program on the percentage of drivers yield- indicated she should receive safety training first."
      },
      {
        "scenario": "For example, the repeated measurement of a student's accuracy in solving division problems when the student possesses no skills in addition, subtraction, and multiplication would add little to an analysis.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, the repeated measurement of a student's accuracy in solving division problems when the student possesses no skills in addition, subtraction, and multiplication would add little to an analysis."
      }
    ],
    "comparisons": [],
    "misconceptions": [
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "The nonconcurrent design entails two of three elements of baseline logic-prediction and replication-but the absence of concurrent baseline measures does not enable verification of intervention effects.",
        "sourceHint": "The nonconcurrent design entails two of three elements of baseline logic-prediction and replication-but the absence of concurrent baseline measures does not enable verification of intervention effects."
      }
    ],
    "examChecklist": [
      "Define \"changing criterion design\" from memory and match the source text.",
      "Define \"delayed multiple baseline design\" from memory and match the source text.",
      "Define \"design\" from memory and match the source text.",
      "Define \"multiple baseline design\" from memory and match the source text.",
      "Define \"Baseline Design\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Considering the Appropriateness The changing criterion design is a useful addition to the behavior analyst's set of tactics for evaluating systematic behav- changes in the rate, accuracy, duration , or latency of a single ior change.\"",
        "options": [
          {
            "label": "A",
            "text": "changing criterion design"
          },
          {
            "label": "B",
            "text": "delayed multiple baseline design"
          },
          {
            "label": "C",
            "text": "design"
          },
          {
            "label": "D",
            "text": "multiple baseline design"
          }
        ],
        "answer": "A",
        "explanation": "\"Considering the Appropriateness The changing criterion design is a useful addition to the behavior analyst's set of tactics for evaluating systematic behav- changes in the rate, accuracy, duration , or latency of a single ior change.\" is the chapter's own definition of changing criterion design.",
        "topic": "Key terms",
        "sourceHint": "Considering the Appropriateness The changing criterion design is a useful addition to the behavior analyst's set of tactics for evaluating systematic behav- changes in the rate, accuracy, duration , or latency of a single ior change."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"A third limitation of the delayed multiple baseline design is that it can mask the interdependence of dependent variables .\"",
        "options": [
          {
            "label": "A",
            "text": "changing criterion design"
          },
          {
            "label": "B",
            "text": "design"
          },
          {
            "label": "C",
            "text": "multiple baseline design"
          },
          {
            "label": "D",
            "text": "delayed multiple baseline design"
          }
        ],
        "answer": "D",
        "explanation": "\"A third limitation of the delayed multiple baseline design is that it can mask the interdependence of dependent variables .\" is the chapter's own definition of delayed multiple baseline design.",
        "topic": "Key terms",
        "sourceHint": "A third limitation of the delayed multiple baseline design is that it can mask the interdependence of dependent variables ."
      },
      {
        "id": "Q3",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"The same pattern of results was obtained for each of the other four players in the study, illustrating that the multiple baseline across behaviors design is a single-subject experimental strategy in which each subject serves as his own control.\"",
        "options": [
          {
            "label": "A",
            "text": "delayed multiple baseline design"
          },
          {
            "label": "B",
            "text": "multiple baseline design"
          },
          {
            "label": "C",
            "text": "design"
          },
          {
            "label": "D",
            "text": "changing criterion design"
          }
        ],
        "answer": "C",
        "explanation": "\"The same pattern of results was obtained for each of the other four players in the study, illustrating that the multiple baseline across behaviors design is a single-subject experimental strategy in which each subject serves as his own control.\" is the chapter's own definition of design.",
        "topic": "Key terms",
        "sourceHint": "The same pattern of results was obtained for each of the other four players in the study, illustrating that the multiple baseline across behaviors design is a single-subject experimental strategy in which each subject serves as his own control."
      },
      {
        "id": "Q4",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"A third limitation of the delayed multiple baseline design is that it can mask the interdependence of dependent variables .\"",
        "options": [
          {
            "label": "A",
            "text": "design"
          },
          {
            "label": "B",
            "text": "multiple baseline design"
          },
          {
            "label": "C",
            "text": "changing criterion design"
          },
          {
            "label": "D",
            "text": "delayed multiple baseline design"
          }
        ],
        "answer": "B",
        "explanation": "\"A third limitation of the delayed multiple baseline design is that it can mask the interdependence of dependent variables .\" is the chapter's own definition of multiple baseline design.",
        "topic": "Key terms",
        "sourceHint": "A third limitation of the delayed multiple baseline design is that it can mask the interdependence of dependent variables ."
      },
      {
        "id": "Q5",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"A third limitation of the delayed multiple baseline design is that it can mask the interdependence of dependent variables .\"",
        "options": [
          {
            "label": "A",
            "text": "Baseline Design"
          },
          {
            "label": "B",
            "text": "changing criterion design"
          },
          {
            "label": "C",
            "text": "delayed multiple baseline design"
          },
          {
            "label": "D",
            "text": "design"
          }
        ],
        "answer": "A",
        "explanation": "\"A third limitation of the delayed multiple baseline design is that it can mask the interdependence of dependent variables .\" is the chapter's own definition of Baseline Design.",
        "topic": "Key terms",
        "sourceHint": "A third limitation of the delayed multiple baseline design is that it can mask the interdependence of dependent variables ."
      }
    ],
    "reviewPrompts": [
      "Define \"changing criterion design\" in your own words, then check against the chapter glossary.",
      "Define \"delayed multiple baseline design\" in your own words, then check against the chapter glossary.",
      "Define \"design\" in your own words, then check against the chapter glossary.",
      "Define \"multiple baseline design\" in your own words, then check against the chapter glossary.",
      "Define \"Baseline Design\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"In a multiple baseline design, simultaneous baseline measurement is begun on two or more behaviors.\"",
      "Restate this idea from the chapter in your own words: \"Experimental control is demonstrated in a multiple baseline design by each behavior changing when, and only when, the independent variable is applied..\""
    ],
    "recap": [
      "Limitations of the changing criterion design are (a) the target behavior must already be in the subject's repertoire, and (b) incorporating the necessary features of the design may impede optimal learning rates.."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true
    }
  },
  "10": {
    "meta": {
      "id": "10",
      "number": 10,
      "title": "Planning and Evaluating Applied Behavior Analysis Research",
      "subtitle": "Threats to validity, internal/external/social validity",
      "part": "Part 3 - Evaluating and Analyzing Behavior Change",
      "bacb": [
        "D-1",
        "D-2",
        "D-3",
        "D-4",
        "D-5",
        "D-6",
        "H-6"
      ]
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [
      {
        "id": "D-1",
        "text": "Distinguish between dependent and independent va riables."
      },
      {
        "id": "D-2",
        "text": "Distinguish between interna l and external validity."
      },
      {
        "id": "D-3",
        "text": "Identify the defining features of single-subject experimenta l designs (e.g., individuals serve as their own controls, repeated."
      },
      {
        "id": "D-4",
        "text": "Describe the advantages of single-subject experimental designs compared to group designs."
      },
      {
        "id": "D-5",
        "text": "Use single-su bject experimental designs (e.g., reversa l, multiple baseline, multielement, changing criterion)."
      },
      {
        "id": "D-6",
        "text": "Describe rationales for conducting comparative, component, and pa ramet ric analyses."
      },
      {
        "id": "H-6",
        "text": "Monitor client prog ress and treat ment integrity."
      }
    ],
    "coreConcepts": [
      {
        "title": "Analysis Research",
        "body": [
          "Behavior analysis research methods feature repeated measures of the behavior of individual organisms within and across experimental conditions."
        ],
        "bullets": [
          "Knowing that the average performance of a group of subjects changed may not reveal anything about the performance of individual subjects.",
          "To be most useful, a treatment must be understood at the level at which people come into contact with it and are affected by it: the individual level. group and a control group.",
          "Mean performance of a group of subjects hides intersubject variability in the data. Attempting to cancel out variability through statistical manipulation neither eliminates its presence in the data nor controls the variables responsible for it. 17 Jdeally, published procedural descriptions should include suffic ient detail to allow an experienced investigator to repl icate the experiment. However, space limitations of most journals often prohibit such detail. The common and recommended practice in replicating published studies is to request complete experimental protocols from the original investigator(s). 248 Part 3 • Evaluating and Analyzing Behavior Change",
          "When repeated measurement reveals significant variability, the researcher should seek to identify and control the factors responsible for it."
        ]
      },
      {
        "title": "Importance of Flexibility in Experimental Design",
        "body": [
          "An effective experimental design is any sequence of independent variable manipulations that produces data question(s)."
        ],
        "bullets": [
          "To investigate the research question(s) of interest, an experimenter must often build an experimental design that",
          "A component analysis is any experiment designed to identify the active elements of a treatment condition, the relative contributions of different components in a of treatment components. Two basic methods are used for conducting component analyses: • drop-out component analysis: the investigator presents and assesses the treatment package as a whole, then systematically removes components. assesses components individually or in combination, then presents the complete treatment package.",
          "The most effective experimental designs use ongoing for employing the three elements of baseline logicprediction, verification, and replication."
        ]
      },
      {
        "title": "Internal Validity: Controlling Potential Sources",
        "body": [
          "of Confounding in Experimental Design"
        ],
        "bullets": [
          "Experiments that demonstrate a clear functional relation between the independent variable and the target behavior have a high degree of internal validity.",
          "An experimental design's strength is determined by the extent to which it (a) demonstrates a reliable effect and (b) eliminates or reduces the likelihood that factors other than the independent variable produced the behavior change.",
          "Although the term experimental control implies that the researcher controls the subject's behavior, the researcher can control only some aspect of the subject's environment.",
          "A confounding variable is an uncontrolled factor known or suspected to have exerted influence on the dependent variable."
        ]
      },
      {
        "title": "Social Validity: Assessing the Applied Value",
        "body": [
          "of Behavior Changes and the Treatments"
        ],
        "bullets": []
      },
      {
        "title": "That Accomplish Them",
        "body": [
          "The social validity of an applied behavior analysis study should be assessed in three ways: the social significance of the behavior change goals, the appropriateness of the intervention, and the social importance of the results."
        ],
        "bullets": [
          "Experts and persons who use the prospective skill in natural environments can help researchers identify socially valid target behaviors.",
          "Socially valid goals can be determined empiricalJy by assessing the performance of individuals judged to be highly competent, and experimentally manipulating different levels of performance to determine socially valid outcomes.",
          "Several scales and questionnaires for obtaining consumers' opinions of the acceptability of behavioral interventions have been developed.",
          "Preference for interventions can be assessed directly by arranging experimental conditions in which practitioners or clients can choose which of multiple treatments to implement or receive."
        ]
      },
      {
        "title": "External Validity: Replicating Experiments",
        "body": [
          "External validity refers to the degree to which a functional relation found reliable and socially valid in a given experiment operates under different conditions."
        ],
        "bullets": [
          "Group design researchers assume that including many subjects increases the external validity, or generality, of a study's findings to other individuals.",
          "The assumption of increased generality violates a fundamental prem ise of the between-groups method: The proper inferences about the results of a groups design study are from the sample to the population, not from the sample to the individual.",
          "A between-groups experiment does not demonstrate a function al relation between the behavior of any subject and some aspect of his or her environment; the external validity of its findings is moot.",
          "Although between-groups designs and tests of statistical significance are necessary and effective tools for answering certain types of research questions, they have contributed little to an effective technology of behavior change."
        ]
      },
      {
        "title": "Evaluating Applied Behavior Analysis Research",
        "body": [
          "The quality and value of an applied behavior analysis study may be evaluated by seeking answers to a sequence of questions related to internal validity, social validity, maintenance and generalization of behavior change, external validity, and scientific and theoretical significance."
        ],
        "bullets": [
          "A Type I error occurs when a researcher concludes that the independent variable had an effect on the dependent variable when it did not. A Type II error occurs when a researcher concludes that the independent variable did not have an effect on the dependent variable when it did.",
          "Visual analysis effectively identifies variables that produce strong, large, and reliable effects, which contribute to an effective and robust technology of behavior change. Stato Determine the Generality of Research Findings tistical analysis detects the slightest possible correlations between the independent and dependent variables, which may lead to the identification and inclusion of weak and unreliable variables in the technology.",
          "A study can yield significant results from an applied perspective-demonstrate a functional relation between the independent variable and a socially important target behavior-yet contribute little to the advancement of the field.",
          "Only when all of the variables influencing a functional relation have been identified and accounted for can an analysis be considered complete."
        ]
      }
    ],
    "glossary": [
      {
        "term": "add-in component analysis",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "placebo control",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "treatment drif t",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "component analysis",
        "definition": "A component analysis is any experiment designed to identify the active elements of a treatment package, the relative contributions of different components in a treatment package, and/or the necessity and sufficiency of treatment components.",
        "sourceHint": "A component analysis is any experiment designed to identify the active elements of a treatment package, the relative contributions of different components in a treatment package, and/or the necessity and sufficiency of treatment components."
      },
      {
        "term": "pro cedura l fi delity",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "treatment int egrity",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "direct replication",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "replicat ion",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "treatment package",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "double-blind control",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "social va lidity",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Type I error",
        "definition": "A Type I error occurs when a researcher concludes that the independent variable had an effect on the dependent variable when it did not.",
        "sourceHint": "A Type I error occurs when a researcher concludes that the independent variable had an effect on the dependent variable when it did not."
      },
      {
        "term": "drop-out component ana lysis",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "syst ematic replicat ion",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Distinguish between dependent and independent va riables.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Distinguish between interna l and external validity.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "revious chapters outlined considerations and procedures",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "strategies for designing and implementing measurement",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "For example, Ahearn, Kerwin, Eicher, Shantz, and Swearingin (1996; see Figure 12.5) evaluated the relative effects of two treatments for food refusal in an alternating treatments design implemented in a multiple baseline across subjects format.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, Ahearn, Kerwin, Eicher, Shantz, and Swearingin (1996; see Figure 12.5) evaluated the relative effects of two treatments for food refusal in an alternating treatments design implemented in a multiple baseline across subjects format."
      },
      {
        "scenario": "For example, a subject's improved performance during the later phases of a study may result from physical growth or the acquisition of academic, social, or other behaviors and may be unrelated to manipulations of the independent variable.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, a subject's improved performance during the later phases of a study may result from physical growth or the acquisition of academic, social, or other behaviors and may be unrelated to manipulations of the independent variable."
      },
      {
        "scenario": "For example, suppose that the rate of contributions to a class discussion is the dependent variable.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, suppose that the rate of contributions to a class discussion is the dependent variable."
      },
      {
        "scenario": "For example, a practitioner might implement only those aspects of a procedure she favors and implement the full intervention only when the investigator is present.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, a practitioner might implement only those aspects of a procedure she favors and implement the full intervention only when the investigator is present."
      }
    ],
    "comparisons": [
      {
        "title": "Distinction drawn in the source",
        "left": {
          "label": "First framing",
          "points": [
            "One threat to treatment integrity, treatment drift, occurs when application of the independent variable during later phases of an experiment."
          ]
        },
        "right": {
          "label": "Contrast",
          "points": [
            "the way the treatment was applied at the study's outset. treatment package, and/or the necessity and sufficiency."
          ]
        },
        "sourceHint": "One threat to treatment integrity, treatment drift, occurs when application of the independent variable during later phases of an experiment differs from the way the treatment was applied at the study's outset. treatment package, and/or the necessity and sufficiency"
      }
    ],
    "misconceptions": [
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "Researchers should not assume that a person's general competence or experience in the experimental setting, or that providing the intervention agent with detailed written instructions or a script, will ensure a high degree of treatment integrity.",
        "sourceHint": "Researchers should not assume that a person's general competence or experience in the experimental setting, or that providing the intervention agent with detailed written instructions or a script, will ensure a high degree of treatment integrity."
      },
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "A between-groups experiment does not demonstrate a function al relation between the behavior of any subject and some aspect of his or her environment; the external validity of its findings is moot.",
        "sourceHint": "A between-groups experiment does not demonstrate a function al relation between the behavior of any subject and some aspect of his or her environment; the external validity of its findings is moot."
      }
    ],
    "examChecklist": [
      "Address objective D-1: Distinguish between dependent and independent va riables.",
      "Address objective D-2: Distinguish between interna l and external validity.",
      "Address objective D-3: Identify the defining features of single-subject experimenta l designs (e.g., individuals serve as their own controls, repeated.",
      "Address objective D-4: Describe the advantages of single-subject experimental designs compared to group designs.",
      "Address objective D-5: Use single-su bject experimental designs (e.g., reversa l, multiple baseline, multielement, changing criterion).",
      "Address objective D-6: Describe rationales for conducting comparative, component, and pa ramet ric analyses.",
      "Address objective H-6: Monitor client prog ress and treat ment integrity.",
      "Define \"component analysis\" from memory and match the source text.",
      "Define \"Type I error\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"A component analysis is any experiment designed to identify the active elements of a treatment package, the relative contributions of different components in a treatment package, and/or the necessity and sufficiency of treatment components.\"",
        "options": [
          {
            "label": "A",
            "text": "component analysis"
          },
          {
            "label": "B",
            "text": "Type I error"
          },
          {
            "label": "C",
            "text": "add-in component analysis"
          },
          {
            "label": "D",
            "text": "placebo control"
          }
        ],
        "answer": "A",
        "explanation": "\"A component analysis is any experiment designed to identify the active elements of a treatment package, the relative contributions of different components in a treatment package, and/or the necessity and sufficiency of treatment components.\" is the chapter's own definition of component analysis.",
        "topic": "Key terms",
        "sourceHint": "A component analysis is any experiment designed to identify the active elements of a treatment package, the relative contributions of different components in a treatment package, and/or the necessity and sufficiency of treatment components."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"A Type I error occurs when a researcher concludes that the independent variable had an effect on the dependent variable when it did not.\"",
        "options": [
          {
            "label": "A",
            "text": "component analysis"
          },
          {
            "label": "B",
            "text": "add-in component analysis"
          },
          {
            "label": "C",
            "text": "placebo control"
          },
          {
            "label": "D",
            "text": "Type I error"
          }
        ],
        "answer": "D",
        "explanation": "\"A Type I error occurs when a researcher concludes that the independent variable had an effect on the dependent variable when it did not.\" is the chapter's own definition of Type I error.",
        "topic": "Key terms",
        "sourceHint": "A Type I error occurs when a researcher concludes that the independent variable had an effect on the dependent variable when it did not."
      }
    ],
    "reviewPrompts": [
      "Define \"component analysis\" in your own words, then check against the chapter glossary.",
      "Define \"Type I error\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"Behavior analysis research methods feature repeated measures of the behavior of individual organisms within and across experimental conditions..\"",
      "Restate this idea from the chapter in your own words: \"By contrast, a between-groups experiment follows a sequence like this: • A pool of subjects is selected randomly from the population of interest.\"",
      "What is the single most important takeaway from \"Planning and Evaluating Applied Behavior Analysis Research\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "When evaluating the scientific significance of a research report, readers should consider the technological description of the experiment, the interpretation and discussion of the results, and the level of conceptual sense and integrity."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true
    }
  },
  "11": {
    "meta": {
      "id": "11",
      "number": 11,
      "title": "Positive Reinforcement",
      "subtitle": "Unconditioned and conditioned reinforcers, schedules basics",
      "part": "Part 4 - Reinforcement",
      "bacb": [
        "B-4",
        "B-7",
        "B-8",
        "F-5",
        "G-1",
        "G-3"
      ]
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [
      {
        "id": "B-4",
        "text": "Define and provide examples of positive and negative reinforcement contingencies."
      },
      {
        "id": "B-7",
        "text": "Define and provide examples of automatic and socially mediated contingencies."
      },
      {
        "id": "B-8",
        "text": "Define and provide examples of unconditioned, cond itioned, and generalized reinforcers and pun ishers."
      },
      {
        "id": "F-5",
        "text": "Cond uct preference assessments."
      },
      {
        "id": "G-1",
        "text": "Use positive and negative reinforcement procedu res to strengthen behavior."
      },
      {
        "id": "G-3",
        "text": "Establish and use conditioned reinforcers."
      }
    ],
    "coreConcepts": [
      {
        "title": "Positive Reinforcement Defined",
        "body": [
          "Positive reinforcement occurs when a response is followed immediately by the presentation of a stimulus change that increases the future occurrence of similar responses."
        ],
        "bullets": [
          "The effects of long-delayed consequences on human behavior should not be attributed to reinforcement, as these effects drop off quickly as the delay is increased. By virtue of being temporally paired with the responsereinforcer contingency, antecedent events acquire the ability to evoke (make more likely) instances of the reinforced response class. An antecedent stimulus that evokes behavior because it has been correlated with the availability of reinforcement is called a discriminative stimulus (S0 ). gency of s 0 ~ R ~ sR+_",
          "The momentary effectiveness of any stimulus change as reinforcement depends on an existing level of motivation with respect to that stimulus change. An establishing operation (EO) (e.g., deprivation) increases the current effectiveness of a reinforcer; an abolishing operation (AO) (e.g., satiation) decreases the current effectiveness of a reinforcer.",
          "A misconception held by some is that reinforcement is a circular concept. Circular reasoning is a form of faulty logic in which cause and effect are confused and not independent of each other. Reinforcement is not a circular concept because the two components of the responseconsequence relation can be separated and the consequence manipulated to determine whether it increases the frequency of the behavior it follows .",
          "Reinforcement does more than increase the future occurrence of similar behavior; it also changes the function of stimuli that immediately precede the reinforced behavior."
        ]
      },
      {
        "title": "Eo~s0 ~R~sR+ _",
        "body": [
          "Automaticity of reinforcement refers to the fact that a person does not have to understand or verbalize the relation between his or her actions and a reinforcing consequence, or for that matter even be aware that a consequence has occurred, for reinforcement to happen."
        ],
        "bullets": [
          "Reinforcement strengthens any behavior that immediately precedes it; no logical or adaptive connection between behavior and the reinforcing consequence is necessary. 286 Part 4 • Reinforcement",
          "The importance of understanding the arbitrariness of reinforcement goes far beyond providing a possible explanation for the development of harmless superstitious and idiosyncratic behaviors. The arbitrary nature of selection by reinforcement may explain the acquisition and maintenance of many maladaptive and challenging behaviors.",
          "Automatic reinforcement refers to the behavior-stimulus change relation that occurs without the presentation of consequences by other people, or is assumed when a"
        ]
      },
      {
        "title": "Classifying Reinforcers",
        "body": [
          "An unconditioned reinforcer is a stimulus change that functions as reinforcement even though the learner has had no particular learning history with it. (The terms primary reinforcer and unlearned reinforcer are synonyms for unconditioned reinforcer.)"
        ],
        "bullets": [
          "A conditioned reinforcer (sometimes called a secondary stimulus change that has acquired the capability to function as a reinforcer through stimulus-stimulus pairing with one or more unconditioned reinforcers or conditioned reinforcers.",
          "A generalized conditioned reinforcer is a conditioned many unconditioned and conditioned reinforcers, does not forcement for its effectiveness.",
          "The Premack principle states that making the opportunity to engage in a behavior that occurs at a relatively high free operant (or baseline) rate contingent on the occurrence of low-frequency behavior will function as reinforcement for the low-occurrence behavior.",
          "The response-deprivation hypothesis is a model for prebehavior) will function as reinforcement for another behavior (the instrumental response) based on the relative baseline rates at which each behavior occurs and whether compared to the baseline level of engagement."
        ]
      },
      {
        "title": "Identifying Potential Reinforcers",
        "body": [
          "Reinforcer assessment refers to a variety of direct, databased methods for determining the relative effects of a given stimulus as reinforcement under different and changing conditions or the comparative effectiveness of multiple stimuli as reinforcers for a given behavior under specific conditions. Re inforcer assessment is often conducted with in-the-moment procedures, concurrent schedules of reinforcement, multiple schedules of reinforcement, and progressive reinforcement schedules. reinforcer or learned reinforcer) is a previously neutral"
        ],
        "bullets": []
      },
      {
        "title": "Control Procedures for Positive Reinforcement",
        "body": [
          "Positive reinforcement control procedures are used to manipulate the contingent presentation of a potential reinforcer and observe any effects on the future frequency of behavior. Control, as the term is used here, requires an experimental demonstration that the presentation of a reinforcer that, as a result of having been paired with stimulus contingent on the occurrence of a target response functions as positive reinforcement."
        ],
        "bullets": [
          "In addition to a reversal design using the withdrawal of the reinforcement contingency (i.e., extinction) as the control condition, noncontingent reinforcement (NCR), differential reinforcement of other behavior (DRO), and differential reinforcement of alternative behavior (DRA) can be used as control conditions for reinforcement."
        ]
      }
    ],
    "glossary": [
      {
        "term": "automatic reinforcement",
        "definition": "Although the idea that automatic reinforcement is a factor in early language acquisition has been proposed repeatedly, few experimental analyses of the phenomenon have appeared in the literature (e.g., Miguel, Carr, & Michael, 2002; Sundberg, Michael, Partington, & Sundberg, 1996; Yoon & Bennett, 2000).",
        "sourceHint": "Although the idea that automatic reinforcement is a factor in early language acquisition has been proposed repeatedly, few experimental analyses of the phenomenon have appeared in the literature (e.g., Miguel, Carr, & Michael, 2002; Sundberg, Michael, Partington, & Sundberg, 1996; Yoon & Bennett, 2000)."
      },
      {
        "term": "positive reinforcer",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "rule-governed behavior",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "condit ioned reinforcer",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Premack principle",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "socially mediated contingencies",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "generalized condit ioned reinforcer",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "reinforcer assessment",
        "definition": "Reinforcer assessment refers to a variety of direct, databased methods used to present one or more stimuli contingent on a target response and then measuring the future effects on the rate of responding.",
        "sourceHint": "Reinforcer assessment refers to a variety of direct, databased methods used to present one or more stimuli contingent on a target response and then measuring the future effects on the rate of responding."
      },
      {
        "term": "stimulus preference assessment",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "positive reinforcement",
        "definition": "Positive reinforcement occurs when a response is followed immediately by the presentation of a stimulus change that increases the future occurrence of similar responses.",
        "sourceHint": "Positive reinforcement occurs when a response is followed immediately by the presentation of a stimulus change that increases the future occurrence of similar responses."
      },
      {
        "term": "response-deprivation hypothesis",
        "definition": "The response-deprivation hypothesis is a model for prebehavior) will function as reinforcement for another behavior (the instrumental response) based on the relative baseline rates at which each behavior occurs and whether compared to the baseline level of engagement.",
        "sourceHint": "The response-deprivation hypothesis is a model for prebehavior) will function as reinforcement for another behavior (the instrumental response) based on the relative baseline rates at which each behavior occurs and whether compared to the baseline level of engagement."
      },
      {
        "term": "unconditioned reinforcer",
        "definition": "Unconditioned Reinforcers An unconditioned reinforcer is a stimulus change that functions as reinforcement even though the learner has had no particular learning history with it.",
        "sourceHint": "Unconditioned Reinforcers An unconditioned reinforcer is a stimulus change that functions as reinforcement even though the learner has had no particular learning history with it."
      },
      {
        "term": "Cond uct preference assessments.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Establish and use conditioned reinforcers.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "widely applied principle of behavior. Although some",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "Figure 11.2 1 Phrases such as strengthening the behavior and increasing the likelihood offuture responding are sometimes used to describe the basic effect of reinforcement.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Figure 11.2 1 Phrases such as strengthening the behavior and increasing the likelihood offuture responding are sometimes used to describe the basic effect of reinforcement."
      },
      {
        "scenario": "For example, suppose that a piano student practiced dutifully every day for several months in preparation for a statewide competition, at which she received a first-place award for her solo piano performance.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, suppose that a piano student practiced dutifully every day for several months in preparation for a statewide competition, at which she received a first-place award for her solo piano performance."
      },
      {
        "scenario": "A statement by the piano teacher such as \" If you practice your effect are the same.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "A statement by the piano teacher such as \" If you practice your effect are the same."
      },
      {
        "scenario": "[However,] if we say, for example, that a particular stimulus strengthens a response behavior because it is a reinforcer, we are using the term reinforcer in a circular fashion.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "[However,] if we say, for example, that a particular stimulus strengthens a response behavior because it is a reinforcer, we are using the term reinforcer in a circular fashion."
      }
    ],
    "comparisons": [],
    "misconceptions": [
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "The effects of long-delayed consequences on human behavior should not be attributed to reinforcement, as these effects drop off quickly as the delay is increased.",
        "sourceHint": "The effects of long-delayed consequences on human behavior should not be attributed to reinforcement, as these effects drop off quickly as the delay is increased."
      },
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "A misconception held by some is that reinforcement is a circular concept.",
        "sourceHint": "A misconception held by some is that reinforcement is a circular concept."
      },
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "Automaticity of reinforcement refers to the fact that a person does not have to understand or verbalize the relation between his or her actions and a reinforcing consequence, or for that matter even be aware that a consequence has occurred, for reinforcement to happen.",
        "sourceHint": "Automaticity of reinforcement refers to the fact that a person does not have to understand or verbalize the relation between his or her actions and a reinforcing consequence, or for that matter even be aware that a consequence has occurred, for reinforcement to happen."
      },
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "A generalized conditioned reinforcer is a conditioned many unconditioned and conditioned reinforcers, does not forcement for its effectiveness.",
        "sourceHint": "A generalized conditioned reinforcer is a conditioned many unconditioned and conditioned reinforcers, does not forcement for its effectiveness."
      }
    ],
    "examChecklist": [
      "Address objective B-4: Define and provide examples of positive and negative reinforcement contingencies.",
      "Address objective B-7: Define and provide examples of automatic and socially mediated contingencies.",
      "Address objective B-8: Define and provide examples of unconditioned, cond itioned, and generalized reinforcers and pun ishers.",
      "Address objective F-5: Cond uct preference assessments.",
      "Address objective G-1: Use positive and negative reinforcement procedu res to strengthen behavior.",
      "Address objective G-3: Establish and use conditioned reinforcers.",
      "Define \"automatic reinforcement\" from memory and match the source text.",
      "Define \"reinforcer assessment\" from memory and match the source text.",
      "Define \"positive reinforcement\" from memory and match the source text.",
      "Define \"response-deprivation hypothesis\" from memory and match the source text.",
      "Define \"unconditioned reinforcer\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Although the idea that automatic reinforcement is a factor in early language acquisition has been proposed repeatedly, few experimental analyses of the phenomenon have appeared in the literature (e.g., Miguel, Carr, & Michael, 2002; Sundberg, Michael, Partington, & Sundberg, 1996; Yoon & Bennett, 2000).\"",
        "options": [
          {
            "label": "A",
            "text": "automatic reinforcement"
          },
          {
            "label": "B",
            "text": "reinforcer assessment"
          },
          {
            "label": "C",
            "text": "positive reinforcement"
          },
          {
            "label": "D",
            "text": "response-deprivation hypothesis"
          }
        ],
        "answer": "A",
        "explanation": "\"Although the idea that automatic reinforcement is a factor in early language acquisition has been proposed repeatedly, few experimental analyses of the phenomenon have appeared in the literature (e.g., Miguel, Carr, & Michael, 2002; Sundberg, Michael, Partington, & Sundberg, 1996; Yoon & Bennett, 2000).\" is the chapter's own definition of automatic reinforcement.",
        "topic": "Key terms",
        "sourceHint": "Although the idea that automatic reinforcement is a factor in early language acquisition has been proposed repeatedly, few experimental analyses of the phenomenon have appeared in the literature (e.g., Miguel, Carr, & Michael, 2002; Sundberg, Michael, Partington, & Sundberg, 1996; Yoon & Bennett, 2000)."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Reinforcer assessment refers to a variety of direct, databased methods used to present one or more stimuli contingent on a target response and then measuring the future effects on the rate of responding.\"",
        "options": [
          {
            "label": "A",
            "text": "automatic reinforcement"
          },
          {
            "label": "B",
            "text": "positive reinforcement"
          },
          {
            "label": "C",
            "text": "response-deprivation hypothesis"
          },
          {
            "label": "D",
            "text": "reinforcer assessment"
          }
        ],
        "answer": "D",
        "explanation": "\"Reinforcer assessment refers to a variety of direct, databased methods used to present one or more stimuli contingent on a target response and then measuring the future effects on the rate of responding.\" is the chapter's own definition of reinforcer assessment.",
        "topic": "Key terms",
        "sourceHint": "Reinforcer assessment refers to a variety of direct, databased methods used to present one or more stimuli contingent on a target response and then measuring the future effects on the rate of responding."
      },
      {
        "id": "Q3",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Positive reinforcement occurs when a response is followed immediately by the presentation of a stimulus change that increases the future occurrence of similar responses.\"",
        "options": [
          {
            "label": "A",
            "text": "reinforcer assessment"
          },
          {
            "label": "B",
            "text": "response-deprivation hypothesis"
          },
          {
            "label": "C",
            "text": "positive reinforcement"
          },
          {
            "label": "D",
            "text": "automatic reinforcement"
          }
        ],
        "answer": "C",
        "explanation": "\"Positive reinforcement occurs when a response is followed immediately by the presentation of a stimulus change that increases the future occurrence of similar responses.\" is the chapter's own definition of positive reinforcement.",
        "topic": "Key terms",
        "sourceHint": "Positive reinforcement occurs when a response is followed immediately by the presentation of a stimulus change that increases the future occurrence of similar responses."
      },
      {
        "id": "Q4",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"The response-deprivation hypothesis is a model for prebehavior) will function as reinforcement for another behavior (the instrumental response) based on the relative baseline rates at which each behavior occurs and whether compared to the baseline level of engagement.\"",
        "options": [
          {
            "label": "A",
            "text": "positive reinforcement"
          },
          {
            "label": "B",
            "text": "response-deprivation hypothesis"
          },
          {
            "label": "C",
            "text": "automatic reinforcement"
          },
          {
            "label": "D",
            "text": "reinforcer assessment"
          }
        ],
        "answer": "B",
        "explanation": "\"The response-deprivation hypothesis is a model for prebehavior) will function as reinforcement for another behavior (the instrumental response) based on the relative baseline rates at which each behavior occurs and whether compared to the baseline level of engagement.\" is the chapter's own definition of response-deprivation hypothesis.",
        "topic": "Key terms",
        "sourceHint": "The response-deprivation hypothesis is a model for prebehavior) will function as reinforcement for another behavior (the instrumental response) based on the relative baseline rates at which each behavior occurs and whether compared to the baseline level of engagement."
      },
      {
        "id": "Q5",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Unconditioned Reinforcers An unconditioned reinforcer is a stimulus change that functions as reinforcement even though the learner has had no particular learning history with it.\"",
        "options": [
          {
            "label": "A",
            "text": "unconditioned reinforcer"
          },
          {
            "label": "B",
            "text": "automatic reinforcement"
          },
          {
            "label": "C",
            "text": "reinforcer assessment"
          },
          {
            "label": "D",
            "text": "positive reinforcement"
          }
        ],
        "answer": "A",
        "explanation": "\"Unconditioned Reinforcers An unconditioned reinforcer is a stimulus change that functions as reinforcement even though the learner has had no particular learning history with it.\" is the chapter's own definition of unconditioned reinforcer.",
        "topic": "Key terms",
        "sourceHint": "Unconditioned Reinforcers An unconditioned reinforcer is a stimulus change that functions as reinforcement even though the learner has had no particular learning history with it."
      }
    ],
    "reviewPrompts": [
      "Define \"automatic reinforcement\" in your own words, then check against the chapter glossary.",
      "Define \"reinforcer assessment\" in your own words, then check against the chapter glossary.",
      "Define \"positive reinforcement\" in your own words, then check against the chapter glossary.",
      "Define \"response-deprivation hypothesis\" in your own words, then check against the chapter glossary.",
      "Define \"unconditioned reinforcer\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"Positive reinforcement occurs when a response is followed immediately by the presentation of a stimulus change that increases the future occurrence of similar responses..\"",
      "Restate this idea from the chapter in your own words: \"The stimulus that is presented as a consequence, and that is responsible for the subsequent increase in responding, is 7.\""
    ],
    "recap": [
      "Positive reinforcement control procedures are used to manipulate the contingent presentation of a potential reinforcer and observe any effects on the future frequency of behavior."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true
    }
  },
  "12": {
    "meta": {
      "id": "12",
      "number": 12,
      "title": "Negative Reinforcement",
      "subtitle": "Escape vs avoidance, SR-, free-operant avoidance",
      "part": "Part 4 - Reinforcement",
      "bacb": []
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [],
    "coreConcepts": [
      {
        "title": "Definition of Negative Reinfo rcement",
        "body": [
          "Negative reinforcement involves the termination, reduction, or postponement of a stimulus contingent on the occurrence of a response, which leads to an increase in the future occurrence of that response."
        ],
        "bullets": [
          "Positive and negative reinforcement are similar in that both lead to an increase in responding; they differ in that positive reinforcement involves contingent stimulus presentation, whereas negative reinforcement involves contingent stimulus termination.",
          "Negative reinforcement and punishment differ in that (a) negative reinforcement involves contingent stimulus termination, whereas punishment involves contingent stimulation, and (b) negative reinforcement leads to an increase in responding, whereas punishment leads to a decrease in responding.",
          "Negative reinforcement may play an important role in the development of academic skills, but it can also account for the development of disruptive or dangerous behavior.",
          "Unconditioned negative reinforcers are stimuli whose removal strengthens behavior in the absence of prior learning. Conditioned negative reinforcers are stimuli whose removal strengthens behavior as a result of previous pairing with other negative reinforcers. nation through the action of another person. Automatic negative reinforcement involves stimulus termination as a direct result of a response."
        ]
      },
      {
        "title": "Escape and Avoidance Con tingencies",
        "body": [
          "An escape contingency is one in which responding terminates an ongoing stimulus. An avoidance contingency is one in which responding delays or prevents the presentation of a stimulus."
        ],
        "bullets": [
          "In discriminated avoidance, responding in the presence of a signal prevents stimulus presentation; in free-operant avoidance, responding at any time prevents stimulus presentation."
        ]
      },
      {
        "title": "Characterist ics of Negative Reinforcement",
        "body": [
          "Any response that successfully terminates aversive stimulation will be strengthened; as a result, a wide range of behaviors may be acquired and maintained by negative reinforcement."
        ],
        "bullets": []
      },
      {
        "title": "Applica tions of Negative Reinforcement",
        "body": [
          "Although negative reinforcement is a fundamental principle of learning that has been studied extensively in basic research, applied behavior analysis has heavily emphasized the use of positive reinforcement over negative reinforcement."
        ],
        "bullets": [
          "Applied researchers have explored the therapeutic uses of negative reinforcement in treating pediatric feeding problems.",
          "Improvements in student performance as a result of error correction that involves repeating a learning trial, having the student practice correct performance, or giving the student additional work may be a function of negative reinforcement.",
          "Extinction of behavior maintained by negative reinforcement involves not allowing a response to avoid or terminate its programmed consequence.",
          "One strategy for treating problem behaviors maintained by negative reinforcement is to strengthen a more socially appropriate replacement behavior through negative reinforcement."
        ]
      },
      {
        "title": "Reinforcement",
        "body": [
          "Ethical concerns about the use of positive and negative reinforcement are similar and arise from the severity of the antecedent event (EO) that occasions behavior. Most EOs for behavior maintained by negative reinforcement can be viewed as aversive events. Extremely noxious events, when presented as antecedent stimuli, cannot be justified as part of a typical behavior change program."
        ],
        "bullets": [
          "Another concern with negative reinforcement is that the presence of aversive stimuli can itself generate behaviors that compete with the acquisition of desired behavior."
        ]
      }
    ],
    "glossary": [
      {
        "term": "avoidance cont ingency",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "escape conti ngency",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "negative reinforcement",
        "definition": "Another concern with negative reinforcement is that the presence of aversive stimuli can itself generate behaviors that compete with the acquisition of desired behavior (Hutchinson , 1977; Myer, 1971).",
        "sourceHint": "Another concern with negative reinforcement is that the presence of aversive stimuli can itself generate behaviors that compete with the acquisition of desired behavior (Hutchinson , 1977; Myer, 1971)."
      },
      {
        "term": "co nditioned negat ive rei nforcer",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "free-operant avoid ance",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "unconditioned negat ive reinforcer",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "discrimi nated avoidance",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "Many stimulus changes have discrete onsets on a television (positive reinforcement) or turning off the light in on a continuum from less to more, such as turning up the volume t of a stereo to hear it better (positive reinforcement) or turning it down when it is too loud (negative reinforcement).",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Many stimulus changes have discrete onsets on a television (positive reinforcement) or turning off the light in on a continuum from less to more, such as turning up the volume t of a stereo to hear it better (positive reinforcement) or turning it down when it is too loud (negative reinforcement)."
      },
      {
        "scenario": "Osborne's (1969) study on free-time contingencies may also serve as an example of escape learning in an applied conattempt to renew the discussion, Baron and Galizia (2005) reit- text.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Osborne's (1969) study on free-time contingencies may also serve as an example of escape learning in an applied conattempt to renew the discussion, Baron and Galizia (2005) reit- text."
      },
      {
        "scenario": "For example, Solomon, Kamin, and Wynne (1953) showed that dogs continued to emit avoidance responses in the presence of a warning signal long after shocks were no longer programmed to follow the signal.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, Solomon, Kamin, and Wynne (1953) showed that dogs continued to emit avoidance responses in the presence of a warning signal long after shocks were no longer programmed to follow the signal."
      },
      {
        "scenario": "For example, Dougher, Hamilton, Fink, and Harrington (2007) showed that fear responses spread in an orderly, hierarchical way across three otherwise arbitrary stimuli to which college students avoidance, scientists in other fields are producing better ways had been trained to respond according to a small, medium, and large relation.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, Dougher, Hamilton, Fink, and Harrington (2007) showed that fear responses spread in an orderly, hierarchical way across three otherwise arbitrary stimuli to which college students avoidance, scientists in other fields are producing better ways had been trained to respond according to a small, medium, and large relation."
      }
    ],
    "comparisons": [
      {
        "title": "Distinction drawn in the source",
        "left": {
          "label": "First framing",
          "points": [
            "Negative reinforcement and punishment differ in that (a) negative reinforcement involves contingent stimulus termination."
          ]
        },
        "right": {
          "label": "Contrast",
          "points": [
            "punishment involves contingent stimulation, and (b) negative reinforcement leads to an increase in responding, whereas punishment leads to a decrease in responding."
          ]
        },
        "sourceHint": "Negative reinforcement and punishment differ in that (a) negative reinforcement involves contingent stimulus termination, whereas punishment involves contingent stimulation, and (b) negative reinforcement leads to an increase in responding, whereas punishment leads to a decrease in responding."
      }
    ],
    "misconceptions": [],
    "examChecklist": [
      "Define \"negative reinforcement\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Another concern with negative reinforcement is that the presence of aversive stimuli can itself generate behaviors that compete with the acquisition of desired behavior (Hutchinson , 1977; Myer, 1971).\"",
        "options": [
          {
            "label": "A",
            "text": "negative reinforcement"
          },
          {
            "label": "B",
            "text": "avoidance cont ingency"
          },
          {
            "label": "C",
            "text": "escape conti ngency"
          },
          {
            "label": "D",
            "text": "co nditioned negat ive rei nforcer"
          }
        ],
        "answer": "A",
        "explanation": "\"Another concern with negative reinforcement is that the presence of aversive stimuli can itself generate behaviors that compete with the acquisition of desired behavior (Hutchinson , 1977; Myer, 1971).\" is the chapter's own definition of negative reinforcement.",
        "topic": "Key terms",
        "sourceHint": "Another concern with negative reinforcement is that the presence of aversive stimuli can itself generate behaviors that compete with the acquisition of desired behavior (Hutchinson , 1977; Myer, 1971)."
      }
    ],
    "reviewPrompts": [
      "Define \"negative reinforcement\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"Negative reinforcement involves the termination, reduction, or postponement of a stimulus contingent on the occurrence of a response, which leads to an increase in the future occurrence of that response..\"",
      "Restate this idea from the chapter in your own words: \"A negative reinforcement contingency involves (a) an establishing operation (EO) in whose presence escape is reinforcing, (b) a discriminative stimulus (S0 ) in whose presence a response is more likely to be reinforced, (c) the 10.\"",
      "What is the single most important takeaway from \"Negative Reinforcement\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "Another concern with negative reinforcement is that the presence of aversive stimuli can itself generate behaviors that compete with the acquisition of desired behavior.."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "misconceptions": true
    }
  },
  "13": {
    "meta": {
      "id": "13",
      "number": 13,
      "title": "Schedules of Reinforcement",
      "subtitle": "FR, VR, FI, VI; compound and concurrent schedules",
      "part": "Part 4 - Reinforcement",
      "bacb": []
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [],
    "coreConcepts": [
      {
        "title": "Intermittent Reinforcement",
        "body": [
          "A schedule of reinforcement is a rule that establishes the probability that a specific occurrence of a behavior will produce reinforcement."
        ],
        "bullets": [
          "Continuous reinforcement and extinction provide the boundaries for all other schedules of reinforcement.",
          "Only selected occurrences of behavior produce reinforcement with an intermittent schedule of reinforcement.",
          "Continuous reinforcement (CRF) is used to strengthen behavior, primarily during the initial stages of learning new behaviors.",
          "Intermittent reinforcement (INT) is used to maintain an established behavior, especially during maintenance stages of learning."
        ]
      },
      {
        "title": "Reinforcement",
        "body": [
          "Ratio schedules require a number of responses before one response produces reinforcement."
        ],
        "bullets": [
          "Interval schedules require an elapse of time before a response produces reinforcement."
        ]
      },
      {
        "title": "Schedule Effects and Consistency of Performance",
        "body": [
          "A fixed ratio (FR) schedule requires the completion of a specified number of responses before a response produces reinforcement."
        ],
        "bullets": [
          "FR schedules produce a typical pattern of responding: (a) After the first response of the ratio requirement, the participant completes the required responses with little hesitation between responses; and (b) a postreinforcement pause follows reinforcement.",
          "The size of the ratio and the reinforcement magnitude can influence the duration of the postreinforcement pause.",
          "A variable ratio (VR) schedule of reinforcement requires the completion of a variable number of responses before a response produces reinforcement. A number representing the average (e.g., mean) number of responses required for reinforcement identifies the VR schedule.",
          "A fixed interval (FI) schedule provides reinforcement for the first response following the elapse of a specific, constant duration of time since the last reinforced response. The reinforcer is available after the fixed time interval has elapsed, and it remains available until the first response is emitted."
        ]
      },
      {
        "title": "Thinning Intermittent Reinforcement",
        "body": [
          "To adjust the thinning process, and to avoid the loss of previous improvements, use small increments of schedule changes."
        ],
        "bullets": []
      },
      {
        "title": "Compound Schedules of Reinforcement",
        "body": [
          "Continuous reinforcement, the four basic intermittent schedules of reinforcement, differential reinforcement of rates of responding, and extinction, when combined, produce compound schedules of reinforcement."
        ],
        "bullets": [
          "The basic component schedules within a compound schedule (a) can occur successively or simultaneously; (b) can occur with or without discriminative stimuli; and (c) make reinforcement contingent on meeting the response requirements of each component schedule independently, or in combination with compound schedules.",
          "A multiple schedule (mult) presents two or more basic schedules of reinforcement in an alternating, usually random, sequence. The basic schedules within the multiple schedule occur successively and independently. A discriminative stimulus is correlated with each basic schedule, and that stimulus is present as Jong as the schedule is in effect.",
          "Ratio strain can result from abrupt increases in ratio requirements when moving from denser to thinner reinforcement schedules."
        ]
      },
      {
        "title": "Reinforcement",
        "body": [
          "Differential reinforcement of high rates (DRH) and differential reinforcement of low rates (DRL) are variations of ratio schedules that make reinforcement contingent on responses occurring above or below criterion response rates. • DRH schedules produce higher rates of responding. • DRL schedules produce lower rates of responding."
        ],
        "bullets": [
          "The differential reinforcement of diminishing rates schedule provides reinforcement at the end of a predetermined time interval when the number of responses is Jess than a criterion that is gradually decreased across time intervals based on the individual 's performance.",
          "A Jag schedule of reinforcement is one method to increase response variability. Reinforcement on a Jag schedule is contingent on a response differing in some predetermined way (e.g., different topography, different sequence) from one or more responses that preceded it.",
          "A progressive ratio schedule of reinforcement is a variation of the fixed ratio (FR) schedule in which the ratio requirements increase incrementally within the session.",
          "A concurrent schedule (cone) of reinforcement occurs when (a) two or more contingencies of reinforcement (b) operate independently and simultaneously (c) for two or more behaviors. Each schedule is correlated with a discriminative stimulus."
        ]
      }
    ],
    "glossary": [
      {
        "term": "adjunctive behaviors",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "differential reinforcement of low",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "postreinforcement pause",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "progressive schedule of",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "behavioral contrast",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "reinforcement",
        "definition": "schedule of reinforcement is a rule that describes a conroom (a light comes on), and putting money into a vending A will produce reinforcement.",
        "sourceHint": "schedule of reinforcement is a rule that describes a conroom (a light comes on), and putting money into a vending A will produce reinforcement."
      },
      {
        "term": "intermittent schedule of",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "compound schedule of reinforcement",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "ratio strain",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "lag schedule",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "schedule of reinforcement",
        "definition": "schedule of reinforcement is a rule that describes a conroom (a light comes on), and putting money into a vending A will produce reinforcement.",
        "sourceHint": "schedule of reinforcement is a rule that describes a conroom (a light comes on), and putting money into a vending A will produce reinforcement."
      },
      {
        "term": "limited hold",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "schedule thinning",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "matching law",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "differential reinforcement of",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "differential reinforcement of high",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Use procedures to promote maintenance.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "tingency of reinforcement, the environmental arrange-",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "ments that determine conditions by which behaviors",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "will produce reinforcement. Continuous reinforcement and",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "example,",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "For example, a teacher using a continuous schedule of reinforcement would praise each occurrence of a correctly identified sight word emitted by a student.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, a teacher using a continuous schedule of reinforcement would praise each occurrence of a correctly identified sight word emitted by a student."
      },
      {
        "scenario": "Jack Michael (1987) provides an example of a verbal ru le controlling a schedule contingency.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Jack Michael (1987) provides an example of a verbal ru le controlling a schedule contingency."
      },
      {
        "scenario": "For example, a student might withdraw one slip of paper for each homework assignment completed.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, a student might withdraw one slip of paper for each homework assignment completed."
      },
      {
        "scenario": "For example, if the Teachers have used classroom lotteries with a variety of student accomplishments, such as reading non-assigned books.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, if the Teachers have used classroom lotteries with a variety of student accomplishments, such as reading non-assigned books."
      }
    ],
    "comparisons": [],
    "misconceptions": [
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "A tandem schedule (tand) operates like the chained schedule, except that discriminative stimuli are not used with the elements in the chain.",
        "sourceHint": "A tandem schedule (tand) operates like the chained schedule, except that discriminative stimuli are not used with the elements in the chain."
      }
    ],
    "examChecklist": [
      "Define \"reinforcement\" from memory and match the source text.",
      "Define \"schedule of reinforcement\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"schedule of reinforcement is a rule that describes a conroom (a light comes on), and putting money into a vending A will produce reinforcement.\"",
        "options": [
          {
            "label": "A",
            "text": "reinforcement"
          },
          {
            "label": "B",
            "text": "schedule of reinforcement"
          },
          {
            "label": "C",
            "text": "adjunctive behaviors"
          },
          {
            "label": "D",
            "text": "differential reinforcement of low"
          }
        ],
        "answer": "A",
        "explanation": "\"schedule of reinforcement is a rule that describes a conroom (a light comes on), and putting money into a vending A will produce reinforcement.\" is the chapter's own definition of reinforcement.",
        "topic": "Key terms",
        "sourceHint": "schedule of reinforcement is a rule that describes a conroom (a light comes on), and putting money into a vending A will produce reinforcement."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"schedule of reinforcement is a rule that describes a conroom (a light comes on), and putting money into a vending A will produce reinforcement.\"",
        "options": [
          {
            "label": "A",
            "text": "reinforcement"
          },
          {
            "label": "B",
            "text": "adjunctive behaviors"
          },
          {
            "label": "C",
            "text": "differential reinforcement of low"
          },
          {
            "label": "D",
            "text": "schedule of reinforcement"
          }
        ],
        "answer": "D",
        "explanation": "\"schedule of reinforcement is a rule that describes a conroom (a light comes on), and putting money into a vending A will produce reinforcement.\" is the chapter's own definition of schedule of reinforcement.",
        "topic": "Key terms",
        "sourceHint": "schedule of reinforcement is a rule that describes a conroom (a light comes on), and putting money into a vending A will produce reinforcement."
      }
    ],
    "reviewPrompts": [
      "Define \"reinforcement\" in your own words, then check against the chapter glossary.",
      "Define \"schedule of reinforcement\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"A schedule of reinforcement is a rule that establishes the probability that a specific occurrence of a behavior will produce reinforcement..\"",
      "Restate this idea from the chapter in your own words: \"Continuous reinforcement and extinction provide the boundaries for all other schedules of reinforcement..\"",
      "What is the single most important takeaway from \"Schedules of Reinforcement\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "Applied behavior analysts should include an analysis of the basic intermittent schedules and the compound ing of the schedule effects in applied settings will advance the development of applied behavior analysis and its applications."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true
    }
  },
  "14": {
    "meta": {
      "id": "14",
      "number": 14,
      "title": "Positive Punishment",
      "subtitle": "SP+, response cost vs additive aversives, side effects",
      "part": "Part 5 - Punishment",
      "bacb": [
        "B-6",
        "B-8",
        "G-16",
        "H-4",
        "H-5"
      ]
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [
      {
        "id": "B-6",
        "text": "Define and provide examples of positive and negative punishment contingencies."
      },
      {
        "id": "B-8",
        "text": "Defi ne and provide examples of unconditioned, cond itioned, and generalized reinforcers and pun ishers."
      },
      {
        "id": "G-16",
        "text": "Use positive and negative punishment (e.g., time-out, response cost, overcorrection)."
      },
      {
        "id": "H-4",
        "text": "When a target behavior is to be decreased, select an acceptable alternative behavior to be established or increased."
      },
      {
        "id": "H-5",
        "text": "Plan for possible unwanted effects when using reinforcement, extinction, and punishment procedures."
      }
    ],
    "coreConcepts": [
      {
        "title": "Definition and Characteristics of Punishment",
        "body": [
          "Punishment has occurred when a response is followed immediately by a stimulus change that decreases the frequency of that type of behavior in the future."
        ],
        "bullets": [
          "Punishment is defined neither by the actions of the person delivering the consequences nor by the nature of those consequences. A decrease in the future occurrences of the behavior must be observed before a consequence-based intervention qualifies as punishment. absence of the s0 P as a result of a conditioning history in which responses in the presence of the s0 P have been punished and similar responses in the absence of that stimulus have not been punished (or have resulted in a reduced frequency or magnitude of punishment).",
          "Positive punishment has occurred when the presentation of a stimulus (or an increase in the intensity of an already present stimulus) immediately following a behavior results in a decrease in the frequency of the behavior.",
          "Negative punishment has occurred when the termination of an already present stimulus (or a decrease in the intensity of an already present stimulus) immediately following a behavior results in a decrease in future occurrences of the behavior.",
          "Because aversive events are associated with positive punishment and with negative reinforcement, the term aversive control is often used to describe interventions involving either or both of these two principles."
        ]
      },
      {
        "title": "Possible Side Effects and Problems with Punishment",
        "body": [
          "A generalized conditioned punisher will function as punishment under a wide range of motivating operations because of its previous pairing with numerous unconditioned and conditioned punishers."
        ],
        "bullets": []
      },
      {
        "title": "Positive Punishment Interventions",
        "body": [
          "Response blocking: When the learner begins to emit the problem behavior, the therapist physically intervenes to prevent or \"block\" the completion of the response."
        ],
        "bullets": [
          "Contingent exercise: In this intervention, the client is required to perform a response that is not topographically related to the problem behavior.",
          "Overcorrection: This is a punishment-based tactic in which, contingent on each occurrence of the problem behavior, the learner is required to engage in effortful behavior that is directly or logically related to the problem.",
          "Positive practice overcorrection: In this type of overcorrection, the learner repeatedly performs a correct form of the behavior, or a behavior incompatibl e with the problem behavior, for a specified time or number of responses. • Mediate unavoidable response-to-punishment delays. • Supplement punishment with complementary interventions, in particular, differential reinforcement, extinction, and antecedent interventions. • Watch and be prepared for negative side effects. • Record, graph, and evaluate data daily."
        ]
      },
      {
        "title": "Ethical Considerations Regarding the Use",
        "body": [
          "The first ethical responsibility for any human services professional or agency is to do no harm. Any intervention must be physically safe for all involved and contain no elements that are degrading or disrespectful to the client."
        ],
        "bullets": [
          "The doctri ne of the least restrictive alternative holds that less intrusive procedures (e.g., positive reductive approaches) must be tried first and found to be ineffective before more intrusive procedures are implemented (e.g. , a punishment-based intervention). ethical issue. Some maintain that the failure to use a punishment procedure that research has shown to suppress self-destructive behavior is unethical because it withholds a potentially effective treatment and may maintain a dangerous or uncomfortable state for the client.",
          "Contingent exercise: In this intervention, the client is required to perform a response that is not topographically related to the problem behavior."
        ]
      },
      {
        "title": "Guidelines for Using Punishment",
        "body": [
          "Agencies and individuals providing applied behavior analysis services can help ensure that applications of punishment-based interventions are safe, humane, ethical, and effective by creating and following a set of policy standards, procedural safeguards, and evaluation requirements."
        ],
        "bullets": []
      },
      {
        "title": "Concluding Perspectives",
        "body": [
          "Applied behavior analysts should recognize and appreciate the natural role of punishment and the importance of punishment to learning."
        ],
        "bullets": [
          "Many misapplications of punishment reflect the field 's incomplete knowledge of the principle. More basic and applied research on punishment is needed.",
          "Applied behavior analysts should advocate for the deliver the punisher as early in the response sequence as judicious and ethical application punishment, incorporate possible. a full range of differential reinforcement contingencies, antecedent interventions, and extinction to reduce behaviors, study the conditions under which default technologies are considered and used, so as to eventually make them unnecessary."
        ]
      }
    ],
    "glossary": [
      {
        "term": "behavioral contrast",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "overcorrection",
        "definition": "First, overcorrection is a labor-intensive, time-consuming procedure that requires the full attention of the practitioner implementing it.",
        "sourceHint": "First, overcorrection is a labor-intensive, time-consuming procedure that requires the full attention of the practitioner implementing it."
      },
      {
        "term": "response blocking",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "conditioned punisher",
        "definition": "A conditioned punisher is a stimulus that has acquired its punishing capabilities by being paired with unconditioned or conditioned punishers.",
        "sourceHint": "A conditioned punisher is a stimulus that has acquired its punishing capabilities by being paired with unconditioned or conditioned punishers."
      },
      {
        "term": "positive practice overcorrection",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "response interruption and redirection",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "discriminative st imulus for",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "positive punishment",
        "definition": "Positive punishment occurs when the presentation of a stimulus (or an increase in the intensity of an already present stimulus) immediately following a behavior results in a decrease in the frequency of the behavproved successful in reducing the frequency of Andrea's biting ior.",
        "sourceHint": "Positive punishment occurs when the presentation of a stimulus (or an increase in the intensity of an already present stimulus) immediately following a behavior results in a decrease in the frequency of the behavproved successful in reducing the frequency of Andrea's biting ior."
      },
      {
        "term": "punishment",
        "definition": "Although punishment is a natural phenomenon and one of stood and frequently misapplied, and its application is controversial.",
        "sourceHint": "Although punishment is a natural phenomenon and one of stood and frequently misapplied, and its application is controversial."
      },
      {
        "term": "punisher",
        "definition": "Types of Punishers A punisher is a stimulus change that immediately follows a response and decreases future occurrences of that type of behavior.",
        "sourceHint": "Types of Punishers A punisher is a stimulus change that immediately follows a response and decreases future occurrences of that type of behavior."
      },
      {
        "term": "restit utional overcorrection",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "generalized condit ioned punisher",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "unconditioned punisher",
        "definition": "An unconditioned punisher is a stimulus whose presentation function s as punishment without having been paired with any other punishers .",
        "sourceHint": "An unconditioned punisher is a stimulus whose presentation function s as punishment without having been paired with any other punishers ."
      },
      {
        "term": "negative punishment",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "recovery from punishment",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Learning from consequences that produce pain, discomfort,",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "versia",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "Punishments meted out by the legal system, such as jail time and fines , are often considered a process by which con- This section presents the functional relation that defines punishvicted lawbreakers must repay their debt to society.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Punishments meted out by the legal system, such as jail time and fines , are often considered a process by which con- This section presents the functional relation that defines punishvicted lawbreakers must repay their debt to society."
      },
      {
        "scenario": "Stubbing one's toe on a chair leg is an example of positive punishment- if it suppresses the frequency of the behavior that preceded the toe stub-because the painful stimulation is best described as the presentation of a stimulus.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Stubbing one's toe on a chair leg is an example of positive punishment- if it suppresses the frequency of the behavior that preceded the toe stub-because the painful stimulation is best described as the presentation of a stimulus."
      },
      {
        "scenario": "For example, when a small child's misbehavior is eaten his fill and set the sandwich down.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, when a small child's misbehavior is eaten his fill and set the sandwich down."
      },
      {
        "scenario": "For example, Baum (2017) described how the application and threat of physical beatings might condition the behavior of people living in a police state.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, Baum (2017) described how the application and threat of physical beatings might condition the behavior of people living in a police state."
      }
    ],
    "comparisons": [],
    "misconceptions": [
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "Contingent exercise: In this intervention, the client is required to perform a response that is not topographically related to the problem behavior.",
        "sourceHint": "Contingent exercise: In this intervention, the client is required to perform a response that is not topographically related to the problem behavior."
      },
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "Contingent exercise: In this intervention, the client is required to perform a response that is not topographically related to the problem behavior.",
        "sourceHint": "Contingent exercise: In this intervention, the client is required to perform a response that is not topographically related to the problem behavior."
      }
    ],
    "examChecklist": [
      "Address objective B-6: Define and provide examples of positive and negative punishment contingencies.",
      "Address objective B-8: Defi ne and provide examples of unconditioned, cond itioned, and generalized reinforcers and pun ishers.",
      "Address objective G-16: Use positive and negative punishment (e.g., time-out, response cost, overcorrection).",
      "Address objective H-4: When a target behavior is to be decreased, select an acceptable alternative behavior to be established or increased.",
      "Address objective H-5: Plan for possible unwanted effects when using reinforcement, extinction, and punishment procedures.",
      "Define \"overcorrection\" from memory and match the source text.",
      "Define \"conditioned punisher\" from memory and match the source text.",
      "Define \"positive punishment\" from memory and match the source text.",
      "Define \"punishment\" from memory and match the source text.",
      "Define \"punisher\" from memory and match the source text.",
      "Define \"unconditioned punisher\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"First, overcorrection is a labor-intensive, time-consuming procedure that requires the full attention of the practitioner implementing it.\"",
        "options": [
          {
            "label": "A",
            "text": "overcorrection"
          },
          {
            "label": "B",
            "text": "conditioned punisher"
          },
          {
            "label": "C",
            "text": "positive punishment"
          },
          {
            "label": "D",
            "text": "punishment"
          }
        ],
        "answer": "A",
        "explanation": "\"First, overcorrection is a labor-intensive, time-consuming procedure that requires the full attention of the practitioner implementing it.\" is the chapter's own definition of overcorrection.",
        "topic": "Key terms",
        "sourceHint": "First, overcorrection is a labor-intensive, time-consuming procedure that requires the full attention of the practitioner implementing it."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"A conditioned punisher is a stimulus that has acquired its punishing capabilities by being paired with unconditioned or conditioned punishers.\"",
        "options": [
          {
            "label": "A",
            "text": "overcorrection"
          },
          {
            "label": "B",
            "text": "positive punishment"
          },
          {
            "label": "C",
            "text": "punishment"
          },
          {
            "label": "D",
            "text": "conditioned punisher"
          }
        ],
        "answer": "D",
        "explanation": "\"A conditioned punisher is a stimulus that has acquired its punishing capabilities by being paired with unconditioned or conditioned punishers.\" is the chapter's own definition of conditioned punisher.",
        "topic": "Key terms",
        "sourceHint": "A conditioned punisher is a stimulus that has acquired its punishing capabilities by being paired with unconditioned or conditioned punishers."
      },
      {
        "id": "Q3",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Positive punishment occurs when the presentation of a stimulus (or an increase in the intensity of an already present stimulus) immediately following a behavior results in a decrease in the frequency of the behavproved successful in reducing the frequency of Andrea's biting ior.\"",
        "options": [
          {
            "label": "A",
            "text": "conditioned punisher"
          },
          {
            "label": "B",
            "text": "punishment"
          },
          {
            "label": "C",
            "text": "positive punishment"
          },
          {
            "label": "D",
            "text": "overcorrection"
          }
        ],
        "answer": "C",
        "explanation": "\"Positive punishment occurs when the presentation of a stimulus (or an increase in the intensity of an already present stimulus) immediately following a behavior results in a decrease in the frequency of the behavproved successful in reducing the frequency of Andrea's biting ior.\" is the chapter's own definition of positive punishment.",
        "topic": "Key terms",
        "sourceHint": "Positive punishment occurs when the presentation of a stimulus (or an increase in the intensity of an already present stimulus) immediately following a behavior results in a decrease in the frequency of the behavproved successful in reducing the frequency of Andrea's biting ior."
      },
      {
        "id": "Q4",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Although punishment is a natural phenomenon and one of stood and frequently misapplied, and its application is controversial.\"",
        "options": [
          {
            "label": "A",
            "text": "positive punishment"
          },
          {
            "label": "B",
            "text": "punishment"
          },
          {
            "label": "C",
            "text": "overcorrection"
          },
          {
            "label": "D",
            "text": "conditioned punisher"
          }
        ],
        "answer": "B",
        "explanation": "\"Although punishment is a natural phenomenon and one of stood and frequently misapplied, and its application is controversial.\" is the chapter's own definition of punishment.",
        "topic": "Key terms",
        "sourceHint": "Although punishment is a natural phenomenon and one of stood and frequently misapplied, and its application is controversial."
      },
      {
        "id": "Q5",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Types of Punishers A punisher is a stimulus change that immediately follows a response and decreases future occurrences of that type of behavior.\"",
        "options": [
          {
            "label": "A",
            "text": "punisher"
          },
          {
            "label": "B",
            "text": "overcorrection"
          },
          {
            "label": "C",
            "text": "conditioned punisher"
          },
          {
            "label": "D",
            "text": "positive punishment"
          }
        ],
        "answer": "A",
        "explanation": "\"Types of Punishers A punisher is a stimulus change that immediately follows a response and decreases future occurrences of that type of behavior.\" is the chapter's own definition of punisher.",
        "topic": "Key terms",
        "sourceHint": "Types of Punishers A punisher is a stimulus change that immediately follows a response and decreases future occurrences of that type of behavior."
      },
      {
        "id": "Q6",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"An unconditioned punisher is a stimulus whose presentation function s as punishment without having been paired with any other punishers .\"",
        "options": [
          {
            "label": "A",
            "text": "overcorrection"
          },
          {
            "label": "B",
            "text": "conditioned punisher"
          },
          {
            "label": "C",
            "text": "positive punishment"
          },
          {
            "label": "D",
            "text": "unconditioned punisher"
          }
        ],
        "answer": "D",
        "explanation": "\"An unconditioned punisher is a stimulus whose presentation function s as punishment without having been paired with any other punishers .\" is the chapter's own definition of unconditioned punisher.",
        "topic": "Key terms",
        "sourceHint": "An unconditioned punisher is a stimulus whose presentation function s as punishment without having been paired with any other punishers ."
      }
    ],
    "reviewPrompts": [
      "Define \"overcorrection\" in your own words, then check against the chapter glossary.",
      "Define \"conditioned punisher\" in your own words, then check against the chapter glossary.",
      "Define \"positive punishment\" in your own words, then check against the chapter glossary.",
      "Define \"punishment\" in your own words, then check against the chapter glossary.",
      "Define \"punisher\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"Punishment has occurred when a response is followed immediately by a stimulus change that decreases the frequency of that type of behavior in the future..\"",
      "Restate this idea from the chapter in your own words: \"Punishment is defined neither by the actions of the person delivering the consequences nor by the nature of those consequences.\""
    ],
    "recap": [
      "Applied behavior analysts should advocate for the deliver the punisher as early in the response sequence as judicious and ethical application punishment, incorporate possible."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true
    }
  },
  "15": {
    "meta": {
      "id": "15",
      "number": 15,
      "title": "Negative Punishment",
      "subtitle": "Time-out, response cost",
      "part": "Part 5 - Punishment",
      "bacb": [
        "G-16",
        "H-4",
        "H-5"
      ]
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [
      {
        "id": "G-16",
        "text": "Use positive and negative punishment (e.g., time-out, response cost, overcorrection)."
      },
      {
        "id": "H-4",
        "text": "When a target behavior is to be decreased, select an acceptable alternative behavior to be established or increased."
      },
      {
        "id": "H-5",
        "text": "Plan for possible unwanted effects w hen using reinforcement, extinction, and punishment procedures."
      }
    ],
    "coreConcepts": [
      {
        "title": "Time-Out from Positive Reinforcement Defined",
        "body": [
          "Time-out from positive reinforcement (or simply time-out) is the immediate response-contingent withdrawal of the opportunity to earn positive reinforcers or the immediate loss of access to positive reinforcers for a specified time."
        ],
        "bullets": [
          "To function as negative punishment, the time-out procedure must decrease future occurrences of similar behaviors. Implicit in the definition of time-out are three important factors: (a) The discrepancy between the \"time-in\" and the time-out environments must be discriminative, (b) the response-contingent loss of access to reinforcement must occur immediately, and (c) a resultant decrease in the future frequency of the time-out-producing behavior must occur."
        ]
      },
      {
        "title": "Time-Out Tactics for Applied Settings",
        "body": [
          "There are two basic types of time-out: nonexclusion and exclusion."
        ],
        "bullets": [
          "Nonexclusion time-out means that contingent on the occurrence of the target behavior, the participant remains physically within the time-in setting, but elements of that setting are changed so that (a) the opportunity to earn reinforcers is removed; (b) a specific reinforcer is terminated; time-in setting.",
          "Nonexclusion time-out is typically implemented using one of four tactics: planned ignoring, terminate specific reinforcer contact, contingent observation, and partition/select space time-out.",
          "Exclusion time-out is the physical separation of the participant from the time-in environment when time-out goes into effect.",
          "There are two basic tactics for implementing exclusion time-out contingent on the occurrence of the target behavior: (a) The participant is removed immediately from the time-in environment, or (b) the time-in environment is removed immediately from the participant."
        ]
      },
      {
        "title": "Using Time-Out Effectively",
        "body": [
          "The time-in environment must be reinforcing if time-out is to be effective."
        ],
        "bullets": [
          "Effective use of time-out requires that the behaviors leading to, the duration of, and exit criteria for time-out be explicitly stated. Further, practitioners must decide whether to use nonexclusion or exclusion time-out.",
          "The exit criteria for time-out can be conceptualized in three dimensions: (a) the duration of any individual timeout session, (b) the behavioral criteria for leaving time-out and returning to the time-in setting, and (c) the overall length of the time-out program.",
          "The duration of any individual time-out session, the behavioral criteria that prompt termination of time-out, and the duration of the time-out program need to be made explicit before launching time-out, and appropriate ethical and legal guidelines should be followed. (c) repositioning occurs so that observations of ongoing",
          "In the majority of applications, permission is required activity continue, but without reinforcement; or (d) the before time-out can be implemented. individual is removed to a different space within the"
        ]
      },
      {
        "title": "Response Cost Defined",
        "body": [
          "Response cost is the response-contingent loss of a specific number of positive reinforcers that has the effect of decreasing the future occurrence of similar responses."
        ],
        "bullets": [
          "Response cost typically involves the loss of one or more generalized conditioned reinforcers, tangibles, or minutes of already-earned time with a preferred activity.",
          "The punitive value of the lost reinforcers depends entirely on the individual reinforcement preferences of the participant.",
          "Response cost affords practitioners a number of desirable features. It is effective, meets the standard for least restrictive alternative, produces rapid suppression of behavior, is convenient, can be combined with other procedures, and is socially valid."
        ]
      },
      {
        "title": "Response Cost Methods",
        "body": [
          "Bonus response cost operates when practitioners make additional reinforcers available noncontingently to the participant, specifically for removal when a target behavior occurs."
        ],
        "bullets": []
      },
      {
        "title": "Using Response Cost Effectively",
        "body": [
          "To use response cost effectively, practitioners should deliver fines immediately, decide whether bonus response cost is a preferred option, ensure reinforcer reserve, recognize the potential for unplanned or unexpected outcomes, avoid overusing response cost, and keep records on its effects."
        ],
        "bullets": []
      },
      {
        "title": "Response Cost Considerations",
        "body": [
          "Implementing response cost may increase aggression, produce avoidance responses, affect collateral reductions of desired behaviors, call attention to the punished behavior, be unpredictable, and suffer treatment integrity challenges. This page intentionally left blank"
        ],
        "bullets": []
      }
    ],
    "glossary": [
      {
        "term": "bonus response cost",
        "definition": "To use response cost effectively, practitioners should deliver fines immediately, decide whether bonus response cost is a preferred option, ensure reinforcer reserve, recognize the potential for unplanned or unexpected outcomes, avoid overusing response cost, and keep records on its effects.",
        "sourceHint": "To use response cost effectively, practitioners should deliver fines immediately, decide whether bonus response cost is a preferred option, ensure reinforcer reserve, recognize the potential for unplanned or unexpected outcomes, avoid overusing response cost, and keep records on its effects."
      },
      {
        "term": "nonexclusion time-out",
        "definition": "Nonexclusion Time-Out Nonexclusion time-out means that contingent on the occurrence of the target behavior, the participant remains physically within the time-in setting, but elements of that setting are changed so level during school lunchtime.",
        "sourceHint": "Nonexclusion Time-Out Nonexclusion time-out means that contingent on the occurrence of the target behavior, the participant remains physically within the time-in setting, but elements of that setting are changed so level during school lunchtime."
      },
      {
        "term": "terminate specific reinforcer contact",
        "definition": "Terminate Specific Reinforcer Contact Terminate specific reinforcer contact is a variation of timeout whereby each occurrence of the target behavior immediately stops an activity or sensory reinforcer.",
        "sourceHint": "Terminate Specific Reinforcer Contact Terminate specific reinforcer contact is a variation of timeout whereby each occurrence of the target behavior immediately stops an activity or sensory reinforcer."
      },
      {
        "term": "contingent observation",
        "definition": "An athletic analog to contingent observation occurs when an athlete commits an unnecessary foul during a game, and, in turn, the coach immediately \"sidelines\" the player.",
        "sourceHint": "An athletic analog to contingent observation occurs when an athlete commits an unnecessary foul during a game, and, in turn, the coach immediately \"sidelines\" the player."
      },
      {
        "term": "partition or select space t ime-out",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "t ime-out from positive reinforcement",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "exclusion time-out",
        "definition": "Exclusion Time-Out Exclusion time-out is the physical separation of the participant from the time-in environment when time-out goes into effect.",
        "sourceHint": "Exclusion Time-Out Exclusion time-out is the physical separation of the participant from the time-in environment when time-out goes into effect."
      },
      {
        "term": "planned ignoring",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "negative punishment",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "response cost",
        "definition": "Response cost is the response-contingent loss of a specific number of positive reinforcers that has the effect of decreasing the future occurrence of similar responses.",
        "sourceHint": "Response cost is the response-contingent loss of a specific number of positive reinforcers that has the effect of decreasing the future occurrence of similar responses."
      },
      {
        "term": "egative punishment contingencies changed the behavior",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "that makes videos disappear!",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "For example, if a behavior targeted for time-out occurred in a one-to-one instrucfuture (see Figure 15.2).",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, if a behavior targeted for time-out occurred in a one-to-one instrucfuture (see Figure 15.2)."
      },
      {
        "scenario": "For example, a demic assignment completed during the morning seatwork period, but lose a point, a star, or a sticker for calling out without permission.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, a demic assignment completed during the morning seatwork period, but lose a point, a star, or a sticker for calling out without permission."
      }
    ],
    "comparisons": [],
    "misconceptions": [
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "Behavior does not occur in an environmental vacuum.",
        "sourceHint": "Behavior does not occur in an environmental vacuum."
      }
    ],
    "examChecklist": [
      "Address objective G-16: Use positive and negative punishment (e.g., time-out, response cost, overcorrection).",
      "Address objective H-4: When a target behavior is to be decreased, select an acceptable alternative behavior to be established or increased.",
      "Address objective H-5: Plan for possible unwanted effects w hen using reinforcement, extinction, and punishment procedures.",
      "Define \"bonus response cost\" from memory and match the source text.",
      "Define \"nonexclusion time-out\" from memory and match the source text.",
      "Define \"terminate specific reinforcer contact\" from memory and match the source text.",
      "Define \"contingent observation\" from memory and match the source text.",
      "Define \"exclusion time-out\" from memory and match the source text.",
      "Define \"response cost\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"To use response cost effectively, practitioners should deliver fines immediately, decide whether bonus response cost is a preferred option, ensure reinforcer reserve, recognize the potential for unplanned or unexpected outcomes, avoid overusing response cost, and keep records on its effects.\"",
        "options": [
          {
            "label": "A",
            "text": "bonus response cost"
          },
          {
            "label": "B",
            "text": "nonexclusion time-out"
          },
          {
            "label": "C",
            "text": "terminate specific reinforcer contact"
          },
          {
            "label": "D",
            "text": "contingent observation"
          }
        ],
        "answer": "A",
        "explanation": "\"To use response cost effectively, practitioners should deliver fines immediately, decide whether bonus response cost is a preferred option, ensure reinforcer reserve, recognize the potential for unplanned or unexpected outcomes, avoid overusing response cost, and keep records on its effects.\" is the chapter's own definition of bonus response cost.",
        "topic": "Key terms",
        "sourceHint": "To use response cost effectively, practitioners should deliver fines immediately, decide whether bonus response cost is a preferred option, ensure reinforcer reserve, recognize the potential for unplanned or unexpected outcomes, avoid overusing response cost, and keep records on its effects."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Nonexclusion Time-Out Nonexclusion time-out means that contingent on the occurrence of the target behavior, the participant remains physically within the time-in setting, but elements of that setting are changed so level during school lunchtime.\"",
        "options": [
          {
            "label": "A",
            "text": "bonus response cost"
          },
          {
            "label": "B",
            "text": "terminate specific reinforcer contact"
          },
          {
            "label": "C",
            "text": "contingent observation"
          },
          {
            "label": "D",
            "text": "nonexclusion time-out"
          }
        ],
        "answer": "D",
        "explanation": "\"Nonexclusion Time-Out Nonexclusion time-out means that contingent on the occurrence of the target behavior, the participant remains physically within the time-in setting, but elements of that setting are changed so level during school lunchtime.\" is the chapter's own definition of nonexclusion time-out.",
        "topic": "Key terms",
        "sourceHint": "Nonexclusion Time-Out Nonexclusion time-out means that contingent on the occurrence of the target behavior, the participant remains physically within the time-in setting, but elements of that setting are changed so level during school lunchtime."
      },
      {
        "id": "Q3",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Terminate Specific Reinforcer Contact Terminate specific reinforcer contact is a variation of timeout whereby each occurrence of the target behavior immediately stops an activity or sensory reinforcer.\"",
        "options": [
          {
            "label": "A",
            "text": "nonexclusion time-out"
          },
          {
            "label": "B",
            "text": "contingent observation"
          },
          {
            "label": "C",
            "text": "terminate specific reinforcer contact"
          },
          {
            "label": "D",
            "text": "bonus response cost"
          }
        ],
        "answer": "C",
        "explanation": "\"Terminate Specific Reinforcer Contact Terminate specific reinforcer contact is a variation of timeout whereby each occurrence of the target behavior immediately stops an activity or sensory reinforcer.\" is the chapter's own definition of terminate specific reinforcer contact.",
        "topic": "Key terms",
        "sourceHint": "Terminate Specific Reinforcer Contact Terminate specific reinforcer contact is a variation of timeout whereby each occurrence of the target behavior immediately stops an activity or sensory reinforcer."
      },
      {
        "id": "Q4",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"An athletic analog to contingent observation occurs when an athlete commits an unnecessary foul during a game, and, in turn, the coach immediately \"sidelines\" the player.\"",
        "options": [
          {
            "label": "A",
            "text": "terminate specific reinforcer contact"
          },
          {
            "label": "B",
            "text": "contingent observation"
          },
          {
            "label": "C",
            "text": "bonus response cost"
          },
          {
            "label": "D",
            "text": "nonexclusion time-out"
          }
        ],
        "answer": "B",
        "explanation": "\"An athletic analog to contingent observation occurs when an athlete commits an unnecessary foul during a game, and, in turn, the coach immediately \"sidelines\" the player.\" is the chapter's own definition of contingent observation.",
        "topic": "Key terms",
        "sourceHint": "An athletic analog to contingent observation occurs when an athlete commits an unnecessary foul during a game, and, in turn, the coach immediately \"sidelines\" the player."
      },
      {
        "id": "Q5",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Exclusion Time-Out Exclusion time-out is the physical separation of the participant from the time-in environment when time-out goes into effect.\"",
        "options": [
          {
            "label": "A",
            "text": "exclusion time-out"
          },
          {
            "label": "B",
            "text": "bonus response cost"
          },
          {
            "label": "C",
            "text": "nonexclusion time-out"
          },
          {
            "label": "D",
            "text": "terminate specific reinforcer contact"
          }
        ],
        "answer": "A",
        "explanation": "\"Exclusion Time-Out Exclusion time-out is the physical separation of the participant from the time-in environment when time-out goes into effect.\" is the chapter's own definition of exclusion time-out.",
        "topic": "Key terms",
        "sourceHint": "Exclusion Time-Out Exclusion time-out is the physical separation of the participant from the time-in environment when time-out goes into effect."
      },
      {
        "id": "Q6",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Response cost is the response-contingent loss of a specific number of positive reinforcers that has the effect of decreasing the future occurrence of similar responses.\"",
        "options": [
          {
            "label": "A",
            "text": "bonus response cost"
          },
          {
            "label": "B",
            "text": "nonexclusion time-out"
          },
          {
            "label": "C",
            "text": "terminate specific reinforcer contact"
          },
          {
            "label": "D",
            "text": "response cost"
          }
        ],
        "answer": "D",
        "explanation": "\"Response cost is the response-contingent loss of a specific number of positive reinforcers that has the effect of decreasing the future occurrence of similar responses.\" is the chapter's own definition of response cost.",
        "topic": "Key terms",
        "sourceHint": "Response cost is the response-contingent loss of a specific number of positive reinforcers that has the effect of decreasing the future occurrence of similar responses."
      }
    ],
    "reviewPrompts": [
      "Define \"bonus response cost\" in your own words, then check against the chapter glossary.",
      "Define \"nonexclusion time-out\" in your own words, then check against the chapter glossary.",
      "Define \"terminate specific reinforcer contact\" in your own words, then check against the chapter glossary.",
      "Define \"contingent observation\" in your own words, then check against the chapter glossary.",
      "Define \"exclusion time-out\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"Time-out from positive reinforcement (or simply time-out) is the immediate response-contingent withdrawal of the opportunity to earn positive reinforcers or the immediate loss of access to positive reinforcers for a specified time..\"",
      "Restate this idea from the chapter in your own words: \"To function as negative punishment, the time-out procedure must decrease future occurrences of similar behaviors.\""
    ],
    "recap": [
      "Implementing response cost may increase aggression, produce avoidance responses, affect collateral reductions of desired behaviors, call attention to the punished behavior, be unpredictable, and suffer treatment integrity challenges."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true
    }
  },
  "16": {
    "meta": {
      "id": "16",
      "number": 16,
      "title": "Motivating Operations",
      "subtitle": "EO/AO, value-altering & behavior-altering effects",
      "part": "Part 6 - Antecedent Variables",
      "bacb": [
        "G-2"
      ]
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [
      {
        "id": "G-2",
        "text": "Use interventions based on motivating operations and discriminative stimuli."
      }
    ],
    "coreConcepts": [
      {
        "title": "Operations",
        "body": [
          "A motivating operation (MO) (a) alters the effectiveness effect."
        ],
        "bullets": [
          "The value-altering effect is either (a) an increase in the reinforcing effectiveness of some stimulus, in which case the MO is an establishing operation (EO); or (b) a decrease in reinforcing effectiveness, in which case the MO is an abolishing operation (AO).",
          "The behavior-altering effect is either (a) an increase in the current frequency of behavior that has been reinforced by some stimulus, called an evocative effect; or (b) a decrease in the current frequency of behavior that has been reinof some stimulus as a reinforcer, the value-altering effect; forced by some stimulus, called an abative effect. and (b) alters the current frequency of all behavior that has been reinforced by that stimulus, the behavior-altering 4. The value-altering effect of an MO changes the potency of reinforcers (or punishers) to increase and maintain (or decrease and eliminate) behavior",
          "The behavior-altering effect is a change in frequency due to the organism's behavior contacting reinforcement or punishment. This change occurs only after the consequence has been obtained.",
          "The value-altering and behavior-altering effects of an MO occur simultaneously but are considered independent in the sense that one does not derive from the other. However, once behavior contacts reinforcement, these two effects may not be discernible."
        ]
      },
      {
        "title": "Distinguishing Between MOs and s0 s",
        "body": [
          "An SD controls a type of behavior because it has been related to the differential availability of an effective reinforcer for that type of behavior. This means that the relevant consequence has been available in the presence of, and unavailable in the absence of, the stimulus. Most variables that qualify as motivating operations fail to meet this second s0 requirement because in the absence of the variable, there is no MO for the relevant reinforcer, and thus no reinforcer unavailability."
        ],
        "bullets": [
          "A useful contrast is that s0 s are related to the differential availability of a currently effective fom1 of reinforcement for a particular type of behavior, whereas MOs are related to the differential reinforcing effectiveness of a particular event.",
          "In nontechnical terms, an SD tells you that something you want is available; an MO makes you want something."
        ]
      },
      {
        "title": "Unconditioned Motivating Operations (UMOs)",
        "body": [
          "The main UMOs for humans are those related to deprivation and satiation with respect to food, water, oxygen, activity, and sleep; and those related to sexual reinforcement, comfortable temperature conditions, and painful stimulation. For each variable, there are two MOs, one with an establishing operation (EO) and one with an abolishing operation (AO). Also, each variable has an evocative effect and an abative effect. Thus food deprivation is an EO and has evocative effects on relevant behavior, and food ingestion is an AO and has abative effects on relevant behavior."
        ],
        "bullets": []
      },
      {
        "title": "MOs for Punishment",
        "body": [
          "MOs alter (increase or decrease) the punishing effectiveness of a stimulus, as well as the frequency (evoke or abate) of behaviors that have been punished by that sti mulus."
        ],
        "bullets": [
          "An EO related to punishment would have a punisherestablishing effect and an abative effect.",
          "An AO related to punishment would have a punisherabolishing effect and an evocative effect, in that behaviors that have been punished would occur again (assuming that a reinforcer contingency for the previously punished behavior is intact).",
          "In the case of conditioned punishers that were established by having been paired with the removal (or reduced availability) of reinforcers (i.e., negative punishment), their effectiveness as conditioned punishers will depend on the same MOs that establish the value of the reinforcers that were removed.",
          "Social disapproval, time-out from reinforcement, and response cost are stimulus conditions that usually function as punishment because they are related to a reduction in the availability of some kinds of reinforcers. The MOs for those forms of punishment are the MOs for the reinforcers that are being made less available."
        ]
      },
      {
        "title": "Multiple Effects of MOs",
        "body": [
          "Events that function as UMOs will typically have behavior-altering effects on the current frequency of a type of behavior and, when presented as consequences, will have function-altering effects on the future frequency of behavior that immedi ately preceded their onset."
        ],
        "bullets": [
          "Events that have MO evocative effects, such as painful stimulation, will also function as punishment for the response immediately preceding the onset of the event."
        ]
      },
      {
        "title": "Conditioned Motivating Operations (CMOs)",
        "body": [
          "Motivating variables that alter the reinforcing effectiveness of other stimuli, objects, or events, but only as a result of the organism's learning history, are called conditioned motivating operations (CMOs). As with the UMOs, they also alter the momentary frequency of all behavior that has been reinforced (or punished) by those other events."
        ],
        "bullets": [
          "The surrogate CMO (CMO-S) is a stimulus that acquires its MO effectiveness by being paired with another MO, and has the same value-altering and behavior-altering effects as the MO with which it was paired. 394 Part 6 • Antecedent Variables",
          "The CMO-S appears to play a role in the development of behaviors that do not seem to make much sense, such as seeing a restaurant after dinner and wanting to eat again or feeling the urge to urinate after seeing the sign for the restroom. Both the restaurant and the restroom may evoke behavior as a CMO-S, given previous pairings with food deprivation and a full bladder, respectively.",
          "A stimulus that acquires MO effectiveness by preceding some form of worsening or improvement is called a reflexive CMO (CMO-R). It is exemplified by the warning stimulus in a typical escape-avoidance procedure, which establishes its own offset as reinforcement and evokes all behavior that has accomplished that offset.",
          "A stimulus that has preceded some form of improvement may also function as a CMO-R by (a) establishing its own offset as an effective punisher and (b) abating any behav- Relevance of MOs to the Generality ior that has been so punished."
        ]
      },
      {
        "title": "Relevance of MOs to Applied Behavior Analysis",
        "body": [
          "of MOs on a multitude of behaviors across a variety of conditions. MOs have affected the results of preference assessments and functional analyses, engagement with activities, within-session responding, social initiations, the rate of acquisition of target behaviors, and the occurrence of challenging behaviors. that the three-term contingency is dependent upon a fourth variable that modulates the effectiveness of reinforcement, and hence the evocative strength of the discriminative stimuli."
        ],
        "bullets": [
          "A clear understanding of MOs seems critical not only for interpreting and assessing results but also for designing effective behavior analytic interventions.",
          "Given the ubiquity of motivational variables in our lives, a complete understanding of human behavior demands an analysis of the critical roles of MOs."
        ]
      }
    ],
    "glossary": [
      {
        "term": "abative effect",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "transitive cond it io ned motivating",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "reflexive conditio ned motivating",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "behavior-a ltering effect",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "unconditioned motivating operatio n",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "reinforcer-abolishing effect",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "reinforcer-establish ing effect",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "MO unpairing",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "surrogate condit ioned motivating",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "value-altering effect",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "evocative effect",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "function-altering effect",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "stimuli may vary conditionally with other environmen-",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "good unless we are eating som",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "In addition to frequency, other aspects of behavior such as response magnitude, latency, and relative frequency (occurrence per opportunity) can be altered by an MO.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "In addition to frequency, other aspects of behavior such as response magnitude, latency, and relative frequency (occurrence per opportunity) can be altered by an MO."
      },
      {
        "scenario": "In other words, after not having food for a while, food becomes a reinforcer, and behaviors such as looking for food are increased.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "In other words, after not having food for a while, food becomes a reinforcer, and behaviors such as looking for food are increased."
      },
      {
        "scenario": "More specifically, this description pertains to variables that are not discrete, such as the presence/absence of immediate events or objects, deprivation/satiation, or recent social interactions, all of which may differentially affect specific functions of stimuli (Leigland, 1984; Wahler & Fox, 1981).",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "More specifically, this description pertains to variables that are not discrete, such as the presence/absence of immediate events or objects, deprivation/satiation, or recent social interactions, all of which may differentially affect specific functions of stimuli (Leigland, 1984; Wahler & Fox, 1981)."
      },
      {
        "scenario": "Thus, terms such as hunger and thirst are unnecessary (intervening) variables that may obscure a behavior analysis of motivation.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Thus, terms such as hunger and thirst are unnecessary (intervening) variables that may obscure a behavior analysis of motivation."
      }
    ],
    "comparisons": [
      {
        "title": "Distinction drawn in the source",
        "left": {
          "label": "First framing",
          "points": [
            "A useful contrast is that s0 s are related to the differential availability of a currently effective fom1 of reinforcement for a particular type of behavior."
          ]
        },
        "right": {
          "label": "Contrast",
          "points": [
            "MOs are related to the differential reinforcing effectiveness of a particular event."
          ]
        },
        "sourceHint": "A useful contrast is that s0 s are related to the differential availability of a currently effective fom1 of reinforcement for a particular type of behavior, whereas MOs are related to the differential reinforcing effectiveness of a particular event."
      },
      {
        "title": "Distinction drawn in the source",
        "left": {
          "label": "First framing",
          "points": [
            "A CMO-T evokes behavior because of its relation to the value of a consequence."
          ]
        },
        "right": {
          "label": "Contrast",
          "points": [
            "to the availability of a consequence."
          ]
        },
        "sourceHint": "A CMO-T evokes behavior because of its relation to the value of a consequence rather than to the availability of a consequence."
      }
    ],
    "misconceptions": [
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "The value-altering and behavior-altering effects of an MO occur simultaneously but are considered independent in the sense that one does not derive from the other.",
        "sourceHint": "The value-altering and behavior-altering effects of an MO occur simultaneously but are considered independent in the sense that one does not derive from the other."
      },
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "Thus, it is possible that generalization and maintenance failures are not only a function of novel (generalization) stimuli being dissimilar to those present during training, but also due to different MOs.",
        "sourceHint": "Thus, it is possible that generalization and maintenance failures are not only a function of novel (generalization) stimuli being dissimilar to those present during training, but also due to different MOs."
      }
    ],
    "examChecklist": [
      "Address objective G-2: Use interventions based on motivating operations and discriminative stimuli."
    ],
    "quiz": [],
    "reviewPrompts": [
      "Restate this idea from the chapter in your own words: \"A motivating operation (MO) (a) alters the effectiveness effect..\"",
      "What is the single most important takeaway from \"Motivating Operations\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "Given the ubiquity of motivational variables in our lives, a complete understanding of human behavior demands an analysis of the critical roles of MOs.."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "quiz": true
    }
  },
  "17": {
    "meta": {
      "id": "17",
      "number": 17,
      "title": "Stimulus Control",
      "subtitle": "SD/SΔ, discrimination, generalization gradients",
      "part": "Part 6 - Antecedent Variables",
      "bacb": []
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [],
    "coreConcepts": [
      {
        "title": "Stimulus Control: Basic Concepts and Processes",
        "body": [
          "Behavior that occurs more often in the presence control."
        ],
        "bullets": [
          "A stimulus generalization gradient graphically depicts the degree of stimulus generalization and discrimination by showing the extent to which responses reinforced in one",
          "Stimulus generalization reflects a loose degree of stimulus control, whereas discrimination indicates a relatively tight degree of stimulus control.",
          "In a conditional discrimination, the response that will produce reinforcement in the presence of a particular stimulus depends on (is conditional on) the presence or absence of other stimuli.",
          "An s0 acquires its controlling function for operant behavior by being paired with stimulus changes that occur immediately following behavior. Conversely, a conditioned stimulus acquires its controlling function for respondent behavior by being paired with other antecedent stimuli that elicit the behavior (i.e., an unconditioned stimulus or conditioned stimulus)."
        ]
      },
      {
        "title": "Developing Stimulus Control",
        "body": [
          "Stimulus discrimination training entails reinforcing responses in the presence of the s0 and not reinforcing responses in the presence of the sa."
        ],
        "bullets": [
          "A concept is defined by a set of shared features found in",
          "Concept formation is a complex example of stimulus con-",
          "An antecedent stimulus class is a set of stimuli that share a common relationship. All of the stimuli in the class will evoke the same operant response class, or elicit the same response in the case of respondent behavior.",
          "Stimuli composing an arbitrary stimulus class evoke the same response, but they do not share a common stimulus feature (i.e., they do not resemble each other in physical form, nor do they share a relational relationship)."
        ]
      },
      {
        "title": "Transferring Stimulus Control",
        "body": [
          "Terrace ( l 963a, b) conducted influential basic research using fading and superimposition of stimuli to transfer stimulus control."
        ],
        "bullets": [
          "Fading response prompts and stimulus prompts can transfer stimulus control from the prompts to the natural stimulus and minimize errors by the learner.",
          "In the most-to-least response prompting procedure, the analyst physically guides the participant through the entire performance sequence and then gradually reduces the amount of physical assistance provided as training progresses from trial to trial and session to session.",
          "With least-to-most prompting, the learner is given the opportunity to perform the response with the least amount of assistance on each trial. The teacher provides increaseach example of the concept. ingly greater degrees of assistance with each successive trial, as needed. trol that requires both stimulus generalization within a class",
          "Stimulus fading involves exaggerating a dimension of a stimulus to increase the likelihood of a correct response. The exaggerated dimension is faded gradually in or out."
        ]
      }
    ],
    "glossary": [
      {
        "term": "antecedent stimulus class",
        "definition": "An antecedent stimulus class is a uli in an antecedent stimulus class will evoke the same operant response class or elicit the same respondent behavior.",
        "sourceHint": "An antecedent stimulus class is a uli in an antecedent stimulus class will evoke the same operant response class or elicit the same respondent behavior."
      },
      {
        "term": "matching-to-sample",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "arb itrary stimulus class",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "most-to-least response prompts",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "stimu lus d iscrimination",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "concept",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "overselective stimu lus control",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "stimu lus d iscrimination train ing",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "conditional discrimination",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "overshadowing",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "stimu lus fad ing",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "constant time delay",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "progressive time delay",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "stimu lus genera lization",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "response prompts",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "stimu lus generalization gradient",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "errorless learning",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "stimulus blocking",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "stimu lus prompts",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "feature stimulus class",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "stimulus control",
        "definition": "Technically, stimulus control occurs when the rate, latency, duration, or magnitude of a response is than with a red or yellow stimulus.",
        "sourceHint": "Technically, stimulus control occurs when the rate, latency, duration, or magnitude of a response is than with a red or yellow stimulus."
      },
      {
        "term": "time delay",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "least-to-most response prompts",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Teach simple and cond itional discriminations.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "reinforcement confers controlling function to antecedent",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "For example, a buzzer sounds occasionally and the rat receives a food pellet after lever presses when the buzzer is sounding, but be observed when a young child who has been reinforced for lever presses in the absence of the buzzer sound produce no food saying \"daddy\" in the presence of her father says \"daddy\" in pellets.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, a buzzer sounds occasionally and the rat receives a food pellet after lever presses when the buzzer is sounding, but be observed when a young child who has been reinforced for lever presses in the absence of the buzzer sound produce no food saying \"daddy\" in the presence of her father says \"daddy\" in pellets."
      },
      {
        "scenario": "Figure 17.2 is an example of a worksheet likely to engender faulty stimulus control.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Figure 17.2 is an example of a worksheet likely to engender faulty stimulus control."
      },
      {
        "scenario": "For example, in a typical shock-escape procedure an animal is placed in an experimental chamber.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, in a typical shock-escape procedure an animal is placed in an experimental chamber."
      },
      {
        "scenario": "Figure 17.4 presents an example of the observing response, the conditional sample, the discriminative events, and the comparison match.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Figure 17.4 presents an example of the observing response, the conditional sample, the discriminative events, and the comparison match."
      }
    ],
    "comparisons": [
      {
        "title": "Distinction drawn in the source",
        "left": {
          "label": "First framing",
          "points": [
            "Stimulus generalization reflects a loose degree of stimulus control."
          ]
        },
        "right": {
          "label": "Contrast",
          "points": [
            "discrimination indicates a relatively tight degree of stimulus control."
          ]
        },
        "sourceHint": "Stimulus generalization reflects a loose degree of stimulus control, whereas discrimination indicates a relatively tight degree of stimulus control."
      },
      {
        "title": "Distinction drawn in the source",
        "left": {
          "label": "First framing",
          "points": [
            "Distinguishing the evocative functions of discriminative stimuli and establishing operations can be difficult. An s0 evokes behavior because its presence has been correlated with the differential availabi lity of an effective reinforcer. EO evokes behavior because it changes what functions as reinforcement."
          ]
        },
        "right": {
          "label": "Contrast",
          "points": [
            "signaling the differential availability of reinforcement."
          ]
        },
        "sourceHint": "Distinguishing the evocative functions of discriminative stimuli and establishing operations can be difficult. An s0 evokes behavior because its presence has been correlated with the differential availabi lity of an effective reinforcer. EO evokes behavior because it changes what functions as reinforcement rather than signaling the differential availability of reinforcement."
      }
    ],
    "misconceptions": [],
    "examChecklist": [
      "Define \"antecedent stimulus class\" from memory and match the source text.",
      "Define \"stimulus control\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"An antecedent stimulus class is a uli in an antecedent stimulus class will evoke the same operant response class or elicit the same respondent behavior.\"",
        "options": [
          {
            "label": "A",
            "text": "antecedent stimulus class"
          },
          {
            "label": "B",
            "text": "stimulus control"
          },
          {
            "label": "C",
            "text": "matching-to-sample"
          },
          {
            "label": "D",
            "text": "arb itrary stimulus class"
          }
        ],
        "answer": "A",
        "explanation": "\"An antecedent stimulus class is a uli in an antecedent stimulus class will evoke the same operant response class or elicit the same respondent behavior.\" is the chapter's own definition of antecedent stimulus class.",
        "topic": "Key terms",
        "sourceHint": "An antecedent stimulus class is a uli in an antecedent stimulus class will evoke the same operant response class or elicit the same respondent behavior."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Technically, stimulus control occurs when the rate, latency, duration, or magnitude of a response is than with a red or yellow stimulus.\"",
        "options": [
          {
            "label": "A",
            "text": "antecedent stimulus class"
          },
          {
            "label": "B",
            "text": "matching-to-sample"
          },
          {
            "label": "C",
            "text": "arb itrary stimulus class"
          },
          {
            "label": "D",
            "text": "stimulus control"
          }
        ],
        "answer": "D",
        "explanation": "\"Technically, stimulus control occurs when the rate, latency, duration, or magnitude of a response is than with a red or yellow stimulus.\" is the chapter's own definition of stimulus control.",
        "topic": "Key terms",
        "sourceHint": "Technically, stimulus control occurs when the rate, latency, duration, or magnitude of a response is than with a red or yellow stimulus."
      }
    ],
    "reviewPrompts": [
      "Define \"antecedent stimulus class\" in your own words, then check against the chapter glossary.",
      "Define \"stimulus control\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"Behavior that occurs more often in the presence control..\"",
      "Restate this idea from the chapter in your own words: \"When an s0 signals a rich schedule of reinforcement and a corresponding sll signals a zero chance of reinforcement (i.e., extinction), the organism will eventually respond only in the presence of the s0 .\"",
      "What is the single most important takeaway from \"Stimulus Control\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "Stimulus shape transformations begin with an initial stimulus shape that will prompt a correct response."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "misconceptions": true
    }
  },
  "18": {
    "meta": {
      "id": "18",
      "number": 18,
      "title": "Verbal Behavior",
      "subtitle": "Mand, tact, echoic, intraverbal; Skinner's analysis",
      "part": "Part 7 - Verbal Behavior",
      "bacb": []
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [],
    "coreConcepts": [
      {
        "title": "Skinner's (1957) Analysis of Verbal Behavior",
        "body": [
          "Skinner argues that language constitutes learned speaker and listener behavior that is acquired, maintained, and extended by environmental contingencies of reinforcement."
        ],
        "bullets": [
          "A given utterance is comprised of formal properties (the words spoken) and functional properties (why those words were spoken).",
          "The formal properties of language involve the topography and structure of verbal responses usually classified in terms of the parts of speech, clauses, and sentences.",
          "The functional properties of language involve the causes of a response often referred to as semantics, or the meaning of words.",
          "From a behavioral perspective, the meaning of a word can be found in the immediate and historical antecedents and consequence that evoke that word."
        ]
      },
      {
        "title": "The Verbal Operants and Listener Behavior in",
        "body": [
          "Mands can be classified by identifying the different types of MOs that control manding behavior (e.g., UMOs, CMOs), and by the different ways mands affect the behavior of the listener and produce specific reinforcement."
        ],
        "bullets": [
          "Several types of MOs are related to aversive stimulation (e.g., too hot, loud noises, demands), and their removal functi ons as specific negative reinforcement.",
          "When sufficient specific positive or negative reinforcement has been provided, it abolishes the MO (e.g., satiation).",
          "Any instance of human behavior is usually a fu nction of multiple variables operating simultaneously. There are two types of multiple control: convergent multiple control and divergent multiple control.",
          "In convergent multiple control, a single response is controlled by more than one antecedent variable."
        ]
      },
      {
        "title": "Listener Behavior",
        "body": [
          "A listener is an active participant in verbal exchanges and serves many roles in this capacity, such as acting as an audience, providing reinforcement for speakers, and taki ng action upon a speaker' s words. for intraverbal relations can be used as a framework to identify various types of nonverbal listener discriminations. In addition, there is a fifth type of verbal discrimination that is specific to listener behavior commonly termed an auditory conditional discrimination. lus alters the evocative effect of a nonverbal stimulus due to a history of reinforcement and evokes a corresponding nonverbal response."
        ],
        "bullets": [
          "A listener often engages in overt or covert verbal behavior in the process of listening to a speaker; when thi s occurs the listener is now a speaker, and his behavior should be classified as such."
        ]
      },
      {
        "title": "Autoclitic Verbal Behavor",
        "body": [
          "A primary verbal response constitutes any of the verbal operants (e.g., mand, tact, intraverbal)."
        ],
        "bullets": [
          "A secondary autoclitic response is controlled by some aspect of the primary verbal operant or by its controlling variables. There are three types of secondary autoclitic behavior: autoclitic mand, autoclitic tact, and autoclitic intraverbal frames.",
          "The autoclitic mand enjoins a listener to take some specific action regarding the primary response, and the autoclitic behavior is reinforced by that action.",
          "The autoclitic tact is controlled by some nonverbal feature of the primary response or its controlling variables, and the autoclitic response informs the listener of that feature. This behavior is reinforced by listeners who provide generalized S'.",
          "lntraverbal autoclitic frames provide order, agreement, grouping, and composition of larger units of verbal behavior. An autoclitic frame facilitates the connections between words in a given utterance and is reinforced by listeners who provide generalized S'."
        ]
      },
      {
        "title": "Behavior",
        "body": [
          "Applied behavior analysis can provide professionals and parents with the necessary intervention procedures and scientific methods to teach language skills."
        ],
        "bullets": [
          "The development of language and social skills by typically developing children can provide a valuable guide for a language intervention curriculum.",
          "Skinner's analysis of verbal behavior can serve as a framework for specific language assessment and intervention programs.",
          "Language assessment for a person with language delays involves measuring the strength of the elementary verbal operants, listener skills, self-listener skill s, multiply controlled responding, speaker-listener interactions.",
          "Assessing a child's mand repertoire involves identifying the degree to which the various MOs control verbal responses."
        ]
      },
      {
        "title": "The Loss of Verbal Behavior",
        "body": [
          "Verbal repertoires can also deteriorate, as observed in cases of dementia, Alzheimer's disease, aphasia, and traumatic brain injury. Skinner's analysis of VB can serve as a guide for language assessment and intervention for these individuals much in the same way it does for those learning to communicate for the first time. This page intentionally left blank"
        ],
        "bullets": []
      }
    ],
    "glossary": [
      {
        "term": "autoclitic",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "intraverba l",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "speaker",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "automatic contingencies",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "listener",
        "definition": "In SB verbal behavior, what is conveyed to the listener is the information on the stimulus selected, as opposed to TB verbal behavior, where the listener's behavior is controlled by the topography of a speaker's response.",
        "sourceHint": "In SB verbal behavior, what is conveyed to the listener is the information on the stimulus selected, as opposed to TB verbal behavior, where the listener's behavior is controlled by the topography of a speaker's response."
      },
      {
        "term": "tact",
        "definition": "Autoclitic Tact An autoclitic tact is a type of secondary verba l behavior that is controll ed by some nonverbal feature of the primary res po nse or its controlling variables, and the a utoclitic response informs the li stener of that feature.",
        "sourceHint": "Autoclitic Tact An autoclitic tact is a type of secondary verba l behavior that is controll ed by some nonverbal feature of the primary res po nse or its controlling variables, and the a utoclitic response informs the li stener of that feature."
      },
      {
        "term": "bidirectional naming",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "listener discrimination",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "tact extension",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "codic",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "mand",
        "definition": "Emergent Mand Relations Learning to mand is a powerful behavioral cusp in early child development (Bijou & Baer, 1965 ; Greer & Ross, 2008; Rosales-Ruiz & Baer, 1997; Sundberg & Michael, 2001).",
        "sourceHint": "Emergent Mand Relations Learning to mand is a powerful behavioral cusp in early child development (Bijou & Baer, 1965 ; Greer & Ross, 2008; Rosales-Ruiz & Baer, 1997; Sundberg & Michael, 2001)."
      },
      {
        "term": "ta king d ictat ion",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "compound verbal discrim ination",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "textual",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "copying text",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "topography-based verbal behavior",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "duplic",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "mu ltiple control",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "verbal behavio r",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "echoic",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "point-to-point correspondence",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "verbal cond itional discrimination",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "elementary verbal operants",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "private events",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "verbal ep isode",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "formal similarity",
        "definition": "Formal similarity occurs when the controlling verbal stimulus and the response product are in the same sense mode (e.g., both are auditory), and the stimulus and the response product resemble each other in the physical sense of resemblance (e.g., hear \"bear,\" say \"bear\").",
        "sourceHint": "Formal similarity occurs when the controlling verbal stimulus and the response product are in the same sense mode (e.g., both are auditory), and the stimulus and the response product resemble each other in the physical sense of resemblance (e.g., hear \"bear,\" say \"bear\")."
      },
      {
        "term": "verbal function-altering effect",
        "definition": "The verbal function-altering effect occurs when verbal stimuli condition the behavior of a listener by changing the functions of other stimuli and MOs that the listener encounters immediately or later in time (e.g., instructions).",
        "sourceHint": "The verbal function-altering effect occurs when verbal stimuli condition the behavior of a listener by changing the functions of other stimuli and MOs that the listener encounters immediately or later in time (e.g., instructions)."
      },
      {
        "term": "generative learning",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "simple verbal discrimination",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Teach simple and cond itional discrimi nations.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Use Skinner's analysis to teach verbal behavior.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "screaming behavior was reduced",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "For example, a child's cry could be the form of verbal response, and why she cried would be the function .",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, a child's cry could be the form of verbal response, and why she cried would be the function ."
      },
      {
        "scenario": "For example, sign language involves cheremes rather than phonemes (Stokoe, Casterline, & Croneberg, 1965), and selection-based icon systems (e.g., iPad commupremise was that language constitutes learned behavior acquired nication devices) have no clear parallel to phonemes.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, sign language involves cheremes rather than phonemes (Stokoe, Casterline, & Croneberg, 1965), and selection-based icon systems (e.g., iPad commupremise was that language constitutes learned behavior acquired nication devices) have no clear parallel to phonemes."
      },
      {
        "scenario": "For example, if a child wants to play with an iPad and signs iPad, that response form informs the listener of the relevant motivation, allowing for the delivery of specific reinforcement (the iPad).",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, if a child wants to play with an iPad and signs iPad, that response form informs the listener of the relevant motivation, allowing for the delivery of specific reinforcement (the iPad)."
      },
      {
        "scenario": "For example, the same ''iPad,\" request exemplified above could also occur by selecting the iPad icon from a comparison array.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, the same ''iPad,\" request exemplified above could also occur by selecting the iPad icon from a comparison array."
      }
    ],
    "comparisons": [],
    "misconceptions": [
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "Verbal behavior is not restricted to spoken words.",
        "sourceHint": "Verbal behavior is not restricted to spoken words."
      },
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "The intraverbal is a verbal operant in which the form of the response is under the functional control of a verbal s0 that does not have point-to-point correspondence to the verbal response, but does have a history of generalized S'.",
        "sourceHint": "The intraverbal is a verbal operant in which the form of the response is under the functional control of a verbal s0 that does not have point-to-point correspondence to the verbal response, but does have a history of generalized S'."
      },
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "The textual relation (codic) is a verbal operant in which the form of the response is under the functional control of a written verbal SD that does not have formal similarity, but does have point-to-point correspondence and a history of generalized S'.",
        "sourceHint": "The textual relation (codic) is a verbal operant in which the form of the response is under the functional control of a written verbal SD that does not have formal similarity, but does have point-to-point correspondence and a history of generalized S'."
      }
    ],
    "examChecklist": [
      "Define \"listener\" from memory and match the source text.",
      "Define \"tact\" from memory and match the source text.",
      "Define \"mand\" from memory and match the source text.",
      "Define \"formal similarity\" from memory and match the source text.",
      "Define \"verbal function-altering effect\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"In SB verbal behavior, what is conveyed to the listener is the information on the stimulus selected, as opposed to TB verbal behavior, where the listener's behavior is controlled by the topography of a speaker's response.\"",
        "options": [
          {
            "label": "A",
            "text": "listener"
          },
          {
            "label": "B",
            "text": "tact"
          },
          {
            "label": "C",
            "text": "mand"
          },
          {
            "label": "D",
            "text": "formal similarity"
          }
        ],
        "answer": "A",
        "explanation": "\"In SB verbal behavior, what is conveyed to the listener is the information on the stimulus selected, as opposed to TB verbal behavior, where the listener's behavior is controlled by the topography of a speaker's response.\" is the chapter's own definition of listener.",
        "topic": "Key terms",
        "sourceHint": "In SB verbal behavior, what is conveyed to the listener is the information on the stimulus selected, as opposed to TB verbal behavior, where the listener's behavior is controlled by the topography of a speaker's response."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Autoclitic Tact An autoclitic tact is a type of secondary verba l behavior that is controll ed by some nonverbal feature of the primary res po nse or its controlling variables, and the a utoclitic response informs the li stener of that feature.\"",
        "options": [
          {
            "label": "A",
            "text": "listener"
          },
          {
            "label": "B",
            "text": "mand"
          },
          {
            "label": "C",
            "text": "formal similarity"
          },
          {
            "label": "D",
            "text": "tact"
          }
        ],
        "answer": "D",
        "explanation": "\"Autoclitic Tact An autoclitic tact is a type of secondary verba l behavior that is controll ed by some nonverbal feature of the primary res po nse or its controlling variables, and the a utoclitic response informs the li stener of that feature.\" is the chapter's own definition of tact.",
        "topic": "Key terms",
        "sourceHint": "Autoclitic Tact An autoclitic tact is a type of secondary verba l behavior that is controll ed by some nonverbal feature of the primary res po nse or its controlling variables, and the a utoclitic response informs the li stener of that feature."
      },
      {
        "id": "Q3",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Emergent Mand Relations Learning to mand is a powerful behavioral cusp in early child development (Bijou & Baer, 1965 ; Greer & Ross, 2008; Rosales-Ruiz & Baer, 1997; Sundberg & Michael, 2001).\"",
        "options": [
          {
            "label": "A",
            "text": "tact"
          },
          {
            "label": "B",
            "text": "formal similarity"
          },
          {
            "label": "C",
            "text": "mand"
          },
          {
            "label": "D",
            "text": "listener"
          }
        ],
        "answer": "C",
        "explanation": "\"Emergent Mand Relations Learning to mand is a powerful behavioral cusp in early child development (Bijou & Baer, 1965 ; Greer & Ross, 2008; Rosales-Ruiz & Baer, 1997; Sundberg & Michael, 2001).\" is the chapter's own definition of mand.",
        "topic": "Key terms",
        "sourceHint": "Emergent Mand Relations Learning to mand is a powerful behavioral cusp in early child development (Bijou & Baer, 1965 ; Greer & Ross, 2008; Rosales-Ruiz & Baer, 1997; Sundberg & Michael, 2001)."
      },
      {
        "id": "Q4",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Formal similarity occurs when the controlling verbal stimulus and the response product are in the same sense mode (e.g., both are auditory), and the stimulus and the response product resemble each other in the physical sense of resemblance (e.g., hear \"bear,\" say \"bear\").\"",
        "options": [
          {
            "label": "A",
            "text": "mand"
          },
          {
            "label": "B",
            "text": "formal similarity"
          },
          {
            "label": "C",
            "text": "listener"
          },
          {
            "label": "D",
            "text": "tact"
          }
        ],
        "answer": "B",
        "explanation": "\"Formal similarity occurs when the controlling verbal stimulus and the response product are in the same sense mode (e.g., both are auditory), and the stimulus and the response product resemble each other in the physical sense of resemblance (e.g., hear \"bear,\" say \"bear\").\" is the chapter's own definition of formal similarity.",
        "topic": "Key terms",
        "sourceHint": "Formal similarity occurs when the controlling verbal stimulus and the response product are in the same sense mode (e.g., both are auditory), and the stimulus and the response product resemble each other in the physical sense of resemblance (e.g., hear \"bear,\" say \"bear\")."
      },
      {
        "id": "Q5",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"The verbal function-altering effect occurs when verbal stimuli condition the behavior of a listener by changing the functions of other stimuli and MOs that the listener encounters immediately or later in time (e.g., instructions).\"",
        "options": [
          {
            "label": "A",
            "text": "verbal function-altering effect"
          },
          {
            "label": "B",
            "text": "listener"
          },
          {
            "label": "C",
            "text": "tact"
          },
          {
            "label": "D",
            "text": "mand"
          }
        ],
        "answer": "A",
        "explanation": "\"The verbal function-altering effect occurs when verbal stimuli condition the behavior of a listener by changing the functions of other stimuli and MOs that the listener encounters immediately or later in time (e.g., instructions).\" is the chapter's own definition of verbal function-altering effect.",
        "topic": "Key terms",
        "sourceHint": "The verbal function-altering effect occurs when verbal stimuli condition the behavior of a listener by changing the functions of other stimuli and MOs that the listener encounters immediately or later in time (e.g., instructions)."
      }
    ],
    "reviewPrompts": [
      "Define \"listener\" in your own words, then check against the chapter glossary.",
      "Define \"tact\" in your own words, then check against the chapter glossary.",
      "Define \"mand\" in your own words, then check against the chapter glossary.",
      "Define \"formal similarity\" in your own words, then check against the chapter glossary.",
      "Define \"verbal function-altering effect\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"Skinner argues that language constitutes learned speaker and listener behavior that is acquired, maintained, and extended by environmental contingencies of reinforcement..\"",
      "Restate this idea from the chapter in your own words: \"A given utterance is comprised of formal properties (the words spoken) and functional properties (why those words were spoken)..\""
    ],
    "recap": [
      "Verbal repertoires can also deteriorate, as observed in cases of dementia, Alzheimer's disease, aphasia, and traumatic brain injury."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true
    }
  },
  "19": {
    "meta": {
      "id": "19",
      "number": 19,
      "title": "Equivalence-Based Instruction",
      "subtitle": "Stimulus equivalence, reflexivity, symmetry, transitivity",
      "part": "Part 8 - Developing New Behavior",
      "bacb": []
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [],
    "coreConcepts": [
      {
        "title": "Research Foundations and Core Concepts",
        "body": [
          "Stimulus equivalence describes a behavior analytic approach to understanding and establishing symbolic function. Our field's interest in the equivalence phenomenon can be traced back to early work by Sidman (1971 ; Sidman & Cresson, 1973) on reading comprehension."
        ],
        "bullets": [
          "Arbitrary match-to-sample procedures are commonly used in equivalence studies to teach the necessary baseline performances and to test for emergent (or untrained) ones. Arbitrary match-to-sample training involves a discrete-trial four-term contingency arrangement with physically dissimilar stimuli. A trial begins with the presentation of a sample stimulus (e.g., A 1 or A2); an observing response to the sample produces two or more comparison stimuli (e.g., Bl and B2). Selection of the comparison designated as correct for that sample results in a reinforcer, while selection of any other comparison does not.",
          "After teaching two interrelated conditional discriminations (e.g., AB and BC), probe trials are presented to test for emergence of the untrained relations that define equivalence. There are no programmed consequences for probe trials ; thus, consistent patterns of responding on these trial types are described as emergent or derived. The critical probe types include: • reflexivity tests, that is, tests for generalized identity matching with all training stimuli, or AA, BB, and CC; in mathematical set theory, reflexivity is defined as A= A.",
          "Positive outcomes on all probe types document interchangeability among a given group of stimuli and allow the conclusion that an equivalence class has formed. That is, responses on reflexivity, symmetry, and transitivity or equivalence trials show that any member of the class can serve effectively as sample or as comparison with any other class member. The equivalence class consists of all such interchangeable stimuli (e.g., A, B, and C, in this example).",
          "The literature on stimulus equivalence is characterized by a true translational approach. Advances in our understanding and application of equivalence have resulted from a necessary and continuing interplay between basic laboratory research, applied behavior analysis, and conceptual developments."
        ]
      },
      {
        "title": "Designing Equivalence-based Instruction",
        "body": [
          "A number of procedural variables have proven important for the successful generation of equivalence classes, and for prevention of problematic stimulus-control patterns that could compete with demonstrations of class formation. These variables are considered in the context of making decisions about training and testing procedures."
        ],
        "bullets": [
          "In planning match-to-sample training procedures, critical decisions will include the number and type of stimuli to be used, the mode of stimulus presentation, inclusion and type of observing response, content of the instructions to be presented, the approach to balanced trial presentations, the necessity of special training steps, the type of training structure to be used, the mastery criteria for training steps, and the arrangement of consequences for training trials.",
          "In planning the testing protocol, critical decisions will include the composition of the probe-trial blocks, the arrangement of consequences within the probe-trial blocks, the order of probe-type presentation, and the criteria to be used for judging class formation."
        ]
      },
      {
        "title": "Applications and Generality",
        "body": [
          "The generality of the equivalence outcome has been repeatedly confirmed and extended by creative applications of EBI across populations, settings, and instructional targets."
        ],
        "bullets": [
          "Work with children and adults with intellectual disabilities, as well as young typically developing children, represents the largest category of EBI applications. Targets have included language- and number-skills instruction , as well as other types of functional skills (e.g., music, academic content, Braille reading).",
          "Important work with adult clinical populations includes examples with health-related behaviors and skills impacted by brain injury; investigations in the field of gerontology are also being explored.",
          "Equivalence-based instruction targeting university course content has had promising results across a range of subject matters and modes of presentation."
        ]
      },
      {
        "title": "Applications Stemming from Alternative Theoretical",
        "body": [
          "equivalence-class member, thus increasing the size of the Approaches to Relational Responding class created by a given amount of training."
        ],
        "bullets": [
          "Naming theory and relational frame theory (RFT) provide differing accounts of the basis for novel relational responding. Both emphasize that novel responding is due to a special learning history, rather than a direct outcome of a reinforcement contingency (as in Sidman's view). Naming Theory and RFT differ, however, with respect to the nature of the learning hi story that is required. These differences give rise to unique applications for generating emergent or derived responding.",
          "For naming theory, naming is a technical term for a tion training is mastered more easily than conditional bidirectional higher-order unit of speaker and listener discrimination training by some learners, and can probehavior that is seen as responsible for any form of clasduce equivalence-class formation. sifying , including equivalence performances. Following from this view, applications designed to promote equivalence include instruction in the components of namingli stener behavior and tacting. For participants lacking these skills, targeting them directly can be effective in producing response patterns indicative of classes and categories.",
          "For RFT, framing, or responding to one stimulus in terms of another, is the key higher-order operant. It is establi shed by teaching many different examples of a given relation, which allows for abstraction and then application of the relation to new examples, given the proper context. RFT emphasizes that equivalence is just one example of the many relations we learn in this manner. Following from this view, applications designed to promote novel, or derived, relational responding feature multiple-exemplar training as the key instructional approach. A range of examples has provided evidence for the production of generalized response patterns that can contribute to complex symbolic skills."
        ]
      }
    ],
    "glossary": [
      {
        "term": "class expansion",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "eq uivalence t est",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "st im ulus-control topographies",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "class merger",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "exclusion",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "st imulus equ iva lence",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "class-specific reinforcement",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "higher-order operant class",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "symmet ry",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "cond it io nal discrim inatio n",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "matching-to-sample procedure",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "tra ining structure",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "contextu al control",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "transf er of function",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "derived stimulus re lations",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "reflexivit y",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "transitivit y",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "emergent stimulus relations",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "simple discri mination",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "equivalence-class formatio n",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "simple-to-complex test ing protoco l",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Teach simple and conditional discriminations.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Use equivalence-based instruction.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "For example, with stimulus B2 as sample, and stimuli Bl , B2, and B3 as comparisons, selecting stimulus B2 would be indicative of reflexivity.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, with stimulus B2 as sample, and stimuli Bl , B2, and B3 as comparisons, selecting stimulus B2 would be indicative of reflexivity."
      },
      {
        "scenario": "For example, the events that might be A chapter on designing and implementing EBI will necessarily focus on productive uses of this teaching approach.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, the events that might be A chapter on designing and implementing EBI will necessarily focus on productive uses of this teaching approach."
      },
      {
        "scenario": "For example, Fienup and Critchfield (2010; see also Fienup, Critchfield, & Covey, 2009) taught concepts of inferential statistics and hypothesis testing to college students using a computerized equivalence after training.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, Fienup and Critchfield (2010; see also Fienup, Critchfield, & Covey, 2009) taught concepts of inferential statistics and hypothesis testing to college students using a computerized equivalence after training."
      },
      {
        "scenario": "Applied research with stimulus sets such as these typically incorporate control procedures to rule out extra-experimental learning with the stimuli as responsible for probe performances.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Applied research with stimulus sets such as these typically incorporate control procedures to rule out extra-experimental learning with the stimuli as responsible for probe performances."
      }
    ],
    "comparisons": [
      {
        "title": "Distinction drawn in the source",
        "left": {
          "label": "First framing",
          "points": [
            "Naming theory and relational frame theory (RFT) provide differing accounts of the basis for novel relational responding. Both emphasize that novel responding is due to a special learning history."
          ]
        },
        "right": {
          "label": "Contrast",
          "points": [
            "a direct outcome of a reinforcement contingency (as in Sidman's view). Naming Theory and RFT differ, however, with respect to the nature of the learning hi story that is required. These differences give rise to unique applications for generating emergent or derived responding."
          ]
        },
        "sourceHint": "Naming theory and relational frame theory (RFT) provide differing accounts of the basis for novel relational responding. Both emphasize that novel responding is due to a special learning history, rather than a direct outcome of a reinforcement contingency (as in Sidman's view). Naming Theory and RFT differ, however, with respect to the nature of the learning hi story that is required. These differences give rise to unique applications for generating emergent or derived responding."
      }
    ],
    "misconceptions": [
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "Selection of the comparison designated as correct for that sample results in a reinforcer, while selection of any other comparison does not.",
        "sourceHint": "Selection of the comparison designated as correct for that sample results in a reinforcer, while selection of any other comparison does not."
      }
    ],
    "examChecklist": [],
    "quiz": [],
    "reviewPrompts": [
      "Restate this idea from the chapter in your own words: \"Stimulus equivalence describes a behavior analytic approach to understanding and establishing symbolic function.\"",
      "Restate this idea from the chapter in your own words: \"Arbitrary match-to-sample procedures are commonly used in equivalence studies to teach the necessary baseline performances and to test for emergent (or untrained) ones.\"",
      "What is the single most important takeaway from \"Equivalence-Based Instruction\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "For RFT, framing, or responding to one stimulus in terms of another, is the key higher-order operant."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "quiz": true
    }
  },
  "20": {
    "meta": {
      "id": "20",
      "number": 20,
      "title": "Engineering Emergent Learning with Nonequivalence Relations",
      "subtitle": "Relational frames, derived relational responding",
      "part": "Part 8 - Developing New Behavior",
      "bacb": []
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [],
    "coreConcepts": [
      {
        "title": "Why Do They Matter?",
        "body": [
          "Stimulus relations are arbitrary associations between stimuli, with \"association\" meaning that how one stimulus is responded to is intertwined in some way with how other stimuli are responded to."
        ],
        "bullets": [
          "Stimulus equivalence is only one of a wide variety of stimulus relations. Not all stimuli are related via \"same as,\" and nonequivalence relations are integral to many everyday experiences."
        ]
      },
      {
        "title": "The Vocabulary of Nonequivalence Relations",
        "body": [
          "Key ways of talking about stimulus equivalence do not work for nonequivalence relations, so a substitute vocabulary is needed."
        ],
        "bullets": [
          "What's called symmetry in the stimulus equivalence Literature is subsumed under the term mutual entailment, which means the converse of any A-to-B relation. For example, if the original relation is \"A is greater than B,\" the converse will be \"B is less than A.\"",
          "What's called transitivity in the stimulus equivalence Literature is subsumed under the term combinatorial entailment, which means any derived relation in which the function of stimuli depends on the other stimuli to which they are indirectly related.",
          "What's called transfer offunction in the stimulus equivalence literature is subsumed under the term transformation offunction . This means that the stimuli in a relational class do not all acquire the same behavioral functions ; however, the functions acquired by any stimulus depend on the functions acquired by others in the class.",
          "Stimuli can also be related in terms of spatial or temporal juxtaposition and in terms of cause-effect relations."
        ]
      },
      {
        "title": "Theoretical Foundations",
        "body": [
          "Most research on nonequivalence relations has been guided by relational frame theory, which assumes (a) that verbal processes are bound up in derived stimulus relations, and (b) that given enough reinforced experience with multiple exemplars, people develop a higher-order ability to derive relations among sets of stimuli, even in the absence of further reinforced experience."
        ],
        "bullets": [
          "The role of verbal behavior in derived stimulus relations is not fully understood, but assuming a close connection has led to interesting research. For example, as the theory would predict, providing reinforced multiple-exemplar experience has been shown to create generalizable relational abilities. This may be an example of what relational frame theory calls arbitrarily applicable relational responding , a generalized repertoire that allows new classes to form without new reinforced experience.",
          "It has also been found that, for some learners, the baseline relations of stimulus classes can be built simply by telling learners about them. Among other things, this finding could imply that verbal experience is functionally similar to the largely nonverbal match-to-sample experience provided in many stimulus equivalence protocols."
        ]
      },
      {
        "title": "Some Types of Nonequivalence Relations",
        "body": [
          "The notion that there are many ways of relating the same stimuli implies the existence of contextual stimuli that signal which way of relating is appropriate to a given situation. Explicit contextual stimuli are recommended as part of applied interventions focusing on derived stimulus relations."
        ],
        "bullets": []
      },
      {
        "title": "Nonequivalence Relations and Big-Picture Psychological Constructs",
        "body": [
          "alence relation called hierarchical relations produces several effects seen in cognitive psychology studies of categorization."
        ],
        "bullets": [
          "Self-concept: A type of nonequivalence relation called deictic relations may underlie important self-related and social repertoires, a primary example of which is perspective shifting, in which an individual experiences the world as another person would.",
          "Intellectual development: Normatively speaking, various types of derived stimulus relations tend to emerge gradually during child development. 526 Part 8 • Developing New Behavior Importantly, systematically training stimulus relations has been found to boost scores on standardized intelligence tests ."
        ]
      },
      {
        "title": "Derived Stimulus Relations and General Well-Being",
        "body": [
          "Acceptance and commitment therapy is a behavior therapy based partly on relational frame theory and research on derived stimulus relations (including nonequivalence relations). It focuses on promoting general well-being. In many cases, the therapy does not target public behaviors relevant to the referring problem. Instead, to undermine the control of behavior by problematic private events, the therapy employs verbally guided exercises that are very different from most ABA interventions."
        ],
        "bullets": [
          "The therapy has been shown to lessen symptoms of certain clinical disorders and to enhance performance in nonclinical situations. Another important application has been to reduce stress and alleviate depression in parents and caregivers of persons with disabilities. In some documented cases, improving caregiver well-being has been followed by improvements in client behavior."
        ]
      }
    ],
    "glossary": [
      {
        "term": "acceptance and commitment therapy",
        "definition": "Acceptance and commitment therapy is a behavior therapy based partly on relational frame theory and research on derived stimulus relations (including nonequivalence relations).",
        "sourceHint": "Acceptance and commitment therapy is a behavior therapy based partly on relational frame theory and research on derived stimulus relations (including nonequivalence relations)."
      },
      {
        "term": "deictic relations",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "perspective shifting",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "arbitrarily applicable relationa l",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "derived relations",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "relational frame theory",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "responding",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "distinction relations",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "relational frame",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "arbitrary relations",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "hierarchical relations",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "rule-governed behavior",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "behavioral inflexibility",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "multiple-exemplar trai ning",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "spatial relations",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "causal relations",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "mutual entailment",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "transformation of function",
        "definition": "This new transformation of function means that untempered joy.",
        "sourceHint": "This new transformation of function means that untempered joy."
      },
      {
        "term": "contextual stimulus",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "nonequivalence relations",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "temporal relations",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "combinatorial entailment",
        "definition": "To be more precise, combinatorial entailment is the relation involving two stimuli that both participate in mutual entailment with some common third stimulus.",
        "sourceHint": "To be more precise, combinatorial entailment is the relation involving two stimuli that both participate in mutual entailment with some common third stimulus."
      },
      {
        "term": "Define and provide examples of stimulus control.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Teach simple and conditional discriminations.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Use equivalence-based instruction.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "be symbolically and behaviorally linked. Nonequivalence",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "A baseball staof silver-colored metal, or to have its value represented with \" 10¢.\" Humans have arbitrarily created these symbols and the relations among them (such as the equivalence class in Figure 19.7).",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "A baseball staof silver-colored metal, or to have its value represented with \" 10¢.\" Humans have arbitrarily created these symbols and the relations among them (such as the equivalence class in Figure 19.7)."
      },
      {
        "scenario": "Symmetry implies mutual \"sameness.\" For example, in the top left panel of Figure 20.3, a learner who is shown overdue and taught to identify tardy as \"the same\" should also be able to identify overdue as \"the same\" when given tardy.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Symmetry implies mutual \"sameness.\" For example, in the top left panel of Figure 20.3, a learner who is shown overdue and taught to identify tardy as \"the same\" should also be able to identify overdue as \"the same\" when given tardy."
      },
      {
        "scenario": "For example, when shown a picture of the frontal lobe, the student's job was to select an answer (impul- addressed here.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, when shown a picture of the frontal lobe, the student's job was to select an answer (impul- addressed here."
      },
      {
        "scenario": "For example, imagine that posted right next to the Sidman sites (discussed further in the next section).",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, imagine that posted right next to the Sidman sites (discussed further in the next section)."
      }
    ],
    "comparisons": [],
    "misconceptions": [
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "The role of verbal behavior in derived stimulus relations is not fully understood, but assuming a close connection has led to interesting research.",
        "sourceHint": "The role of verbal behavior in derived stimulus relations is not fully understood, but assuming a close connection has led to interesting research."
      },
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "In many cases, the therapy does not target public behaviors relevant to the referring problem.",
        "sourceHint": "In many cases, the therapy does not target public behaviors relevant to the referring problem."
      }
    ],
    "examChecklist": [
      "Define \"acceptance and commitment therapy\" from memory and match the source text.",
      "Define \"transformation of function\" from memory and match the source text.",
      "Define \"combinatorial entailment\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Acceptance and commitment therapy is a behavior therapy based partly on relational frame theory and research on derived stimulus relations (including nonequivalence relations).\"",
        "options": [
          {
            "label": "A",
            "text": "acceptance and commitment therapy"
          },
          {
            "label": "B",
            "text": "transformation of function"
          },
          {
            "label": "C",
            "text": "combinatorial entailment"
          },
          {
            "label": "D",
            "text": "deictic relations"
          }
        ],
        "answer": "A",
        "explanation": "\"Acceptance and commitment therapy is a behavior therapy based partly on relational frame theory and research on derived stimulus relations (including nonequivalence relations).\" is the chapter's own definition of acceptance and commitment therapy.",
        "topic": "Key terms",
        "sourceHint": "Acceptance and commitment therapy is a behavior therapy based partly on relational frame theory and research on derived stimulus relations (including nonequivalence relations)."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"This new transformation of function means that untempered joy.\"",
        "options": [
          {
            "label": "A",
            "text": "acceptance and commitment therapy"
          },
          {
            "label": "B",
            "text": "combinatorial entailment"
          },
          {
            "label": "C",
            "text": "deictic relations"
          },
          {
            "label": "D",
            "text": "transformation of function"
          }
        ],
        "answer": "D",
        "explanation": "\"This new transformation of function means that untempered joy.\" is the chapter's own definition of transformation of function.",
        "topic": "Key terms",
        "sourceHint": "This new transformation of function means that untempered joy."
      },
      {
        "id": "Q3",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"To be more precise, combinatorial entailment is the relation involving two stimuli that both participate in mutual entailment with some common third stimulus.\"",
        "options": [
          {
            "label": "A",
            "text": "transformation of function"
          },
          {
            "label": "B",
            "text": "deictic relations"
          },
          {
            "label": "C",
            "text": "combinatorial entailment"
          },
          {
            "label": "D",
            "text": "acceptance and commitment therapy"
          }
        ],
        "answer": "C",
        "explanation": "\"To be more precise, combinatorial entailment is the relation involving two stimuli that both participate in mutual entailment with some common third stimulus.\" is the chapter's own definition of combinatorial entailment.",
        "topic": "Key terms",
        "sourceHint": "To be more precise, combinatorial entailment is the relation involving two stimuli that both participate in mutual entailment with some common third stimulus."
      }
    ],
    "reviewPrompts": [
      "Define \"acceptance and commitment therapy\" in your own words, then check against the chapter glossary.",
      "Define \"transformation of function\" in your own words, then check against the chapter glossary.",
      "Define \"combinatorial entailment\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"Stimulus relations are arbitrary associations between stimuli, with \"association\" meaning that how one stimulus is responded to is intertwined in some way with how other stimuli are responded to..\"",
      "Restate this idea from the chapter in your own words: \"Stimulus equivalence is only one of a wide variety of stimulus relations.\"",
      "What is the single most important takeaway from \"Engineering Emergent Learning with Nonequivalence Relations\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "The therapy has been shown to lessen symptoms of certain clinical disorders and to enhance performance in nonclinical situations."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true
    }
  },
  "21": {
    "meta": {
      "id": "21",
      "number": 21,
      "title": "Imitation, Modeling, and Observational Learning",
      "subtitle": "Generalized imitation, video modeling",
      "part": "Part 8 - Developing New Behavior",
      "bacb": []
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [],
    "coreConcepts": [
      {
        "title": "Imitation",
        "body": [
          "A model is a live or symbolic demonstration of the target behavior that shows the learner exactly what to do."
        ],
        "bullets": [
          "Formal simi larity occurs when the imitator's behavior physically resembles the model and is in the same mode.",
          "Imitation training is a systematic, research-based set of steps for teaching a non-imitative learner to imitate models of novel behaviors. is occasioned by another person's model of the behavior",
          "Generalized imitation refers to a learner imitating a wide variety of unprompted, untrained, non-reinforced modeled behaviors in different settings and situations. in time, and (d) the model is the primary controlling",
          "A brief latency between the model and the learner's behavior is an important feature of imitation."
        ]
      },
      {
        "title": "Modeling",
        "body": [
          "Modeling is a behavior change strategy in which learners acquire new skills by imitating demonstrations of the skills by live or symbolic models."
        ],
        "bullets": [
          "Video modeling is a technique that involves the demonstration of desired behaviors through visual representations of the behavior.",
          "In video self-modeling, the learners observe a video of themselves successfully performing the target behavior and imitates their self-model."
        ]
      },
      {
        "title": "Observational Learning",
        "body": [
          "Observational learning entails another person's behavior and its consequence(s) and using that information to determined whether or not to imitate the behavior. Observational learning typically involves imitation but does not require it."
        ],
        "bullets": [
          "Three requisite skills are central to developing an observational learning repertoire: attending, imitating, and discriminating. If any of the skills are lacking, they can be taught separately and then combined."
        ]
      }
    ],
    "glossary": [
      {
        "term": "genera lized im itation",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "modeling",
        "definition": "Modeling is a behavior change strategy in which learners acquire new skills by imitating demonstrations of the skills by live or symbolic models.",
        "sourceHint": "Modeling is a behavior change strategy in which learners acquire new skills by imitating demonstrations of the skills by live or symbolic models."
      },
      {
        "term": "video modeling",
        "definition": "Video modeling is a technique that involves the demonstration of desired behaviors through visual representations of the behavior.",
        "sourceHint": "Video modeling is a technique that involves the demonstration of desired behaviors through visual representations of the behavior."
      },
      {
        "term": "im it at ion",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "observat ional learn ing",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "video self-model ing",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "imit at ion t raining",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Use modeling and imitation train ing.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "singer-songwriter performing in a contemporary rock",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "playing similar riffs.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "immediately reproduces it note-for-note.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Backstage between sets, the singer-songwriter says to",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "observational learners.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "tarist overhears the singer-songwriter's comment. During",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "mitation, modeling, and observational learning are respon-",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "received considerable experimental and theoretical attention",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "LeBlanc and colleagues (2003), for example, used video models to teach perspective-taking skills to three children with autism.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "LeBlanc and colleagues (2003), for example, used video models to teach perspective-taking skills to three children with autism."
      },
      {
        "scenario": "The children learned to imitate a video model touching or pointing to objects, such as a bowl or a box.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "The children learned to imitate a video model touching or pointing to objects, such as a bowl or a box."
      },
      {
        "scenario": "Also, the children imitated vocal-verbal behaviors, such as saying \"under the bowl, or saying \"one.\" Unplanned models, for better or worse, occasion imitation in everyday social environments (e.g., school, work, play, community).",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Also, the children imitated vocal-verbal behaviors, such as saying \"under the bowl, or saying \"one.\" Unplanned models, for better or worse, occasion imitation in everyday social environments (e.g., school, work, play, community)."
      },
      {
        "scenario": "This is not an imitative behavior; it is an example of a discriminated operant with a history of reinforcement.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "This is not an imitative behavior; it is an example of a discriminated operant with a history of reinforcement."
      }
    ],
    "comparisons": [],
    "misconceptions": [],
    "examChecklist": [
      "Define \"modeling\" from memory and match the source text.",
      "Define \"video modeling\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Modeling is a behavior change strategy in which learners acquire new skills by imitating demonstrations of the skills by live or symbolic models.\"",
        "options": [
          {
            "label": "A",
            "text": "modeling"
          },
          {
            "label": "B",
            "text": "video modeling"
          },
          {
            "label": "C",
            "text": "genera lized im itation"
          },
          {
            "label": "D",
            "text": "im it at ion"
          }
        ],
        "answer": "A",
        "explanation": "\"Modeling is a behavior change strategy in which learners acquire new skills by imitating demonstrations of the skills by live or symbolic models.\" is the chapter's own definition of modeling.",
        "topic": "Key terms",
        "sourceHint": "Modeling is a behavior change strategy in which learners acquire new skills by imitating demonstrations of the skills by live or symbolic models."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Video modeling is a technique that involves the demonstration of desired behaviors through visual representations of the behavior.\"",
        "options": [
          {
            "label": "A",
            "text": "modeling"
          },
          {
            "label": "B",
            "text": "genera lized im itation"
          },
          {
            "label": "C",
            "text": "im it at ion"
          },
          {
            "label": "D",
            "text": "video modeling"
          }
        ],
        "answer": "D",
        "explanation": "\"Video modeling is a technique that involves the demonstration of desired behaviors through visual representations of the behavior.\" is the chapter's own definition of video modeling.",
        "topic": "Key terms",
        "sourceHint": "Video modeling is a technique that involves the demonstration of desired behaviors through visual representations of the behavior."
      }
    ],
    "reviewPrompts": [
      "Define \"modeling\" in your own words, then check against the chapter glossary.",
      "Define \"video modeling\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"A model is a live or symbolic demonstration of the target behavior that shows the learner exactly what to do..\"",
      "What is the single most important takeaway from \"Imitation, Modeling, and Observational Learning\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "Three requisite skills are central to developing an observational learning repertoire: attending, imitating, and discriminating."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true,
      "misconceptions": true
    }
  },
  "22": {
    "meta": {
      "id": "22",
      "number": 22,
      "title": "Shaping",
      "subtitle": "Successive approximations, differential reinforcement",
      "part": "Part 8 - Developing New Behavior",
      "bacb": [
        "G-7"
      ]
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [
      {
        "id": "G-7",
        "text": "Use shaping."
      }
    ],
    "coreConcepts": [
      {
        "title": "Shaping Defined",
        "body": [
          "A terminal behavior- the end product of shaping--<:an be claimed when the topography, rate, latency, duration, interresponse time, or magnitude of the target behavior reaches a predetermined criterion level."
        ],
        "bullets": [
          "Differential reinforcement refers to the act of presenting an unconditioned or conditioned reinforcer only to those emitted members of a response class that share a specified dimension or quality, while placing all other emitted response class members on extinction.",
          "Differential reinforcement has three effects: Responses simi lar to those that have been reinforced are more likely to occur, responses resembling the unre inforced members are emitted less frequently (i.e., undergo extinction), and some of these emitted responses under extinction may be likely to resemble the next successive approximation to the terminal behavior and would therefore be targeted for reinforcement.",
          "When differential reinforcement is applied consistently within a response class, its triple effect results in a new response class composed primarily of responses sharing the characteristics of the previously reinforced subclass. 14. Clicker training is a science-based system for progressively This emergence of a new response class is called response differentiation.",
          "The gradually changing criterion for reinforcement during shaping results in a succession of new response classes, or successive approximations, each one closer in form to the terminal behavior than the response class it replaces."
        ]
      },
      {
        "title": "Shaping Across and Within Response Topographies",
        "body": [
          "Shaping behavior across different response topographies means that selected members of a response class are differentially re inforced, whereas members of other response classes are placed on extinction."
        ],
        "bullets": [
          "Shaping a behavior within a response topography means that the form of the behavior remains constant, but differential reinforcement is applied to another measurable dimension of the behavior (e.g., magnitude).",
          "Shaping is a positive approach to teach new behavior and may be combined with other behavior change tactics.",
          "In shaping, the antecedent stimulus stays the same, while the response progressively becomes more differentiated. In stimulus fading, the response remains the same, while the antecedent stimulus changes gradually."
        ]
      },
      {
        "title": "Clicker Training",
        "body": [
          "The clicker, a handheld device that produces a cl icking sound when a metal tab is pressed, provides the signal that when a behavior is being performed in the presence of the click, reinforcement follows."
        ],
        "bullets": []
      },
      {
        "title": "Emerging Applications of Shaping",
        "body": [
          "Using computers to teach shaping, combining shaping procedures with robotics engineering, and applying telemedicine technology for humanitarian purposes for populations in hard-to-access settings serve as three emerging applications of shaping. 556 Part 8 • Developing New Behavior"
        ],
        "bullets": []
      },
      {
        "title": "Shaping Guidelines",
        "body": [
          "Before deciding to use shaping, assess the nature of the behaviors to be learned, the staff requirements and resources available, and whether a different tactic altogether might be more efficient in terms of time and effort."
        ],
        "bullets": [
          "After the decision has been made to use a shaping procedure, the practitioner performs the following steps: select the terminal behavior, decide the criterion for success, analyze the response class, identify the first behavior to reinforce, eliminate interfering or extraneous stimuli, proceed gradually, limit the number of approximations at each level, continue reinforcement when the terminal behavior is achieved, and learn to shape behavior."
        ]
      },
      {
        "title": "Learning to Shape",
        "body": [
          "To learn to shape behavior, consider shaping a simple behavior, working with a colleague, practicing with a group, or using a computer-based simulator."
        ],
        "bullets": []
      }
    ],
    "glossary": [
      {
        "term": "clicker train ing",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "ext inction-induced variabi lit y",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "shap ing",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "d iffe rent ial re inforcement",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "respon se differentiation",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "successive approximations",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Use shaping.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "hand-shaping successive approximations to the final task,",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "schedules of reinforcement in normal preschool children,",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "\"goodies.\"",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "Wolf, Risley, and Mees ( 1964), for example, employed shaping in an applied setting to approximation.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Wolf, Risley, and Mees ( 1964), for example, employed shaping in an applied setting to approximation."
      },
      {
        "scenario": "For example, assume that a respiratory therapist (RT) is charged with increasing the lung capacity of a patient recovering from pneumonia.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, assume that a respiratory therapist (RT) is charged with increasing the lung capacity of a patient recovering from pneumonia."
      },
      {
        "scenario": "Edgerton and Wine (2017), for example, used a digital tablet and app (Voice Meter Pro™) to measure the magnitude of a boy's utterances that frequently fell below conversational volume.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Edgerton and Wine (2017), for example, used a digital tablet and app (Voice Meter Pro™) to measure the magnitude of a boy's utterances that frequently fell below conversational volume."
      },
      {
        "scenario": "During the early stages of the program, the psychologist waited for the next approximation of the behavior to appear before practitioners-for example, teachers in busy or demanddelivering the reinforcer.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "During the early stages of the program, the psychologist waited for the next approximation of the behavior to appear before practitioners-for example, teachers in busy or demanddelivering the reinforcer."
      }
    ],
    "comparisons": [],
    "misconceptions": [],
    "examChecklist": [
      "Address objective G-7: Use shaping."
    ],
    "quiz": [],
    "reviewPrompts": [
      "Restate this idea from the chapter in your own words: \"A terminal behavior- the end product of shaping--<:an be claimed when the topography, rate, latency, duration, interresponse time, or magnitude of the target behavior reaches a predetermined criterion level..\"",
      "What is the single most important takeaway from \"Shaping\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "To learn to shape behavior, consider shaping a simple behavior, working with a colleague, practicing with a group, or using a computer-based simulator.."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true,
      "misconceptions": true,
      "quiz": true
    }
  },
  "23": {
    "meta": {
      "id": "23",
      "number": 23,
      "title": "Chaining",
      "subtitle": "Task analysis, forward/backward/total task chaining",
      "part": "Part 8 - Developing New Behavior",
      "bacb": []
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [],
    "coreConcepts": [
      {
        "title": "Behavior Chain Defined",
        "body": [
          "A behavior chain is a linked sequence of responses leading to a terminal outcome. Each response, and its associated stimulus condition, produces a change that functions as conditioned reinforcement for that previous response and as a discriminative stimulus for the next response in the chain. Reinforcement for the last response in a chain maintains the reinforcing effectiveness of the stimulus changes produced by all previous responses in the chain."
        ],
        "bullets": [
          "Each stimulus that links two sequential responses in a chain serves dual functions: It is a conditioned reinforcer for the response that produced it and an s0 for the next response in the chain.",
          "In a behavior chain with a limited hold, a sequence of behaviors must be performed correctly and within a specific time for reinforcement to be delivered. Proficient responding is a distinguishing feature of chains with limited holds.",
          "If a learner takes too much time to complete one or more component responses, the behavior analysis can implement contingencies focusing on the proficiency of performance. Setting a time criterion for the onset and completion of each response within the chain is one way to do this; another is to set a time criterion for completion of the total chain."
        ]
      },
      {
        "title": "Rationale for Chaining",
        "body": [
          "Whereas a behavior chain denotes a particular sequence of stimuli and responses ending in reinforcement, chaining refers to various methods for linking specific sequences of stimuli and responses to form new performances."
        ],
        "bullets": [
          "Chaining refers to the way these specific sequences of stimuli and responses are linked to form new performances. In forward chaining, behaviors are linked beginning with the first behavior in the sequence. In backward chaining, the behaviors are linked beginning with the last behavior in the sequence. Forward and backward chaining have variations available.",
          "A behavior analyst should be skilled in building behavior chains for three reasons: (a) Chains can be used to improve independent-living skills; (b) chains can provide the means by which other behaviors can be combined into more complex sequences; and (c) chains can be combined with other procedures to build behavioral repertoires in generalized settings."
        ]
      },
      {
        "title": "Establishing Behavior Chains with Task Analysis",
        "body": [
          "Task analysis involves breaking a complex skill into smaller, teachable units, the product of which is a series of sequentially ordered steps or tasks."
        ],
        "bullets": [
          "The purpose of constructing and validating a task analysis is to determine the sequence of stepwise critical behaviors that constitute the complete task and that would lead to it being individualized for the learner and performed efficiently. Task analyses can be constructed by observing a competent performer, by executing the task yourself, by asking an expert, and by trial and error.",
          "The purpose of assessing mastery level is to determine which components of the task analysis can already be performed independently. Assessment can be conducted with the single-opportunity or multiple-opportunity method."
        ]
      },
      {
        "title": "Behavior Chaining Methods",
        "body": [
          "In forward chaining, the behaviors identified in the task analysis are taught in their natural sequence. Specifically, reinforcement is delivered when the predetermined criterion for the first behavior in the sequence is achieved. Thereafter, reinforcement is delivered for criterion completion of Steps I and 2. With each successive step, reinforcement is delivered contingent on the correct performance of all steps trained thus far."
        ],
        "bullets": [
          "Total-task chaining is a variation of forward chaining in which the learner receives training on each step in the task analysis during every session. Trainer assistance is provided using response prompts with any step the individual is not able to perform. The chain is trained until the learner performs all the behaviors in the sequence to criterion.",
          "In backward chaining, all the steps identified in the task analysis are completed by the trainer, except the last one. When the final step in the sequence is performed to criterion, reinforcement is delivered. Next, reinforcement is delivered when the next-to-last step and the last step are performed. Subsequently, the individual must perform the last three steps before reinforcement is delivered, and so on. The primary advantage of backward chaining is that the learner contacts the chain's terminal reinforcer on every instructional trial.",
          "Backward chaining with leap aheads follows essentially the same procedures as in backward chaining, except that not every step in the task analysis is trained. The leapaheads modification provides for probing or assessing untrained behaviors in the sequence. Its purpose is to speed up training of the behavior chain."
        ]
      },
      {
        "title": "Choosing a Chaining Method",
        "body": [
          "The decision to use forward chaining, total-task chaining, backward chaining, or backward chaining with leap aheads should be based on the results of a task analysis assessment; empirically sound data-based studies; and a functional evaluation, taking into consideration the cognitive, physical, motoric, and attention abilities of the individual."
        ],
        "bullets": []
      },
      {
        "title": "Disrupting and Breaking Behavior Chains",
        "body": [
          "Behavior chains can be interrupted or broken in at least six ways. These include extinction, satiation, unchaining, interrupting the chain, substituting an s0 , or extending the chain and building in time delays ."
        ],
        "bullets": []
      }
    ],
    "glossary": [
      {
        "term": "backward chaining",
        "definition": "575) A primary advantage of backward chaining is that the learner contacts the chain's terminal reinforcer on every instructional trial.",
        "sourceHint": "575) A primary advantage of backward chaining is that the learner contacts the chain's terminal reinforcer on every instructional trial."
      },
      {
        "term": "behavior chain with a limited hold",
        "definition": "Behavior Chains with a Limited Hold A behavior chain with a limited hold is a chain that must ment.",
        "sourceHint": "Behavior Chains with a Limited Hold A behavior chain with a limited hold is a chain that must ment."
      },
      {
        "term": "task analysis",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "backward chaining with leap aheads",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "chaining",
        "definition": "575) A primary advantage of backward chaining is that the learner contacts the chain's terminal reinforcer on every instructional trial.",
        "sourceHint": "575) A primary advantage of backward chaining is that the learner contacts the chain's terminal reinforcer on every instructional trial."
      },
      {
        "term": "total-task ch aining",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "behavior chain",
        "definition": "A behavior chain is a linked sequence of responses leading to a terminal outcome.",
        "sourceHint": "A behavior chain is a linked sequence of responses leading to a terminal outcome."
      },
      {
        "term": "forward chaining",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "unchaining",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "behavior chain interruption strategy",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "interrupted chain procedure",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Use chain ing.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "challenge, as an authentic Philadelphia cheesesteak sand-",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "wich hung in the balance.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "another victory.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "-Tim Heron",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "mastered the snugging task, the second behavi",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "For example, assume that a person with a developmental disability consistently seeks assistance from a coworker or job coach while completing an assembly task.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, assume that a person with a developmental disability consistently seeks assistance from a coworker or job coach while completing an assembly task."
      },
      {
        "scenario": "Figure 23.6 is an example of a form used to record a learner's ability to insert a hearing aid.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Figure 23.6 is an example of a form used to record a learner's ability to insert a hearing aid."
      },
      {
        "scenario": "Each step performed correctly is scored as a correct response, even if the learner erred on the For example, when the first step, \"Pinch lace,\" is perprevious steps.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Each step performed correctly is scored as a correct response, even if the learner erred on the For example, when the first step, \"Pinch lace,\" is perprevious steps."
      },
      {
        "scenario": "formed accurately 3 consecutive times , reinforcement is Figure 23.7 shows an example of the multiple-opportunity delivered (refer to Figure 23.4).",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "formed accurately 3 consecutive times , reinforcement is Figure 23.7 shows an example of the multiple-opportunity delivered (refer to Figure 23.4)."
      }
    ],
    "comparisons": [],
    "misconceptions": [
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "Trainer assistance is provided using response prompts with any step the individual is not able to perform.",
        "sourceHint": "Trainer assistance is provided using response prompts with any step the individual is not able to perform."
      }
    ],
    "examChecklist": [
      "Define \"backward chaining\" from memory and match the source text.",
      "Define \"behavior chain with a limited hold\" from memory and match the source text.",
      "Define \"chaining\" from memory and match the source text.",
      "Define \"behavior chain\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"575) A primary advantage of backward chaining is that the learner contacts the chain's terminal reinforcer on every instructional trial.\"",
        "options": [
          {
            "label": "A",
            "text": "backward chaining"
          },
          {
            "label": "B",
            "text": "behavior chain with a limited hold"
          },
          {
            "label": "C",
            "text": "chaining"
          },
          {
            "label": "D",
            "text": "behavior chain"
          }
        ],
        "answer": "A",
        "explanation": "\"575) A primary advantage of backward chaining is that the learner contacts the chain's terminal reinforcer on every instructional trial.\" is the chapter's own definition of backward chaining.",
        "topic": "Key terms",
        "sourceHint": "575) A primary advantage of backward chaining is that the learner contacts the chain's terminal reinforcer on every instructional trial."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Behavior Chains with a Limited Hold A behavior chain with a limited hold is a chain that must ment.\"",
        "options": [
          {
            "label": "A",
            "text": "backward chaining"
          },
          {
            "label": "B",
            "text": "chaining"
          },
          {
            "label": "C",
            "text": "behavior chain"
          },
          {
            "label": "D",
            "text": "behavior chain with a limited hold"
          }
        ],
        "answer": "D",
        "explanation": "\"Behavior Chains with a Limited Hold A behavior chain with a limited hold is a chain that must ment.\" is the chapter's own definition of behavior chain with a limited hold.",
        "topic": "Key terms",
        "sourceHint": "Behavior Chains with a Limited Hold A behavior chain with a limited hold is a chain that must ment."
      },
      {
        "id": "Q3",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"575) A primary advantage of backward chaining is that the learner contacts the chain's terminal reinforcer on every instructional trial.\"",
        "options": [
          {
            "label": "A",
            "text": "behavior chain with a limited hold"
          },
          {
            "label": "B",
            "text": "behavior chain"
          },
          {
            "label": "C",
            "text": "chaining"
          },
          {
            "label": "D",
            "text": "backward chaining"
          }
        ],
        "answer": "C",
        "explanation": "\"575) A primary advantage of backward chaining is that the learner contacts the chain's terminal reinforcer on every instructional trial.\" is the chapter's own definition of chaining.",
        "topic": "Key terms",
        "sourceHint": "575) A primary advantage of backward chaining is that the learner contacts the chain's terminal reinforcer on every instructional trial."
      },
      {
        "id": "Q4",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"A behavior chain is a linked sequence of responses leading to a terminal outcome.\"",
        "options": [
          {
            "label": "A",
            "text": "chaining"
          },
          {
            "label": "B",
            "text": "behavior chain"
          },
          {
            "label": "C",
            "text": "backward chaining"
          },
          {
            "label": "D",
            "text": "behavior chain with a limited hold"
          }
        ],
        "answer": "B",
        "explanation": "\"A behavior chain is a linked sequence of responses leading to a terminal outcome.\" is the chapter's own definition of behavior chain.",
        "topic": "Key terms",
        "sourceHint": "A behavior chain is a linked sequence of responses leading to a terminal outcome."
      }
    ],
    "reviewPrompts": [
      "Define \"backward chaining\" in your own words, then check against the chapter glossary.",
      "Define \"behavior chain with a limited hold\" in your own words, then check against the chapter glossary.",
      "Define \"chaining\" in your own words, then check against the chapter glossary.",
      "Define \"behavior chain\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"A behavior chain is a linked sequence of responses leading to a terminal outcome.\"",
      "Restate this idea from the chapter in your own words: \"Each stimulus that links two sequential responses in a chain serves dual functions: It is a conditioned reinforcer for the response that produced it and an s0 for the next response in the chain..\"",
      "What is the single most important takeaway from \"Chaining\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "Behavior chains can be interrupted or broken in at least six ways."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true
    }
  },
  "24": {
    "meta": {
      "id": "24",
      "number": 24,
      "title": "Extinction",
      "subtitle": "Extinction burst, spontaneous recovery, resistance to extinction",
      "part": "Part 9 - Decreasing Behavior with Nonpunishment Procedures",
      "bacb": [
        "B-9"
      ]
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [
      {
        "id": "B-9",
        "text": "Define and provide examples of operant extinction."
      }
    ],
    "coreConcepts": [
      {
        "title": "Extinction Defined",
        "body": [
          "Withholding reinforcement for a previously reinforced behavior decreases the rate of that behavior: a procedure, process, and principle known as extinction. • As a behavior change procedure, extinction provides zero probability of reinforcement. • As a behavioral process, extinction refers to the diminbehavior no longer produces reinforcement. • As a principle, extinction refers to the functional relation between withholding reinforcement for a previously response."
        ],
        "bullets": [
          "Behaviors maintained by negative reinforcement are placed on extinction (escape extinction) when those behaviors do not produce a removal of the aversive stimulus, meaning that the individual cannot escape from the aversive situation.",
          "Behaviors maintained by automatic positive reinforcement are placed on extinction (sensory extinction) by masking or removing the sensory consequence. ishing rate of a previously reinforced behavior when that"
        ]
      },
      {
        "title": "Secondary Effects of Extinction",
        "body": [
          "Behaviors undergoing extinction are usually associated with effects in occurrence and topography of response."
        ],
        "bullets": []
      },
      {
        "title": "Variables Affecting Resistance to Extinction",
        "body": [
          "Behavior that continues to occur during extinction is said to have greater resistance to extinction than behavior that diminishes quickly. Resistance to extinction is a relative concept."
        ],
        "bullets": [
          "Extinction (a) does not refer to any decrease in behavior, (b) is not the same as forgetting, (c) is not response blocking, and (d) is not noncontingent reinforcement."
        ]
      },
      {
        "title": "Extinction Procedures",
        "body": [
          "Procedures for extinction take three distinct forms that are Linked to behavior maintained by positive reinforcement, negative reinforcement, and automatic (positive and negative) reinforcement."
        ],
        "bullets": [
          "Intermittent schedules of reinforcement may produce behavior with greater resistance to extinction than the resistance produced by a continuous reinforcement schedule.",
          "Variable schedules of reinforcement (e.g., VR, VI) may have more resistance to extinction than fixed schedules (e.g., FR, FI).",
          "To a degree, the thinner the intermittent schedule of reinforcement is, the greater the resistance to extinction will be.",
          "Resistance to extinction is likely to increase with the strength of the establishing operation (EO) for the reinforcer being withheld. 594 Part 9 • Decreasing Behavior with Nonpunishment Procedures"
        ]
      },
      {
        "title": "When Not to Use Extinction",
        "body": [
          "Extinction should not be used as a singular intervention in the following circumstances: when the target behavior behavior. is harmful, when all sources of reinforcement cannot be withheld, when a rapid reduction in behavior is required, or when others are likely to imitate the problem behavior."
        ],
        "bullets": []
      }
    ],
    "glossary": [
      {
        "term": "escape ext inction",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "extinction-i nduced variabi lit y",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "resurgence",
        "definition": "Desirable resurgence occurs when a previously reinforced adaptive behavior recurs fo llowing an extinction period and during a period when other behaviors in the repertoire are unsuccessful (Epstein, 1991; Hoffman & Falcomata, 2014).",
        "sourceHint": "Desirable resurgence occurs when a previously reinforced adaptive behavior recurs fo llowing an extinction period and during a period when other behaviors in the repertoire are unsuccessful (Epstein, 1991; Hoffman & Falcomata, 2014)."
      },
      {
        "term": "ext inct io n",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "resist ance t o ext inction",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "sponta neous recovery",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "ext inctio n burst",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Define and provide examples of operant extinction.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Use extinction .",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "ithholding reinforcement for a previously reinforced",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "\"adaptation,\" because it resembled the slow disappearance",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "resultant diminishing rate of response.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "disruptions to aggressive and self-injurious behavior. The",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "effectiveness of extinction depends primarily on identifying",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "target behavior. Although executing an extinction procedure",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "woul",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "Behaviors maintained by automatic positive reinforcement are placed on extinction (also called sensory extinction) by masking or twirling an object, such as a plate, on a table.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Behaviors maintained by automatic positive reinforcement are placed on extinction (also called sensory extinction) by masking or twirling an object, such as a plate, on a table."
      },
      {
        "scenario": "For example, practitioners should anticipate an initial increase in disruption during extinction.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, practitioners should anticipate an initial increase in disruption during extinction."
      },
      {
        "scenario": "For example, if a child asks politely for a reinforcer and the request is denied, he or she may begin to whine or attempt to \"steal\" the item.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, if a child asks politely for a reinforcer and the request is denied, he or she may begin to whine or attempt to \"steal\" the item."
      },
      {
        "scenario": "For example, parents may be unwilling to ignore tantrum behavior for a sufficient amount of time because tantrums are aversive to parents and disruptive to other family members or siblings trying to go to sleep.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, parents may be unwilling to ignore tantrum behavior for a sufficient amount of time because tantrums are aversive to parents and disruptive to other family members or siblings trying to go to sleep."
      }
    ],
    "comparisons": [],
    "misconceptions": [
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "Extinction (a) does not refer to any decrease in behavior, (b) is not the same as forgetting, (c) is not response blocking, and (d) is not noncontingent reinforcement.",
        "sourceHint": "Extinction (a) does not refer to any decrease in behavior, (b) is not the same as forgetting, (c) is not response blocking, and (d) is not noncontingent reinforcement."
      },
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "Extinction should not be used as a singular intervention in the following circumstances: when the target behavior behavior.",
        "sourceHint": "Extinction should not be used as a singular intervention in the following circumstances: when the target behavior behavior."
      }
    ],
    "examChecklist": [
      "Address objective B-9: Define and provide examples of operant extinction.",
      "Define \"resurgence\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Desirable resurgence occurs when a previously reinforced adaptive behavior recurs fo llowing an extinction period and during a period when other behaviors in the repertoire are unsuccessful (Epstein, 1991; Hoffman & Falcomata, 2014).\"",
        "options": [
          {
            "label": "A",
            "text": "resurgence"
          },
          {
            "label": "B",
            "text": "escape ext inction"
          },
          {
            "label": "C",
            "text": "extinction-i nduced variabi lit y"
          },
          {
            "label": "D",
            "text": "ext inct io n"
          }
        ],
        "answer": "A",
        "explanation": "\"Desirable resurgence occurs when a previously reinforced adaptive behavior recurs fo llowing an extinction period and during a period when other behaviors in the repertoire are unsuccessful (Epstein, 1991; Hoffman & Falcomata, 2014).\" is the chapter's own definition of resurgence.",
        "topic": "Key terms",
        "sourceHint": "Desirable resurgence occurs when a previously reinforced adaptive behavior recurs fo llowing an extinction period and during a period when other behaviors in the repertoire are unsuccessful (Epstein, 1991; Hoffman & Falcomata, 2014)."
      }
    ],
    "reviewPrompts": [
      "Define \"resurgence\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"Withholding reinforcement for a previously reinforced behavior decreases the rate of that behavior: a procedure, process, and principle known as extinction.\"",
      "What is the single most important takeaway from \"Extinction\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "Extinction should not be used as a singular intervention in the following circumstances: when the target behavior behavior."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true
    }
  },
  "25": {
    "meta": {
      "id": "25",
      "number": 25,
      "title": "Differential Reinforcement",
      "subtitle": "DRA, DRI, DRO, DRL",
      "part": "Part 9 - Decreasing Behavior with Nonpunishment Procedures",
      "bacb": []
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [],
    "coreConcepts": [
      {
        "title": "Behavior (ORA)",
        "body": [
          "A practitioner applying DRA reinforces occurrences of a desirable alternative to the problem behavior and withholds reinforcement for the problem behavior."
        ],
        "bullets": [
          "The learner allocates more responding to the alternative behavior and less responding to the problem behavior, as described by the matching law.",
          "When DRA entails reinforcing a behavior that cannot occur simultaneously with the problem behavior, the procedure is sometimes called differential reinforcement of incompatible behavior (DRI).",
          "A practitioner applying DRO delivers reinforcers contingent on the problem behavior not occurring throughout intervals of time (interval DRO) or at specific moments of time (momentary DRO).",
          "With interval DRO, the omission of the problem behavior throughout a predetermined time interval produces reinforcement, and any instance of the problem behavior during the interval resets the interval and postpones reinforcement."
        ]
      },
      {
        "title": "Responding (DRL)",
        "body": [
          "DRL is used to decrease the rate of a behavior that occurs"
        ],
        "bullets": [
          "Reinforcement on a full-session DRL schedule is delivered when responding during an entire instructional or treatment session is equal to or below a criterion limit.",
          "On an interval DRL schedule of reinforcement, the practivals of time and provides reinforcement at the end of each interval in which the number of responses was equal to or below a criterion limit.",
          "Reinforcement on a spaced-responding DRL schedule follows each occurrence of the target behavior that is separated from the previous response by a minimum interresponse time (IRT)."
        ]
      }
    ],
    "glossary": [
      {
        "term": "differential reinforcement of",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "differential reinforcement of other",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "differential reinforcement of low",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "solicitous behavior actually occurred more often under",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "illustrates the use of differential reinforcement.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "similar circumstances. Moreover, the immediate increase",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "For example, if Fernando said something about an esting and hoped he could do it again soon.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, if Fernando said something about an esting and hoped he could do it again soon."
      },
      {
        "scenario": "For example, a classroom teacher could assign two students who frequently argue with each other to work on a class project together and reinforce cooperative behaviors associated with project development.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, a classroom teacher could assign two students who frequently argue with each other to work on a class project together and reinforce cooperative behaviors associated with project development."
      },
      {
        "scenario": "Research has identified several factors that may influence resurgence during applications of DRA, such as magnitude of reinforcement, thinning the schedules of reinforcement, response effort (e.g., Wilson, Glassford, & Koerkenmeier, 2016), and lapses in treatment integrity (e.g., Fuhrman et al., 2016).",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Research has identified several factors that may influence resurgence during applications of DRA, such as magnitude of reinforcement, thinning the schedules of reinforcement, response effort (e.g., Wilson, Glassford, & Koerkenmeier, 2016), and lapses in treatment integrity (e.g., Fuhrman et al., 2016)."
      },
      {
        "scenario": "For example, Ringdahl and colleagues (2002) compared the effects ofDRA, with and without instructional fading, on the behavior as \"reinforcement for not responding\" (p.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, Ringdahl and colleagues (2002) compared the effects ofDRA, with and without instructional fading, on the behavior as \"reinforcement for not responding\" (p."
      }
    ],
    "comparisons": [],
    "misconceptions": [],
    "examChecklist": [],
    "quiz": [],
    "reviewPrompts": [
      "Restate this idea from the chapter in your own words: \"Differential reinforcement entails reinforcing one response class and withholding reinforcement for another response class..\"",
      "What is the single most important takeaway from \"Differential Reinforcement\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "Reinforcement on a spaced-responding DRL schedule follows each occurrence of the target behavior that is separated from the previous response by a minimum interresponse time (IRT).."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true,
      "misconceptions": true,
      "quiz": true
    }
  },
  "26": {
    "meta": {
      "id": "26",
      "number": 26,
      "title": "Antecedent Interventions",
      "subtitle": "NCR, high-p sequences, functional communication training",
      "part": "Part 9 - Decreasing Behavior with Nonpunishment Procedures",
      "bacb": [
        "G-2",
        "G-14"
      ]
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [
      {
        "id": "G-2",
        "text": "Use interventions based on motivating operations and discriminative st imuli."
      },
      {
        "id": "G-14",
        "text": "Use reinforcement procedu res to wea ken behavior (e.g., DRA, FCT, DRO, DRL, NCR)."
      }
    ],
    "coreConcepts": [
      {
        "title": "Defining and Classifying Antecedent Interventions",
        "body": [
          "An antecedent intervention is implemented prior to and independent of the target behavior's occurrence."
        ],
        "bullets": [
          "Smith (2011) identified two broad categories of antecedent interventions: Function-based antecedent interventions manipulate at least one component of the contingency identified as maintaining the problem behavior; default interventions do not depend on identifying the variables that evoke and maintain the problem behavior. (FT) or variable-time (VT) schedule independent of the learner's behavior.",
          "An NCR-enriched environment may function as an abolishing operation (AO) that reduces motivation to engage in the problem behavior.",
          "A functional analysis of the reinforcing contingency maintaining the problem behavior determines whether NCR is implemented with positive reinforcement, negative reinforcement (escape), or automatic reinforcement."
        ]
      },
      {
        "title": "Noncontingent Reinforcement",
        "body": [
          "NCR is an antecedent intervention in which stimuli with known reinforcing properties are delivered on a fixed-time"
        ],
        "bullets": []
      },
      {
        "title": "High-probability Instructional Sequence",
        "body": [
          "The reductive effects of the high-p instructional sequence on noncompliance resemble the abative effects of an AO that reduces the current potency of reinforcement for noncompliance with the low-probability requests (i.e., reducing the value of escape from requests)."
        ],
        "bullets": [
          "Behavioral momentum is sometimes used to describe the effects produced by the high-p instructional sequence."
        ]
      },
      {
        "title": "Functional Communication Training",
        "body": [
          "FCT establishes an appropriate communicative behavior to compete with problem behaviors evoked by a motivating operation (MO)."
        ],
        "bullets": [
          "The practitioner uses DRA to teach an adaptive response that produces the same reinforcer that has maintained the problem behavior, thereby making the alternative communicative response functionally equivalent to the problem behavior."
        ]
      },
      {
        "title": "Default Interventions",
        "body": [
          "Default antecedent interventions do not depend on identifying the variables that evoke and maintain the problem behavior."
        ],
        "bullets": [
          "Antecedent exercise requires the participant to engage in some form of aerobic activity prior to receiving an instruction or entering an environment in which the problem behavior has frequently occurred.",
          "The noncontingent access to preferred sources of reinforcement provided by an enriched environment intervention arranges a competition between the intervention and the stimulation provided by the problem behavior.",
          "Three methods of restraint-physically limiting, prohibiting, or securing an individual in such a manner that the problem behavior cannot occur-have been evaluated in the applied behavior analysis literature: personal restraint, protective equipment restraint, and self-restraint."
        ]
      }
    ],
    "glossary": [
      {
        "term": "antecedent exercise",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "fixed-time schedule",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "antecedent intervention",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "functional communication",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "restraint",
        "definition": "Smith and Iwata ( 1997) noted that antecedent exercise is used regularly for self-injury, aggression, and stereotypy; enriched environment is most frequently applied for problem behaviors maintained by automatic positive reinforcement; and restraint is an appropriate intervention for severe behavior problems in limited selected situations.",
        "sourceHint": "Smith and Iwata ( 1997) noted that antecedent exercise is used regularly for self-injury, aggression, and stereotypy; enriched environment is most frequently applied for problem behaviors maintained by automatic positive reinforcement; and restraint is an appropriate intervention for severe behavior problems in limited selected situations."
      },
      {
        "term": "behavioral momentum",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "variable-time schedule",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "enriched environment",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "high-probability request sequence",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Use the high-probability instructional sequence.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "precision teaching, and behavior analysis. The school",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "behavior analysis to conduct weekly after-school in-service",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "behavior-we can describe examples of good playground",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "dren during recess.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "performance. However, the",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "For example, an establishing operation will increase the current rate of certain types of behavior even when an effective reinforcer is not available.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, an establishing operation will increase the current rate of certain types of behavior even when an effective reinforcer is not available."
      },
      {
        "scenario": "For example, at the end of a session, the therapist establishes a new NCR time interval for the next session by dividing the number of problem behaviors that occurred in that session by the duration of A therapist should adjust the interval if the problem behavior worsens during schedule thinning.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, at the end of a session, the therapist establishes a new NCR time interval for the next session by dividing the number of problem behaviors that occurred in that session by the duration of A therapist should adjust the interval if the problem behavior worsens during schedule thinning."
      },
      {
        "scenario": "The alternative communicative responses can take many forms, such as vocalizations, signs, communication boards, word or picture cards, vocal output systems, or gestures (Brown et al., 2000; Shirley, Iwata, Kahng, Mazaleski, & Lerman, 1997).",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "The alternative communicative responses can take many forms, such as vocalizations, signs, communication boards, word or picture cards, vocal output systems, or gestures (Brown et al., 2000; Shirley, Iwata, Kahng, Mazaleski, & Lerman, 1997)."
      },
      {
        "scenario": "Decreased Use of Verbal Prompts While teaching the alternative communicative response, verbal prompts such as saying \"look:' or \"watch me\" are used often.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Decreased Use of Verbal Prompts While teaching the alternative communicative response, verbal prompts such as saying \"look:' or \"watch me\" are used often."
      }
    ],
    "comparisons": [],
    "misconceptions": [],
    "examChecklist": [
      "Address objective G-2: Use interventions based on motivating operations and discriminative st imuli.",
      "Address objective G-14: Use reinforcement procedu res to wea ken behavior (e.g., DRA, FCT, DRO, DRL, NCR).",
      "Define \"restraint\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Smith and Iwata ( 1997) noted that antecedent exercise is used regularly for self-injury, aggression, and stereotypy; enriched environment is most frequently applied for problem behaviors maintained by automatic positive reinforcement; and restraint is an appropriate intervention for severe behavior problems in limited selected situations.\"",
        "options": [
          {
            "label": "A",
            "text": "restraint"
          },
          {
            "label": "B",
            "text": "antecedent exercise"
          },
          {
            "label": "C",
            "text": "fixed-time schedule"
          },
          {
            "label": "D",
            "text": "antecedent intervention"
          }
        ],
        "answer": "A",
        "explanation": "\"Smith and Iwata ( 1997) noted that antecedent exercise is used regularly for self-injury, aggression, and stereotypy; enriched environment is most frequently applied for problem behaviors maintained by automatic positive reinforcement; and restraint is an appropriate intervention for severe behavior problems in limited selected situations.\" is the chapter's own definition of restraint.",
        "topic": "Key terms",
        "sourceHint": "Smith and Iwata ( 1997) noted that antecedent exercise is used regularly for self-injury, aggression, and stereotypy; enriched environment is most frequently applied for problem behaviors maintained by automatic positive reinforcement; and restraint is an appropriate intervention for severe behavior problems in limited selected situations."
      }
    ],
    "reviewPrompts": [
      "Define \"restraint\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"An antecedent intervention is implemented prior to and independent of the target behavior's occurrence..\"",
      "What is the single most important takeaway from \"Antecedent Interventions\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "Three methods of restraint-physically limiting, prohibiting, or securing an individual in such a manner that the problem behavior cannot occur-have been evaluated in the applied behavior analysis literature: personal restraint, protective equipment restraint, and self-restraint.."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true,
      "misconceptions": true
    }
  },
  "27": {
    "meta": {
      "id": "27",
      "number": 27,
      "title": "Functional Behavior Assessment",
      "subtitle": "Indirect, descriptive, and experimental analysis",
      "part": "Part 10 - Functional Assessment",
      "bacb": []
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [],
    "coreConcepts": [
      {
        "title": "Functions of Behavior",
        "body": [
          "The topography, or form, of a behavior often reveals little useful information about the conditions that account for it. Identifying the conditions that account for a behavior (its function) suggests what conditions need to be altered to change the behavior. Assessment of the function of a behavior can therefore yield useful information with respect to intervention strategies that are likely to be effective."
        ],
        "bullets": []
      },
      {
        "title": "Intervention and Prevention",
        "body": [
          "FBA can lead to effective interventions in at least three ways: (a) It can identify antecedent variables that can be altered to prevent problem behavior, (b) it can identify reinforcement contingencies that can be altered so that problem behavior no longer receives reinforcement, and (c) it can help identify reinforcers for alternative replacement behaviors."
        ],
        "bullets": [
          "FBA can decrease reliance on default technologies (increasingly intrusive, coercive, and punishment-based interventions) and contribute to more effective intervenpositive, negative, and/or automatic reinforcement. In this tions. When FBAs are conducted, reinforcement-based respect, problem behavior can be said to have a \"function\" interventions are more likely to be implemented than are (e.g., to \"get\" something or to \"get out of' something). interventions that include a punishment component."
        ]
      },
      {
        "title": "Overview of FBA Methods",
        "body": [
          "Functional analysis involves systematically manipulating environmental events thought to maintain problem behavior within an experimental design. The primary advantage of functional analysis is its ability to yield a clear demonstration of the variable or variables that relate to the occurrence of a problem behavior. However, this assessment method requires a certain amount of expertise to implement and interpret."
        ],
        "bullets": [
          "Indirect functional assessment methods use structured interviews, checklists, rating scales, or questionnaires to obtain information from persons who are familiar with the individual exhibiting the problem behavior (e.g., teachers, parents, caregivers, and/or the individual himself or herself) to identify possible conditions or events in the natural environment that correlate with the problem behavior. Again, these forms of FBA are easy to conduct, but they are limited in their accuracy. As such, they are probably best reserved for hypothesis formulation. Further assessment of these hypotheses is almost always necessary."
        ]
      },
      {
        "title": "Conducting a Functional Behavior Assessment",
        "body": [
          "When teaching an alternative behavior as a replacement for problem behavior, the replacement behavior should be functionally equivalent to the problem behavior (i.e., the replacement behavior should produce the same reinforcers that previously maintained the problem behavior). This page intentionally left blank"
        ],
        "bullets": []
      }
    ],
    "glossary": [
      {
        "term": "brief functional analysis",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "latency-based fun ctional analysis",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "conditional probability",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "scatterplot record ing",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "contingency reversal",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "functionall y equivalent",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "tria l-based functional analysis",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "contingency space analysis",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "indirect functional assessment",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "descriptive functional behavior",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "interview-informed synthesized",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "assessment",
        "definition": "As with trial-based assessments, a limitation to latency-based assessment is that there is only one exposure to the contingency per session.",
        "sourceHint": "As with trial-based assessments, a limitation to latency-based assessment is that there is only one exposure to the contingency per session."
      },
      {
        "term": "contingency analysis",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Conduct a descriptive assessment of problem behavior.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Conduct a functional analysis of problem behavior.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Interp ret functional assessment data.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "approaches to functional assessment. We will revisit",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Flo's problem behavior throughout this chapter to",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "illustrate.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "information valuable for creating an effective behavior",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "intervention. Consistent with the scientific precept of",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "enables hypotheses about the relations among specific",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "as positive or negative reinforcement",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [
      {
        "title": "Intervention and Prevention",
        "steps": [
          {
            "title": "FBA can lead to effective interventions in at",
            "detail": "FBA can lead to effective interventions in at least three ways: (a) It can identify antecedent variables that can be altered to prevent problem behavior, (b) it can identify reinforcement contingencies that can be altered so that problem behavior no longer receives reinforcement, and (c) it can help identify reinforcers for alternative replacement behaviors..",
            "sourceHint": "FBA can lead to effective interventions in at least three ways: (a) It can identify antecedent variables that can be altered to prevent problem behavior, (b) it can identify reinforcement contingencies that can be altered so that problem behavior no longer receives reinforcement, and (c) it can help identify reinforcers for alternative replacement behaviors.."
          },
          {
            "title": "FBA can decrease reliance on default technologies (increasingly",
            "detail": "FBA can decrease reliance on default technologies (increasingly intrusive, coercive, and punishment-based interventions) and contribute to more effective intervenpositive, negative, and/or automatic reinforcement.",
            "sourceHint": "FBA can decrease reliance on default technologies (increasingly intrusive, coercive, and punishment-based interventions) and contribute to more effective intervenpositive, negative, and/or automatic reinforcement."
          }
        ]
      }
    ],
    "examples": [
      {
        "scenario": "Positive Reinforcement Social Positive Reinforcement (Attention) Problem behavior often results in immediate attention from others, such as head turns; surprised facial expressions; reprimands; attempts to soothe, counsel, or distract; and so on.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Positive Reinforcement Social Positive Reinforcement (Attention) Problem behavior often results in immediate attention from others, such as head turns; surprised facial expressions; reprimands; attempts to soothe, counsel, or distract; and so on."
      },
      {
        "scenario": "For example, thumb sucking might be reinforced by physical stimulation of either the hand or the mouth.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, thumb sucking might be reinforced by physical stimulation of either the hand or the mouth."
      },
      {
        "scenario": "Behaviors such as aggression, self-injurious behavior (SIB), and bizarre speech may terminate or avoid unwanted interactions with others.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Behaviors such as aggression, self-injurious behavior (SIB), and bizarre speech may terminate or avoid unwanted interactions with others."
      },
      {
        "scenario": "For example, noncompliance postpones engagement in a nonpreferred activity, and disruptive classroom behavior often results in the student being sent out of the classroom, thereby allowing escape from instructional tasks or teacher demands.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, noncompliance postpones engagement in a nonpreferred activity, and disruptive classroom behavior often results in the student being sent out of the classroom, thereby allowing escape from instructional tasks or teacher demands."
      }
    ],
    "comparisons": [],
    "misconceptions": [],
    "examChecklist": [
      "Define \"assessment\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"As with trial-based assessments, a limitation to latency-based assessment is that there is only one exposure to the contingency per session.\"",
        "options": [
          {
            "label": "A",
            "text": "assessment"
          },
          {
            "label": "B",
            "text": "brief functional analysis"
          },
          {
            "label": "C",
            "text": "latency-based fun ctional analysis"
          },
          {
            "label": "D",
            "text": "conditional probability"
          }
        ],
        "answer": "A",
        "explanation": "\"As with trial-based assessments, a limitation to latency-based assessment is that there is only one exposure to the contingency per session.\" is the chapter's own definition of assessment.",
        "topic": "Key terms",
        "sourceHint": "As with trial-based assessments, a limitation to latency-based assessment is that there is only one exposure to the contingency per session."
      }
    ],
    "reviewPrompts": [
      "Define \"assessment\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"Many problem behaviors are learned and maintained by.\"",
      "Restate this idea from the chapter in your own words: \"The topography, or form, of a behavior often reveals little useful information about the conditions that account for it.\"",
      "What is the single most important takeaway from \"Functional Behavior Assessment\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "When teaching an alternative behavior as a replacement for problem behavior, the replacement behavior should be functionally equivalent to the problem behavior (i.e., the replacement behavior should produce the same reinforcers that previously maintained the problem behavior)."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "comparisons": true,
      "misconceptions": true
    }
  },
  "28": {
    "meta": {
      "id": "28",
      "number": 28,
      "title": "Token Economy, Group Contingencies, and Contingency Contracting",
      "subtitle": "Conditioned generalized reinforcers, independent / interdependent / dependent contingencies",
      "part": "Part 11 - Special Applications",
      "bacb": []
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [],
    "coreConcepts": [
      {
        "title": "Token Economy",
        "body": [
          "Tokens are objects, symbols, marks, or chips that function as generalized conditioned reinforcers because they have been paired with a wide variety of backup reinforcers."
        ],
        "bullets": [
          "As participants move \"up\" from one level to the next, they have access to more privileges and are expected to demonstrate more independence. A level system is a type of token economy in which participants move up or down a hierarchy of levels contingent on meeting specific performance criteria with respect to the target behaviors.",
          "When establishing a token economy, decisions must be made regarding how to begin, conduct, maintain, remove, and evaluate the system ."
        ]
      },
      {
        "title": "Group Contingencies",
        "body": [
          "In a group contingency a common consequence (usually, but not necessarily, a reward intended to function as reinforcement) is contingent on the behavior of one member of the group, the behavior of part of the group, or the behavior of everyone in the group."
        ],
        "bullets": [
          "Group contingencies can be classified as independent, dependent, and interdependent, and they offer the behavior analyst multiple advantages for improving or reducing behaviors. maj or components: (a) a specified list of target behaviors",
          "Future applications of group contingencies might explore their effectiveness with larger societal issues (e.g., global warming), or chronic, systemic, difficult-to-treat individual challenges (e.g., smoking cessation, addictive behaviors)."
        ]
      },
      {
        "title": "Contingency Contracting",
        "body": [
          "Two components required in all contingency contracts are a description of the task and a description of the reward. Under task, who, what, when, and how well should be specified. Under reward, who, what, when, and how much should be specified. An optional task record provides a place for recording the progress of the contract and providing interim rewards."
        ],
        "bullets": [
          "A self-contract is a contingency contract that an individual makes with herself, incorporating a self-selected task and reward as well as self-monitoring of task completion and self-delivery of the reward."
        ]
      }
    ],
    "glossary": [
      {
        "term": "backup reinforcer",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "group contingency",
        "definition": "Choose an Effective Reward One of the more important aspects of a group contingency is the strength of the consequence; it must be strong enough to serve as an effective reward.",
        "sourceHint": "Choose an Effective Reward One of the more important aspects of a group contingency is the strength of the consequence; it must be strong enough to serve as an effective reward."
      },
      {
        "term": "level system",
        "definition": "Level Systems To see the enormous power of conditioned reinforcement, A level system is a type of token economy in which participants move up (and sometimes down) a hierarchy of tiers contingent behavior.",
        "sourceHint": "Level Systems To see the enormous power of conditioned reinforcement, A level system is a type of token economy in which participants move up (and sometimes down) a hierarchy of tiers contingent behavior."
      },
      {
        "term": "contingency contract",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "hero procedure",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "self-contract",
        "definition": "A self-contract is a contingency contract that a person makes with herself, incorporating a self-selected task and reward as well as personal monitoring of task completion and self-delivery of the reward.",
        "sourceHint": "A self-contract is a contingency contract that a person makes with herself, incorporating a self-selected task and reward as well as personal monitoring of task completion and self-delivery of the reward."
      },
      {
        "term": "dependent group contingency",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "independent group contingency",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "token",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "interdependent group contingency",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "token economy",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Use token econom ies.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Use group contingencies.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Use contingency contracting.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "tingencies, and contingency contracting as behavior",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "literatures. Further, token economies have proved successful",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "applied settings.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "various settings.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "For example, a token may be earned during the afternoon, but Second, tokens bridge the setting gap between the behavior and the delivery of the backup reinforcer.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, a token may be earned during the afternoon, but Second, tokens bridge the setting gap between the behavior and the delivery of the backup reinforcer."
      },
      {
        "scenario": "Higgins, Williams, and McLaughlin (2001 ), for example, arranged using a number of basic reinforcement schedules used a token economy to decrease the disruptive behaviors of (e.g., fixed ratio and variable interval) or complex schedules an elementary-age student with learning disabilities.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Higgins, Williams, and McLaughlin (2001 ), for example, arranged using a number of basic reinforcement schedules used a token economy to decrease the disruptive behaviors of (e.g., fixed ratio and variable interval) or complex schedules an elementary-age student with learning disabilities."
      },
      {
        "scenario": "For example, in a classroom setting, the teacher may want to select different behaviors for each student, or perhaps the token economy should not be applied to all students in the classroom.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, in a classroom setting, the teacher may want to select different behaviors for each student, or perhaps the token economy should not be applied to all students in the classroom."
      },
      {
        "scenario": "For example, in a classroom, center, or school setting, tokens can be exchanged for popular games or materials, or they can be traded for favorite classroom selected as the tokens, how the learner will receive them is obvijobs, such as office messenger, materials distributor, teacher assistant, or media operator.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, in a classroom, center, or school setting, tokens can be exchanged for popular games or materials, or they can be traded for favorite classroom selected as the tokens, how the learner will receive them is obvijobs, such as office messenger, materials distributor, teacher assistant, or media operator."
      }
    ],
    "comparisons": [],
    "misconceptions": [],
    "examChecklist": [
      "Define \"group contingency\" from memory and match the source text.",
      "Define \"level system\" from memory and match the source text.",
      "Define \"self-contract\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Choose an Effective Reward One of the more important aspects of a group contingency is the strength of the consequence; it must be strong enough to serve as an effective reward.\"",
        "options": [
          {
            "label": "A",
            "text": "group contingency"
          },
          {
            "label": "B",
            "text": "level system"
          },
          {
            "label": "C",
            "text": "self-contract"
          },
          {
            "label": "D",
            "text": "backup reinforcer"
          }
        ],
        "answer": "A",
        "explanation": "\"Choose an Effective Reward One of the more important aspects of a group contingency is the strength of the consequence; it must be strong enough to serve as an effective reward.\" is the chapter's own definition of group contingency.",
        "topic": "Key terms",
        "sourceHint": "Choose an Effective Reward One of the more important aspects of a group contingency is the strength of the consequence; it must be strong enough to serve as an effective reward."
      },
      {
        "id": "Q2",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Level Systems To see the enormous power of conditioned reinforcement, A level system is a type of token economy in which participants move up (and sometimes down) a hierarchy of tiers contingent behavior.\"",
        "options": [
          {
            "label": "A",
            "text": "group contingency"
          },
          {
            "label": "B",
            "text": "self-contract"
          },
          {
            "label": "C",
            "text": "backup reinforcer"
          },
          {
            "label": "D",
            "text": "level system"
          }
        ],
        "answer": "D",
        "explanation": "\"Level Systems To see the enormous power of conditioned reinforcement, A level system is a type of token economy in which participants move up (and sometimes down) a hierarchy of tiers contingent behavior.\" is the chapter's own definition of level system.",
        "topic": "Key terms",
        "sourceHint": "Level Systems To see the enormous power of conditioned reinforcement, A level system is a type of token economy in which participants move up (and sometimes down) a hierarchy of tiers contingent behavior."
      },
      {
        "id": "Q3",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"A self-contract is a contingency contract that a person makes with herself, incorporating a self-selected task and reward as well as personal monitoring of task completion and self-delivery of the reward.\"",
        "options": [
          {
            "label": "A",
            "text": "level system"
          },
          {
            "label": "B",
            "text": "backup reinforcer"
          },
          {
            "label": "C",
            "text": "self-contract"
          },
          {
            "label": "D",
            "text": "group contingency"
          }
        ],
        "answer": "C",
        "explanation": "\"A self-contract is a contingency contract that a person makes with herself, incorporating a self-selected task and reward as well as personal monitoring of task completion and self-delivery of the reward.\" is the chapter's own definition of self-contract.",
        "topic": "Key terms",
        "sourceHint": "A self-contract is a contingency contract that a person makes with herself, incorporating a self-selected task and reward as well as personal monitoring of task completion and self-delivery of the reward."
      }
    ],
    "reviewPrompts": [
      "Define \"group contingency\" in your own words, then check against the chapter glossary.",
      "Define \"level system\" in your own words, then check against the chapter glossary.",
      "Define \"self-contract\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"Tokens are objects, symbols, marks, or chips that function as generalized conditioned reinforcers because they have been paired with a wide variety of backup reinforcers..\"",
      "What is the single most important takeaway from \"Token Economy, Group Contingencies, and Contingency Contracting\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "A self-contract is a contingency contract that an individual makes with herself, incorporating a self-selected task and reward as well as self-monitoring of task completion and self-delivery of the reward.."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true,
      "misconceptions": true
    }
  },
  "29": {
    "meta": {
      "id": "29",
      "number": 29,
      "title": "Self-Management",
      "subtitle": "Self-monitoring, self-evaluation, self-instruction",
      "part": "Part 11 - Special Applications",
      "bacb": []
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [],
    "coreConcepts": [
      {
        "title": "The \"Self\" as Behavior Controller",
        "body": [
          "We tend to assign causal status to events that immediately precede behavior, and when causal variables are not readily apparent in the immediate, surrounding environment, the tendency to tum to internal causes is strong."
        ],
        "bullets": [
          "Hypothetical constructs such as willpower and drive are explanatory fictions that bring us no closer to understanding the behaviors they claim to explain and lead to circular reasoning.",
          "Skinner ( 1953) conceptualized self-control as a tworesponse phenomenon: The controlling response affects variables in such a way as to change the probability of the other, the controlled response."
        ]
      },
      {
        "title": "Self-Management Defined",
        "body": [
          "We define self-management as the personal application of behavior change tactics that produces a desired change in behavior."
        ],
        "bullets": [
          "Self-management is a relative concept. A behavior change program may entail a small degree of self-management or be totally conceived, designed, and implemented by the person.",
          "Although self-control and self-management often appear interchangeably in the behavioral literature, we recommend that self-management be used in reference to a person acting in some way in order to change his subsequent behavior. Three reasons for this recommendation are as follows: • Self-control implies that the ultimate control of behavior lies within the person, but the causal factors for \"self-control\" are to be found in a person ' s experiences with his environment. • Self-control as a causal factor can serve as an explanatory fiction suggesting \"a [separate] self inside or [that there is] a self inside controlling external behavior\" (Baum, 2017, p. 167).",
          "People discount the value of delayed rewards; the greater the delay, the less value or influence the reward has on current behavior. Behavior analysts call this phenomenon delay discounting (or temporal discounting)."
        ]
      },
      {
        "title": "Self-Monitoring",
        "body": [
          "Self-monitoring is a procedure whereby a person observes and responds to, usually by recording, the behavior he is trying to change."
        ],
        "bullets": [
          "Originally developed as a method of clinical assessment for collecting data on behaviors that only the client could observe, self-monitoring evolved into the most widely used and studied self-management strategy because it often results in desired behavior change. 712 Part 11 • Special Applications",
          "Self-monitoring is often combined with goal setting and self-evaluation. A person using self-evaluation compares her performance with a predetermined goal or standard.",
          "Self- monitoring is often part of an intervention that includes reinforcement for meeting either self- or teacher-selected goal s.",
          "It is difficult to determine exactly how self-monitoring works because the procedure necessarily includes, and is therefore confo unded by, private events (covert verbal behavior); it often includes either explicit or implicit contingencies of reinforcement."
        ]
      },
      {
        "title": "Self-Administ ered Consequences",
        "body": [
          "As a technical term, self-reinforcement (as also, selfpunishment) is a misnomer. Although behavior can be changed by self-administered consequences, the variables influencing the controlling response make such self-management tactics more than a straightforward application of operant reinforcement."
        ],
        "bullets": [
          "Self-administered contingencies analogous to positive and negative reinforcement and positive and negative punishment can be incorporated into self-management programs."
        ]
      },
      {
        "title": "Other Self-Management Tactics",
        "body": [
          "Self-instruction (talking to oneself) can function as a controlling response (verbal mediator) that affects the occurrence of other behaviors."
        ],
        "bullets": [
          "Habit reversal is a multiple-component treatment package in which clients are taught to self-monitor their unwanted habits and interrupt the behavior chain as early as possible by engaging in a behavior incompatible with the problem behavior.",
          "Systematic desensitization is a behavior therapy treatment for anxieties, fears, and phobias that involves substituting one behavior, generally muscle relaxation, for the unwanted behavior- the fear and anxiety. Self-directed systematic desensitization involves developing a hierarchy of situations from the least to the most fearful and then learning to relax while imagining these anxiety-produc ing situations, first the least fearful situation, then the next fearful one, and so on. • Self-monitor the most important dimension of the target 25. Massed practice, forcing oneself to perform an undesired behavior again and again, can decrease future occurrences of the behavior."
        ]
      },
      {
        "title": "Beha vior Changes Behavior",
        "body": [
          "The most fundamental principle of self-management is that behavior changes behavior."
        ],
        "bullets": []
      }
    ],
    "glossary": [
      {
        "term": "delay discounting",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "se lf -contro l [im pulse control]",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "self-monitoring",
        "definition": "Self-monitoring is a procedure whereby a person observes and responds to, usually by recording, the behavior he is trying to change.",
        "sourceHint": "Self-monitoring is a procedure whereby a person observes and responds to, usually by recording, the behavior he is trying to change."
      },
      {
        "term": "habit reversa l",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "self-evaluation",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "systematic desensitizat ion",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "massed pract ice",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "self -inst ruct ion",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "self -cont ro l [Skinner's analysis]",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "se lf-management",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Use self-management strategies.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "self-management, identifies uses for self-management and",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Causes of Behavior",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "Although some psychological theories grant causal status to hypothetical constructs such as willpower, desire, and drive, these explanatory fictions lead to circular reasoning, bring us no closer to understanding the behaviors they claim to explain, and thus have no role in a behavior analysis of self-control.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Although some psychological theories grant causal status to hypothetical constructs such as willpower, desire, and drive, these explanatory fictions lead to circular reasoning, bring us no closer to understanding the behaviors they claim to explain, and thus have no role in a behavior analysis of self-control."
      },
      {
        "scenario": "to definitions such as Thoresen and Mahoney's, the man would not be credited with self-control if his wife were there reminding him not to overeat, praising him for riding the exercise bike, and (e.g., client, child, student), the external change agent manipmarking his time and mileage ridden on a chart.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "to definitions such as Thoresen and Mahoney's, the man would not be credited with self-control if his wife were there reminding him not to overeat, praising him for riding the exercise bike, and (e.g., client, child, student), the external change agent manipmarking his time and mileage ridden on a chart."
      },
      {
        "scenario": "Definitions of self-control such as Kazdin 's (2013), \"those behaviors that an individual deliberately undertakes to achieve self-selected outcomes by manipulating antecedent and consequence events\" (p.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Definitions of self-control such as Kazdin 's (2013), \"those behaviors that an individual deliberately undertakes to achieve self-selected outcomes by manipulating antecedent and consequence events\" (p."
      },
      {
        "scenario": "This intentionally broad definition of self-management encompasses one-time self-management events, such as Raylene's taping a note to her closet door to remind herself to wear her gray behavior change programs in which a person plans and implements one or more contingencies to change his behavior.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "This intentionally broad definition of self-management encompasses one-time self-management events, such as Raylene's taping a note to her closet door to remind herself to wear her gray behavior change programs in which a person plans and implements one or more contingencies to change his behavior."
      }
    ],
    "comparisons": [],
    "misconceptions": [
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "We tend to assign causal status to events that immediately precede behavior, and when causal variables are not readily apparent in the immediate, surrounding environment, the tendency to tum to internal causes is strong.",
        "sourceHint": "We tend to assign causal status to events that immediately precede behavior, and when causal variables are not readily apparent in the immediate, surrounding environment, the tendency to tum to internal causes is strong."
      }
    ],
    "examChecklist": [
      "Define \"self-monitoring\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"Self-monitoring is a procedure whereby a person observes and responds to, usually by recording, the behavior he is trying to change.\"",
        "options": [
          {
            "label": "A",
            "text": "self-monitoring"
          },
          {
            "label": "B",
            "text": "delay discounting"
          },
          {
            "label": "C",
            "text": "se lf -contro l [im pulse control]"
          },
          {
            "label": "D",
            "text": "habit reversa l"
          }
        ],
        "answer": "A",
        "explanation": "\"Self-monitoring is a procedure whereby a person observes and responds to, usually by recording, the behavior he is trying to change.\" is the chapter's own definition of self-monitoring.",
        "topic": "Key terms",
        "sourceHint": "Self-monitoring is a procedure whereby a person observes and responds to, usually by recording, the behavior he is trying to change."
      }
    ],
    "reviewPrompts": [
      "Define \"self-monitoring\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"We tend to assign causal status to events that immediately precede behavior, and when causal variables are not readily apparent in the immediate, surrounding environment, the tendency to tum to internal causes is strong..\"",
      "Restate this idea from the chapter in your own words: \"Hypothetical constructs such as willpower and drive are explanatory fictions that bring us no closer to understanding the behaviors they claim to explain and lead to circular reasoning..\"",
      "What is the single most important takeaway from \"Self-Management\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "The most fundamental principle of self-management is that behavior changes behavior.."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true
    }
  },
  "30": {
    "meta": {
      "id": "30",
      "number": 30,
      "title": "Generalization and Maintenance of Behavior Change",
      "subtitle": "Stokes & Baer tactics, programming common stimuli",
      "part": "Part 12 - Promoting Generalized Behavior Change",
      "bacb": [
        "G-21",
        "G-22",
        "H-9"
      ]
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [
      {
        "id": "G-21",
        "text": "Use procedures to promote stimulus and response generalization."
      },
      {
        "id": "G-22",
        "text": "Use procedures to promote maintenance."
      },
      {
        "id": "H-9",
        "text": "Collaborate with others w ho support and/or provide services to clients."
      }
    ],
    "coreConcepts": [
      {
        "title": "Key Concepts",
        "body": [
          "Generalized behavior change has taken place if trained behavior occurs at other times or in other places without having to be retrained completely in those times or places, or if functionally related behaviors occur that were not taught directly."
        ],
        "bullets": [
          "Setting/situation generalization refers to the extent to which a learner emits the target behavior in settings or situations that are different from the instructional setting.",
          "The instructional setting is the environment where instruction occurs and encompasses all aspects of the environment, planned or unplanned, that may influence the learner's acquisition and generalization of the target behavior.",
          "A generalization setting is any place or stimulus situation that differs from the instructional setting in some meaningful way and in which performance of the target behavior is desired. 754 Part 12 • Promoting Generalized Behavior Change",
          "Response generalization refers to the extent to which a learner emits untrained responses that are functionally equivalent to the trained response."
        ]
      },
      {
        "title": "Planning for Generalized Behavior Change",
        "body": [
          "The first step in promoting generalized behavior changes is to select target behaviors that will meet naturally existing contingencies of reinforcement."
        ],
        "bullets": [
          "A naturally existing contingency is any contingency of reinforcement (or punishment) that operates independent of the behavior analyst's or practitioner's efforts, including socially mediated contingencies contrived by other people and already in effect in the relevant setting.",
          "A contrived contingency is any contingency of reinforcement (or punishment) designed and implemented by a behavior analyst to achieve the acquisition, maintenance, and/or generalization of a targeted behavior change.",
          "Planning for generalization includes identifying all the desired behavior changes and all the environments in which the learner should emit the target behavior(s) after direct training has ceased.",
          "Benefits of developing the planning lists include a better understanding of the scope of the teaching task and an opportunity to prioritize the most important behavior changes and settings for direct instruction."
        ]
      },
      {
        "title": "Behavior Change",
        "body": [
          "Researchers have developed and advanced what Stokes and Baer (1977) called an \"implicit technology of generalization\" into an increasingly explicit and effective set of methods for promoting generalized behavior change."
        ],
        "bullets": [
          "The strategy of teaching enough examples requires teaching a subset of all of the possible stimulus and response examples and then assessing the learner's performance on untrained examples.",
          "A generalization probe is any measurement of a learner's performance of a target behavior in a setting and/or stimulus situation in which direct training has not been provided.",
          "Teaching enough stimulus examples involves teaching the learner to respond correctly to more than one example of an antecedent stimulus and probing for generalization to untaught stimulus examples.",
          "As a general rule, the more examples the practitioner uses during instruction, the more likely the learner will be to respond correctly to untrai ned examples or situations."
        ]
      },
      {
        "title": "Modifying and Terminating Successful Interventions",
        "body": [
          "With most successful behavior change programs it is impossible, impractical, or undesirable to continue the intervention indefinitely."
        ],
        "bullets": [
          "The shift from formal intervention procedures to a normal everyday environment can be accomplished by gradually withdrawing elements constituting the three components of the training program: (a) antecedents, prompts, or cue-related stimuli; (b) task modifications and criteria; and (c) consequences or reinforcement variables.",
          "An important behavior change should not go unmade because complete withdrawal of the intervention required to achieve it may never be possible. Some level of intervention may always be required to maintain certain behaviors, in which case attempts must be made to continue necessary programming."
        ]
      }
    ],
    "glossary": [
      {
        "term": "behavior trap",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "generali zat ion setting",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "program co mmo n st im uli",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "contrived contingency",
        "definition": "A contrived contingency is any contingency of reinforcement (or punishment) designed and implemented by a behavior analyst to achieve the acquisition, maintenance, and/or generalization of a targeted behavior change.",
        "sourceHint": "A contrived contingency is any contingency of reinforcement (or punishment) designed and implemented by a behavior analyst to achieve the acquisition, maintenance, and/or generalization of a targeted behavior change."
      },
      {
        "term": "generali zed behavior cha nge",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "response gene ra lizat ion",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "contrived mediating sti mulus",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "indiscri minable co nt ingency",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "response maintenance",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "genera l case ana lysis",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "instruct ional set t ing",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "setting/sit uation generalization",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "genera lizat ion across subj ects",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "m ultiple-exemplar training",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "teach lo osely",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "genera lizat ion probe",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "naturally exist ing contingency",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "teach enough examples",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Use procedures to promote maintenance.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Sherry's teacher implemented an intervention that taught",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "assignments before submitting them and beginning another",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "soon lose his job.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "as it was before the intervention began.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "education program that targets functional language and",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "son 's language seems stilted and parrot-like.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "Other behaviors, such as literacy, self-care, and social skills, must be maintained in a person' s repertoire for a lifetime.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "Other behaviors, such as literacy, self-care, and social skills, must be maintained in a person' s repertoire for a lifetime."
      },
      {
        "scenario": "For example, planned elements for a math lesson would include the specific problems and solution steps to be presented and the format and sequencing of those items.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, planned elements for a math lesson would include the specific problems and solution steps to be presented and the format and sequencing of those items."
      },
      {
        "scenario": "For example, the phrase how much in a word problem may acquire correct solution to the problem requires a different arithmetic operation.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, the phrase how much in a word problem may acquire correct solution to the problem requires a different arithmetic operation."
      },
      {
        "scenario": "When a person uses a skill in an environment physically removed from the setting where she learned it-as with behaviors 1 through 3 in Figure 30.2-it is easy to understand that event as an example of generalization across settings.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "When a person uses a skill in an environment physically removed from the setting where she learned it-as with behaviors 1 through 3 in Figure 30.2-it is easy to understand that event as an example of generalization across settings."
      }
    ],
    "comparisons": [],
    "misconceptions": [
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "Negative, or \"don ' t do it,\" teaching examples help learners identify stimulus situations in which the target behavior should not be performed.",
        "sourceHint": "Negative, or \"don ' t do it,\" teaching examples help learners identify stimulus situations in which the target behavior should not be performed."
      },
      {
        "myth": "A common shortcut misses the qualifier the chapter spells out below.",
        "reality": "An important behavior change should not go unmade because complete withdrawal of the intervention required to achieve it may never be possible.",
        "sourceHint": "An important behavior change should not go unmade because complete withdrawal of the intervention required to achieve it may never be possible."
      }
    ],
    "examChecklist": [
      "Address objective G-21: Use procedures to promote stimulus and response generalization.",
      "Address objective G-22: Use procedures to promote maintenance.",
      "Address objective H-9: Collaborate with others w ho support and/or provide services to clients.",
      "Define \"contrived contingency\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"A contrived contingency is any contingency of reinforcement (or punishment) designed and implemented by a behavior analyst to achieve the acquisition, maintenance, and/or generalization of a targeted behavior change.\"",
        "options": [
          {
            "label": "A",
            "text": "contrived contingency"
          },
          {
            "label": "B",
            "text": "behavior trap"
          },
          {
            "label": "C",
            "text": "generali zat ion setting"
          },
          {
            "label": "D",
            "text": "program co mmo n st im uli"
          }
        ],
        "answer": "A",
        "explanation": "\"A contrived contingency is any contingency of reinforcement (or punishment) designed and implemented by a behavior analyst to achieve the acquisition, maintenance, and/or generalization of a targeted behavior change.\" is the chapter's own definition of contrived contingency.",
        "topic": "Key terms",
        "sourceHint": "A contrived contingency is any contingency of reinforcement (or punishment) designed and implemented by a behavior analyst to achieve the acquisition, maintenance, and/or generalization of a targeted behavior change."
      }
    ],
    "reviewPrompts": [
      "Define \"contrived contingency\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"Response maintenance refers to the extent to which a learner continues to perform a behavior after a portion or all of the intervention responsible for the behavior's initial appearance in the learner's repertoire has been terminated..\"",
      "What is the single most important takeaway from \"Generalization and Maintenance of Behavior Change\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "An important behavior change should not go unmade because complete withdrawal of the intervention required to achieve it may never be possible."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true
    }
  },
  "31": {
    "meta": {
      "id": "31",
      "number": 31,
      "title": "Ethical and Professional Responsibilities of Applied Behavior Analysts",
      "subtitle": "BACB Ethics Code, informed consent, scope of competence",
      "part": "Part 13 - Ethics",
      "bacb": []
    },
    "overview": [
      "This module is built from the source PDF's Key Terms list, BACB Task List items, and SUMMARY block. Sections where extraction confidence was low are flagged for review and should be checked against the chapter directly."
    ],
    "objectives": [],
    "coreConcepts": [
      {
        "title": "What Is Et hics and Why Is It Important?",
        "body": [
          "For the applied behavior analyst, ethics defines specific rules of conduct."
        ],
        "bullets": [
          "Two approaches to ethics are termed the deontological or \"acts-oriented\" approach, which evaluates only the act itself, and the utilitarian or \"results-oriented\" approach, which looks at the results or consequences of the act. Both approaches contribute to the ethical conduct of behavior analysts.",
          "Ethics describes behaviors, practices, and decisions that address three basic and fundamental questions: What is the right thing to do? What is worth doing? What does it mean to be a good behavior analyst?",
          "Ethics is important because it helps practitioners decide Codes of ethics guide decisions on how to act even in the presence of outside pressures, priorities, or expediencies.",
          "Ethical practices are derived from other behavior analysts and professionals to ensure the well-being of (a) clients, (b) the profession itself, and (c) the culture as a whole. Over time, practices become codified into ethical rules of conduct that may change in response to a changing world."
        ]
      },
      {
        "title": "Behavior A nalysts",
        "body": [
          "Professional organizations adopt formalized statements of conduct, codes of professional behavior, or ethical standards of behavior to guide their members in making decisions. Also, standards exact sanctions when deviations from The Compliance Code occur."
        ],
        "bullets": [
          "The client's welfare is at the forefront of ethical decision making.",
          "Behavior analysts must take steps to ensure that their professional conduct is self-regulating.",
          "Professional standards, guidelines, or rules of practice are written statements that provide direction for conducting the practices associated with an whether a course of action related to the professional pracorganization. tice of behavior analysis is appropriate or inappropriate."
        ]
      },
      {
        "title": "Ensur ing Professional Compet ence",
        "body": [
          "Professional competence in applied behavior analysis is achieved through formal academic training that involves coursework, supervised practica, and mentored professional experience. "
        ],
        "bullets": [
          "Behavior analysts must be truthful and accurate in all professional and personal interactions.",
          "Competence in supervision is critical, as most behavior analysts supervise the work of others in the context of their practice.",
          "Formal certification and/or Licensure credentials in behavior analysis allow consumers to identify practitioners who have demonstrated at least a minimum standard of training and competence.",
          "Behavior analysts must practice within their areas of competence, training, and experience."
        ]
      },
      {
        "title": "Social Media and New Technologies",
        "body": [
          "The use of social media and the emergence of other new technologies present an increasing array of opportunities, challenges, and potential ethical pitfalls for the behavior analyst. Special care must be taken to protect client confidentiality, and the behavior analyst should avoid making case-specific treatment recommendations in a public forum."
        ],
        "bullets": [
          "New technologies allow practitioners to view treatment sessions from remote locations, in real time, which can be useful for supervisors, parents/guardians, and behavior analysts in training.",
          "All therapeutic disciplines must come to terms with the proper way to use social media, without breaching confidentiality or ethical guidelines."
        ]
      },
      {
        "title": "Ethical Issues in Client Services",
        "body": [
          "Three tests must be met before informed consent can be considered valid: capacity to decide, voluntary decision, and knowledge of the treatment."
        ],
        "bullets": [
          "Confidentiality refers to the professional standard requiring that the behavior analyst not discuss or otherwise release information regarding someone in his or her care. Information may be released only with formal permission of the individual or the individual 's guardian.",
          "Practicing behavior analysts have a responsibility to protect a client's dignity, health, and safety. Various rights 34. The choice to provide treatment may be divided into two must be observed and protected, including the right to make choices, the right to privacy, the right to a therapeutic treatment environment, and the right to refuse treatment.",
          "Negligence (not doing what one should) and fraudulent conduct (willful deceit Likely to cause harm) on the part of the behavior analyst pose a direct threat to the client's health and safety, and can result in professional sanctions and possibly legal penalties."
        ]
      },
      {
        "title": "Coordinating with Other Professionals",
        "body": [
          "Behavior analysts must coordinate services with other professionals in a way that best meets the interests of the"
        ],
        "bullets": [
          "The individual receiving services must be given the opportunity to assist in selecting and approving treatment goals. Outcomes must be selected that are primarily aimed at benefiting the individual receiving services."
        ]
      },
      {
        "title": "Advocating for the Client",
        "body": [
          "In deciding to provide services, the behavior analyst must determine that services are needed, that medical causes have been ruled out, that the treatment environment will support service delivery, and that a reasonable expectation of success exists. sets of decision rules: (I) determining that the problem is amenable to behavioral intervention and (2) evaluating the likely success of an intervention."
        ],
        "bullets": [
          "Behavior analysts embrace the scientific method, and promote evidence-based practices in all consumer-related services. 784 Part 13 • Ethics"
        ]
      },
      {
        "title": "Conflict of Interest",
        "body": [
          "All sources of conflict of interest, particularly dual relationships, are to be avoided. appraise the effects of any treatments that might affect the goals of the behavior change program. can commit to providing ethics-related trainings, support syste ms, and differential reinforcement of ethical behaviors."
        ],
        "bullets": []
      },
      {
        "title": "Creating a Culture of Ethical Practice",
        "body": [
          "When coordinating with other professional service providers, behavior analysts have a responsibility to review and"
        ],
        "bullets": [
          "Continuous education and discussion about ethics and the contingencies that support analysis and assistance seeki ng are core features of an environment designed to maintain ethical behavior in an organization."
        ]
      }
    ],
    "glossary": [
      {
        "term": "Comp liance Code",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "d isciplinary standards",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "informed consent",
        "definition": "According to Hurley and O' Sulljvan (1999), \"Capacity to give informed consent is a fluid concept and varies with each individual and proposed procedure\" (p.",
        "sourceHint": "According to Hurley and O' Sulljvan (1999), \"Capacity to give informed consent is a fluid concept and varies with each individual and proposed procedure\" (p."
      },
      {
        "term": "confidential ity",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "ethical codes of behavio r",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "neg ligence",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "conflict of interest",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "ethics",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "risk-ben efit analysis",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "countercontrol",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "fraudulent conduct",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "E. Ethics",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Responsible conduct of behavior ana lysts",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Behavior analysts' responsibil ity to client s",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Assessing behavior",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Behavior analysts and the behavior-change program",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Behavior analysts as supervisors",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Public statements",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "Behavior analysts and research",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "constraints, and social validity.",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      },
      {
        "term": "begin by defining ethics and discuss",
        "definition": "Definition not confidently extracted from the source PDF - please consult the chapter directly.",
        "needsReview": true
      }
    ],
    "procedures": [],
    "examples": [
      {
        "scenario": "For example, a behavior analyst who grew up watching her brother engage in self-injurious behavior (SIB) is now providing services to a child who exhibits similar SIB.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, a behavior analyst who grew up watching her brother engage in self-injurious behavior (SIB) is now providing services to a child who exhibits similar SIB."
      },
      {
        "scenario": "For example, a positive punishment procedure may functional educational model would effectively help this stuproduce an immediate reduction in behavior, but had a careful assessment of the function of the behavior been completed, a less intrusive intervention could have been used.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, a positive punishment procedure may functional educational model would effectively help this stuproduce an immediate reduction in behavior, but had a careful assessment of the function of the behavior been completed, a less intrusive intervention could have been used."
      },
      {
        "scenario": "For example, a behavior analyst may decline a highly tial conflict of interest, or even the appearance of a conflict.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, a behavior analyst may decline a highly tial conflict of interest, or even the appearance of a conflict."
      },
      {
        "scenario": "For example, confunctional analysis, motivating operations, and applications of the matching law have had profound implications for clinical and educational practice.",
        "application": "Example reproduced verbatim from the chapter.",
        "sourceHint": "For example, confunctional analysis, motivating operations, and applications of the matching law have had profound implications for clinical and educational practice."
      }
    ],
    "comparisons": [],
    "misconceptions": [],
    "examChecklist": [
      "Define \"informed consent\" from memory and match the source text."
    ],
    "quiz": [
      {
        "id": "Q1",
        "question": "Which term matches this definition (taken from the chapter)?\n\n\"According to Hurley and O' Sulljvan (1999), \"Capacity to give informed consent is a fluid concept and varies with each individual and proposed procedure\" (p.\"",
        "options": [
          {
            "label": "A",
            "text": "informed consent"
          },
          {
            "label": "B",
            "text": "Comp liance Code"
          },
          {
            "label": "C",
            "text": "d isciplinary standards"
          },
          {
            "label": "D",
            "text": "confidential ity"
          }
        ],
        "answer": "A",
        "explanation": "\"According to Hurley and O' Sulljvan (1999), \"Capacity to give informed consent is a fluid concept and varies with each individual and proposed procedure\" (p.\" is the chapter's own definition of informed consent.",
        "topic": "Key terms",
        "sourceHint": "According to Hurley and O' Sulljvan (1999), \"Capacity to give informed consent is a fluid concept and varies with each individual and proposed procedure\" (p."
      }
    ],
    "reviewPrompts": [
      "Define \"informed consent\" in your own words, then check against the chapter glossary.",
      "Restate this idea from the chapter in your own words: \"For the applied behavior analyst, ethics defines specific rules of conduct..\"",
      "Restate this idea from the chapter in your own words: \"Two approaches to ethics are termed the deontological or \"acts-oriented\" approach, which evaluates only the act itself, and the utilitarian or \"results-oriented\" approach, which looks at the results or consequences of the act.\"",
      "What is the single most important takeaway from \"Ethical and Professional Responsibilities of Applied Behavior Analysts\"? Defend your choice in 2-3 sentences."
    ],
    "recap": [
      "Continuous education and discussion about ethics and the contingencies that support analysis and assistance seeki ng are core features of an environment designed to maintain ethical behavior in an organization.."
    ],
    "needsReview": true,
    "reviewFlags": {
      "glossary": true,
      "procedures": true,
      "comparisons": true,
      "misconceptions": true
    }
  }
};
